import * as i0 from '@angular/core';
import { Injectable, Component, numberAttribute, Input, EventEmitter, booleanAttribute, forwardRef, Attribute, Output, ViewChild, ViewChildren, Directive, HostListener, NgModule, Self, ChangeDetectionStrategy, Optional, HostBinding, ContentChildren, input, effect, afterRenderEffect, computed, contentChild, viewChild, ElementRef, ContentChild, ViewEncapsulation, contentChildren, inject, signal, isDevMode } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule, NgControl, TouchedChangeEvent, StatusChangeEvent, ReactiveFormsModule } from '@angular/forms';
import * as i1$1 from '@angular/cdk/clipboard';
import { ClipboardModule } from '@angular/cdk/clipboard';
import * as i1$2 from '@angular/router';
import * as i1$3 from '@angular/cdk/a11y';
import * as i2$1 from '@angular/cdk/collections';
import { Subscription, merge, startWith, BehaviorSubject, filter, Subject, takeUntil, switchMap, of, timer, combineLatest, firstValueFrom, map, debounceTime, pairwise, EMPTY } from 'rxjs';
import * as i1$6 from '@angular/cdk/listbox';
import { CdkOption, CdkListbox } from '@angular/cdk/listbox';
import * as i1$4 from '@angular/animations';
import { style, animate } from '@angular/animations';
import * as i1$5 from '@angular/cdk/overlay';
import { STANDARD_DROPDOWN_BELOW_POSITIONS } from '@angular/cdk/overlay';
import { DomPortal } from '@angular/cdk/portal';
import { toObservable, toSignal, takeUntilDestroyed } from '@angular/core/rxjs-interop';
function NeoIconComponent__svg_path_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "path", 2);
  }
  if (rf & 2) {
    const iconPath_r1 = ctx.$implicit;
    i0.ɵɵattribute("d", iconPath_r1);
  }
}
const _c0 = ["*"];
const _c1 = (a0, a1) => ({
  borderless: a0,
  empty: a1
});
function NeoButtonComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "neo-icon", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", ctx_r0.leftIcon);
  }
}
function NeoButtonComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "neo-icon", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", ctx_r0.rightIcon);
  }
}
function NeoButtonComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("visible", ctx_r0.isTooltipVisible);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.tooltipText);
  }
}
const _c2 = ["input"];
const _c3 = ["label"];
function NeoCheckboxComponent_neo_icon_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "neo-icon", 8);
  }
  if (rf & 2) {
    i0.ɵɵproperty("name", "neo-check")("size", 14);
  }
}
const _c4 = a0 => ({
  "with-button": a0
});
function NeoInputComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "neo-button", 3);
    i0.ɵɵlistener("click", function NeoInputComponent_ng_container_2_Template_neo_button_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.isHidden = !ctx_r1.isHidden);
    });
    i0.ɵɵelement(2, "neo-icon", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassMap("neo-icon-button");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", ctx_r1.isHidden ? "neo-eye" : "neo-eye-off")("size", 20)("ngClass", i0.ɵɵpureFunction1(5, _c4, ctx_r1.masked && ctx_r1.copy));
  }
}
function NeoInputComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "neo-button", 5);
    i0.ɵɵlistener("click", function NeoInputComponent_ng_container_3_Template_neo_button_click_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.copyToClipboard());
    });
    i0.ɵɵelement(2, "neo-icon", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassMap("neo-icon-button");
    i0.ɵɵproperty("tooltipText", ctx_r1.isCopied ? "Copied" : "Copy to clipboard");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "neo-copy-06")("size", 20);
  }
}
const _c5 = (a0, a1, a2) => ({
  "toggle-on": a0,
  "toggle-off": a1,
  disabled: a2
});
const _c6 = ["inputField"];
function NeoInputCodeComponent_ng_container_0_input_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 4, 0);
    i0.ɵɵlistener("paste", function NeoInputCodeComponent_ng_container_0_input_1_Template_input_paste_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.pasteValue($event));
    })("keydown.backspace", function NeoInputCodeComponent_ng_container_0_input_1_Template_input_keydown_backspace_0_listener() {
      const j_r3 = i0.ɵɵrestoreView(_r1).index;
      const i_r4 = i0.ɵɵnextContext().index;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.clearFieldAndBacktrack(ctx_r1.cumulativeLengths[i_r4] + j_r3));
    })("ngModelChange", function NeoInputCodeComponent_ng_container_0_input_1_Template_input_ngModelChange_0_listener($event) {
      const j_r3 = i0.ɵɵrestoreView(_r1).index;
      const i_r4 = i0.ɵɵnextContext().index;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.writeAndMoveToNext($event, ctx_r1.cumulativeLengths[i_r4] + j_r3));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const j_r3 = ctx.index;
    const i_r4 = i0.ɵɵnextContext().index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngModel", ctx_r1.displayInputs[ctx_r1.cumulativeLengths[i_r4] + j_r3])("placeholder", ctx_r1.placeholders[ctx_r1.cumulativeLengths[i_r4] + j_r3] || "0");
  }
}
function NeoInputCodeComponent_ng_container_0_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtext(1, "-");
    i0.ɵɵelementEnd();
  }
}
function NeoInputCodeComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NeoInputCodeComponent_ng_container_0_input_1_Template, 2, 2, "input", 2)(2, NeoInputCodeComponent_ng_container_0_span_2_Template, 2, 0, "span", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const template_r5 = ctx.$implicit;
    const isLast_r6 = ctx.last;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", template_r5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !isLast_r6);
  }
}
function NeoMenuComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(ctx_r0.style);
  }
}
const _c7 = (a0, a1, a2) => ({
  $implicit: a0,
  item: a1,
  isPanel: true,
  isOpen: a2,
  first: false,
  last: false
});
function NeoSelectButtonComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 0);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.placeholder);
  }
}
function NeoSelectButtonComponent_Conditional_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NeoSelectButtonComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NeoSelectButtonComponent_Conditional_1_ng_container_0_Template, 1, 0, "ng-container", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.selectItem().templateRef)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c7, ctx_r0.value, ctx_r0.value, ctx_r0.selectButton.isExpanded));
  }
}
function _forTrack0($index, $item) {
  return this.selectListbox.trackBy(this.getValue($item));
}
const _c8 = (a0, a1, a2, a3, a4, a5) => ({
  $implicit: a0,
  item: a1,
  isPanel: false,
  isSelected: a2,
  isActive: a3,
  first: a4,
  last: a5
});
function NeoSelectListboxComponent_div_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "neo-icon", 4);
  }
}
function NeoSelectListboxComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, NeoSelectListboxComponent_div_0_Conditional_3_Template, 1, 0, "neo-icon", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const isSelected_r2 = ctx.isSelected;
    const isPanel_r3 = ctx.isPanel;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.getLabel(item_r1));
    i0.ɵɵadvance();
    i0.ɵɵconditional(!isPanel_r3 && isSelected_r2 ? 3 : -1);
  }
}
function NeoSelectListboxComponent_Conditional_2_For_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NeoSelectListboxComponent_Conditional_2_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 6, 0);
    i0.ɵɵtemplate(2, NeoSelectListboxComponent_Conditional_2_For_1_ng_container_2_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r5 = ctx.$implicit;
    const ɵ$index_14_r6 = ctx.$index;
    const ɵ$count_14_r7 = ctx.$count;
    const option_r8 = i0.ɵɵreference(1);
    const selectItemDirective_r9 = i0.ɵɵnextContext();
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("default-highlight", ctx_r3.useDefaultHighlights);
    i0.ɵɵproperty("neoSelectListboxItem", ctx_r3.getValue(item_r5));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", selectItemDirective_r9.templateRef)("ngTemplateOutletContext", i0.ɵɵpureFunction6(5, _c8, item_r5, item_r5, option_r8.isSelected(), option_r8.isActive(), ɵ$index_14_r6 === 0, ɵ$index_14_r6 === ɵ$count_14_r7 - 1));
  }
}
function NeoSelectListboxComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, NeoSelectListboxComponent_Conditional_2_For_1_Template, 3, 12, "li", 5, _forTrack0, true);
  }
  if (rf & 2) {
    i0.ɵɵrepeater(ctx.neoSelectItemOf());
  }
}
function NeoSelectComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 4);
    i0.ɵɵelement(1, "neo-icon", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const selectButton_r1 = i0.ɵɵreference(1);
    i0.ɵɵclassProp("select-button-arrow-inverted", selectButton_r1.selectButton.isExpanded);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "neo-chevron-down")("size", 20);
  }
}
const _c9 = ["neoButton", ""];
const _c10 = [[["neo-icon", 3, "iconPositionEnd", ""]], "*", [["neo-icon", "iconPositionEnd", ""]]];
const _c11 = ["neo-icon:not([iconPositionEnd])", "*", "neo-icon[iconPositionEnd]"];
function NeoButton_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵelement(1, "neo-loader", 2);
    i0.ɵɵelementEnd();
  }
}
const _c12 = [[["label"]], "*", [["", "neoFormFieldHint", ""]], [["", "neoValidationMessage", ""]]];
const _c13 = ["label", "*", "[neoFormFieldHint]", "[neoValidationMessage]"];
function FormFieldComponent_Conditional_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵprojection(1, 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("hidden", ctx_r0.isControlInvalidVisible());
  }
}
function FormFieldComponent_Conditional_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 6);
    i0.ɵɵelement(2, "path", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵprojection(4, 3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("hidden", !ctx_r0.isControlInvalidVisible());
  }
}
function FormFieldComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, FormFieldComponent_Conditional_4_Conditional_1_Template, 2, 1, "div", 3)(2, FormFieldComponent_Conditional_4_Conditional_2_Template, 5, 2, "div", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.hint() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.validationMessage() ? 2 : -1);
  }
}
const _c14 = ["neoInput", ""];
class NeoUiService {
  static {
    this.ɵfac = function NeoUiService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoUiService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: NeoUiService,
      factory: NeoUiService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoUiService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class NeoUiComponent {
  static {
    this.ɵfac = function NeoUiComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoUiComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NeoUiComponent,
      selectors: [["neo-ui"]],
      decls: 2,
      vars: 0,
      template: function NeoUiComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "p");
          i0.ɵɵtext(1, "neo-ui works!");
          i0.ɵɵelementEnd();
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoUiComponent, [{
    type: Component,
    args: [{
      selector: 'neo-ui',
      template: ` <p>neo-ui works!</p> `
    }]
  }], null, null);
})();
const iconSet = {
  // general
  'neo-activity': ['M22 12H18L15 21L9 3L6 12H2'],
  'neo-archive': ['M3 5.9966C2.83599 5.99236 2.7169 5.98287 2.60982 5.96157C1.81644 5.80376 1.19624 5.18356 1.03843 4.39018C1 4.19698 1 3.96466 1 3.5C1 3.03534 1 2.80302 1.03843 2.60982C1.19624 1.81644 1.81644 1.19624 2.60982 1.03843C2.80302 1 3.03534 1 3.5 1H18.5C18.9647 1 19.197 1 19.3902 1.03843C20.1836 1.19624 20.8038 1.81644 20.9616 2.60982C21 2.80302 21 3.03534 21 3.5C21 3.96466 21 4.19698 20.9616 4.39018C20.8038 5.18356 20.1836 5.80376 19.3902 5.96157C19.2831 5.98287 19.164 5.99236 19 5.9966M9 11H13M3 6H19V14.2C19 15.8802 19 16.7202 18.673 17.362C18.3854 17.9265 17.9265 18.3854 17.362 18.673C16.7202 19 15.8802 19 14.2 19H7.8C6.11984 19 5.27976 19 4.63803 18.673C4.07354 18.3854 3.6146 17.9265 3.32698 17.362C3 16.7202 3 15.8802 3 14.2V6Z'],
  'neo-building-07': ['M7.5 11H4.6C4.03995 11 3.75992 11 3.54601 11.109C3.35785 11.2049 3.20487 11.3578 3.10899 11.546C3 11.7599 3 12.0399 3 12.6V21M16.5 11H19.4C19.9601 11 20.2401 11 20.454 11.109C20.6422 11.2049 20.7951 11.3578 20.891 11.546C21 11.7599 21 12.0399 21 12.6V21M16.5 21V6.2C16.5 5.0799 16.5 4.51984 16.282 4.09202C16.0903 3.71569 15.7843 3.40973 15.408 3.21799C14.9802 3 14.4201 3 13.3 3H10.7C9.57989 3 9.01984 3 8.59202 3.21799C8.21569 3.40973 7.90973 3.71569 7.71799 4.09202C7.5 4.51984 7.5 5.0799 7.5 6.2V21M22 21H2M11 7H13M11 11H13M11 15H13'],
  'neo-check': ['M20 6L9 17L4 12'],
  'neo-check-circle': ['M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z'],
  'neo-copy-04': ['M12 12V14.1C12 14.9401 12 15.3601 11.8365 15.681C11.6927 15.9632 11.4632 16.1927 11.181 16.3365C10.8601 16.5 10.4401 16.5 9.6 16.5H3.9C3.05992 16.5 2.63988 16.5 2.31901 16.3365C2.03677 16.1927 1.8073 15.9632 1.66349 15.681C1.5 15.3601 1.5 14.9401 1.5 14.1V8.4C1.5 7.55992 1.5 7.13988 1.66349 6.81901C1.8073 6.53677 2.03677 6.3073 2.31901 6.16349C2.63988 6 3.05992 6 3.9 6H6M8.4 12H14.1C14.9401 12 15.3601 12 15.681 11.8365C15.9632 11.6927 16.1927 11.4632 16.3365 11.181C16.5 10.8601 16.5 10.4401 16.5 9.6V3.9C16.5 3.05992 16.5 2.63988 16.3365 2.31901C16.1927 2.03677 15.9632 1.8073 15.681 1.66349C15.3601 1.5 14.9401 1.5 14.1 1.5H8.4C7.55992 1.5 7.13988 1.5 6.81901 1.66349C6.53677 1.8073 6.3073 2.03677 6.16349 2.31901C6 2.63988 6 3.05992 6 3.9V9.6C6 10.4401 6 10.8601 6.16349 11.181C6.3073 11.4632 6.53677 11.6927 6.81901 11.8365C7.13988 12 7.55992 12 8.4 12Z'],
  'neo-copy-06': ['M7.5 3H14.6C16.8402 3 17.9603 3 18.816 3.43597C19.5686 3.81947 20.1805 4.43139 20.564 5.18404C21 6.03969 21 7.15979 21 9.4V16.5M6.2 21H14.3C15.4201 21 15.9802 21 16.408 20.782C16.7843 20.5903 17.0903 20.2843 17.282 19.908C17.5 19.4802 17.5 18.9201 17.5 17.8V9.7C17.5 8.57989 17.5 8.01984 17.282 7.59202C17.0903 7.21569 16.7843 6.90973 16.408 6.71799C15.9802 6.5 15.4201 6.5 14.3 6.5H6.2C5.0799 6.5 4.51984 6.5 4.09202 6.71799C3.71569 6.90973 3.40973 7.21569 3.21799 7.59202C3 8.01984 3 8.57989 3 9.7V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.0799 21 6.2 21Z'],
  'neo-download-cloud-01': ['M4 16.2422C2.79401 15.435 2 14.0602 2 12.5C2 10.1564 3.79151 8.23129 6.07974 8.01937C6.54781 5.17213 9.02024 3 12 3C14.9798 3 17.4522 5.17213 17.9203 8.01937C20.2085 8.23129 22 10.1564 22 12.5C22 14.0602 21.206 15.435 20 16.2422M8 17L12 21M12 21L16 17M12 21V12'],
  'neo-download-cloud-02': ['M8 17L12 21M12 21L16 17M12 21V12M20 16.7428C21.2215 15.734 22 14.2079 22 12.5C22 9.46243 19.5376 7 16.5 7C16.2815 7 16.0771 6.886 15.9661 6.69774C14.6621 4.48484 12.2544 3 9.5 3C5.35786 3 2 6.35786 2 10.5C2 12.5661 2.83545 14.4371 4.18695 15.7935'],
  'neo-eye': ['M2.42012 12.7132C2.28394 12.4975 2.21584 12.3897 2.17772 12.2234C2.14909 12.0985 2.14909 11.9015 2.17772 11.7766C2.21584 11.6103 2.28394 11.5025 2.42012 11.2868C3.54553 9.50484 6.8954 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7766C21.8517 11.9015 21.8517 12.0985 21.8231 12.2234C21.785 12.3897 21.7169 12.4975 21.5807 12.7132C20.4553 14.4952 17.1054 19 12.0004 19C6.8954 19 3.54553 14.4952 2.42012 12.7132Z', 'M12.0004 15C13.6573 15 15.0004 13.6569 15.0004 12C15.0004 10.3431 13.6573 9 12.0004 9C10.3435 9 9.0004 10.3431 9.0004 12C9.0004 13.6569 10.3435 15 12.0004 15Z'],
  'neo-eye-off': ['M10.7429 5.09232C11.1494 5.03223 11.5686 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7767C21.8518 11.9016 21.8517 12.0987 21.8231 12.2236C21.7849 12.3899 21.7164 12.4985 21.5792 12.7156C21.2793 13.1901 20.8222 13.8571 20.2165 14.5805M6.72432 6.71504C4.56225 8.1817 3.09445 10.2194 2.42111 11.2853C2.28428 11.5019 2.21587 11.6102 2.17774 11.7765C2.1491 11.9014 2.14909 12.0984 2.17771 12.2234C2.21583 12.3897 2.28393 12.4975 2.42013 12.7132C3.54554 14.4952 6.89541 19 12.0004 19C14.0588 19 15.8319 18.2676 17.2888 17.2766M3.00042 3L21.0004 21M9.8791 9.87868C9.3362 10.4216 9.00042 11.1716 9.00042 12C9.00042 13.6569 10.3436 15 12.0004 15C12.8288 15 13.5788 14.6642 14.1217 14.1213'],
  'neo-file-04': ['M14 2.26946V6.4C14 6.96005 14 7.24008 14.109 7.45399C14.2049 7.64215 14.3578 7.79513 14.546 7.89101C14.7599 8 15.0399 8 15.6 8H19.7305M20 9.98822V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V6.8C4 5.11984 4 4.27976 4.32698 3.63803C4.6146 3.07354 5.07354 2.6146 5.63803 2.32698C6.27976 2 7.11984 2 8.8 2H12.0118C12.7455 2 13.1124 2 13.4577 2.08289C13.7638 2.15638 14.0564 2.27759 14.3249 2.44208C14.6276 2.6276 14.887 2.88703 15.4059 3.40589L18.5941 6.59411C19.113 7.11297 19.3724 7.3724 19.5579 7.67515C19.7224 7.94356 19.8436 8.2362 19.9171 8.5423C20 8.88757 20 9.25445 20 9.98822Z'],
  'neo-plus': ['M12 5V19M5 12H19'],
  'neo-plus-circle': ['M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z'],
  'neo-minus-circle': ['M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z'],
  'neo-settings': ['M11 14C12.6569 14 14 12.6569 14 11C14 9.34315 12.6569 8 11 8C9.34315 8 8 9.34315 8 11C8 12.6569 9.34315 14 11 14Z', 'M17.7273 13.7273C17.6063 14.0015 17.5702 14.3056 17.6236 14.6005C17.6771 14.8954 17.8177 15.1676 18.0273 15.3818L18.0818 15.4364C18.2509 15.6052 18.385 15.8057 18.4765 16.0265C18.568 16.2472 18.6151 16.4838 18.6151 16.7227C18.6151 16.9617 18.568 17.1983 18.4765 17.419C18.385 17.6397 18.2509 17.8402 18.0818 18.0091C17.913 18.1781 17.7124 18.3122 17.4917 18.4037C17.271 18.4952 17.0344 18.5423 16.7955 18.5423C16.5565 18.5423 16.3199 18.4952 16.0992 18.4037C15.8785 18.3122 15.678 18.1781 15.5091 18.0091L15.4545 17.9545C15.2403 17.745 14.9682 17.6044 14.6733 17.5509C14.3784 17.4974 14.0742 17.5335 13.8 17.6545C13.5311 17.7698 13.3018 17.9611 13.1403 18.205C12.9788 18.4489 12.8921 18.7347 12.8909 19.0273V19.1818C12.8909 19.664 12.6994 20.1265 12.3584 20.4675C12.0174 20.8084 11.5549 21 11.0727 21C10.5905 21 10.1281 20.8084 9.78708 20.4675C9.4461 20.1265 9.25455 19.664 9.25455 19.1818V19.1C9.24751 18.7991 9.15011 18.5073 8.97501 18.2625C8.79991 18.0176 8.55521 17.8312 8.27273 17.7273C7.99853 17.6063 7.69437 17.5702 7.39947 17.6236C7.10456 17.6771 6.83244 17.8177 6.61818 18.0273L6.56364 18.0818C6.39478 18.2509 6.19425 18.385 5.97353 18.4765C5.7528 18.568 5.51621 18.6151 5.27727 18.6151C5.03834 18.6151 4.80174 18.568 4.58102 18.4765C4.36029 18.385 4.15977 18.2509 3.99091 18.0818C3.82186 17.913 3.68775 17.7124 3.59626 17.4917C3.50476 17.271 3.45766 17.0344 3.45766 16.7955C3.45766 16.5565 3.50476 16.3199 3.59626 16.0992C3.68775 15.8785 3.82186 15.678 3.99091 15.5091L4.04545 15.4545C4.25503 15.2403 4.39562 14.9682 4.4491 14.6733C4.50257 14.3784 4.46647 14.0742 4.34545 13.8C4.23022 13.5311 4.03887 13.3018 3.79497 13.1403C3.55107 12.9788 3.26526 12.8921 2.97273 12.8909H2.81818C2.33597 12.8909 1.87351 12.6994 1.53253 12.3584C1.19156 12.0174 1 11.5549 1 11.0727C1 10.5905 1.19156 10.1281 1.53253 9.78708C1.87351 9.4461 2.33597 9.25455 2.81818 9.25455H2.9C3.2009 9.24751 3.49273 9.15011 3.73754 8.97501C3.98236 8.79991 4.16883 8.55521 4.27273 8.27273C4.39374 7.99853 4.42984 7.69437 4.37637 7.39947C4.3229 7.10456 4.18231 6.83244 3.97273 6.61818L3.91818 6.56364C3.74913 6.39478 3.61503 6.19425 3.52353 5.97353C3.43203 5.7528 3.38493 5.51621 3.38493 5.27727C3.38493 5.03834 3.43203 4.80174 3.52353 4.58102C3.61503 4.36029 3.74913 4.15977 3.91818 3.99091C4.08704 3.82186 4.28757 3.68775 4.50829 3.59626C4.72901 3.50476 4.96561 3.45766 5.20455 3.45766C5.44348 3.45766 5.68008 3.50476 5.9008 3.59626C6.12152 3.68775 6.32205 3.82186 6.49091 3.99091L6.54545 4.04545C6.75971 4.25503 7.03183 4.39562 7.32674 4.4491C7.62164 4.50257 7.9258 4.46647 8.2 4.34545H8.27273C8.54161 4.23022 8.77093 4.03887 8.93245 3.79497C9.09397 3.55107 9.18065 3.26526 9.18182 2.97273V2.81818C9.18182 2.33597 9.37338 1.87351 9.71435 1.53253C10.0553 1.19156 10.5178 1 11 1C11.4822 1 11.9447 1.19156 12.2856 1.53253C12.6266 1.87351 12.8182 2.33597 12.8182 2.81818V2.9C12.8193 3.19253 12.906 3.47834 13.0676 3.72224C13.2291 3.96614 13.4584 4.15749 13.7273 4.27273C14.0015 4.39374 14.3056 4.42984 14.6005 4.37637C14.8954 4.3229 15.1676 4.18231 15.3818 3.97273L15.4364 3.91818C15.6052 3.74913 15.8057 3.61503 16.0265 3.52353C16.2472 3.43203 16.4838 3.38493 16.7227 3.38493C16.9617 3.38493 17.1983 3.43203 17.419 3.52353C17.6397 3.61503 17.8402 3.74913 18.0091 3.91818C18.1781 4.08704 18.3122 4.28757 18.4037 4.50829C18.4952 4.72901 18.5423 4.96561 18.5423 5.20455C18.5423 5.44348 18.4952 5.68008 18.4037 5.9008C18.3122 6.12152 18.1781 6.32205 18.0091 6.49091L17.9545 6.54545C17.745 6.75971 17.6044 7.03183 17.5509 7.32674C17.4974 7.62164 17.5335 7.9258 17.6545 8.2V8.27273C17.7698 8.54161 17.9611 8.77093 18.205 8.93245C18.4489 9.09397 18.7347 9.18065 19.0273 9.18182H19.1818C19.664 9.18182 20.1265 9.37338 20.4675 9.71435C20.8084 10.0553 21 10.5178 21 11C21 11.4822 20.8084 11.9447 20.4675 12.2856C20.1265 12.6266 19.664 12.8182 19.1818 12.8182H19.1C18.8075 12.8193 18.5217 12.906 18.2778 13.0676C18.0339 13.2291 17.8425 13.4584 17.7273 13.7273Z'],
  'neo-trash-01': ['M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M10 11.5V16.5M14 11.5V16.5M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6'],
  'neo-upload-cloud-02': ['M8 16L12 12M12 12L16 16M12 12V21M20 16.7428C21.2215 15.734 22 14.2079 22 12.5C22 9.46243 19.5376 7 16.5 7C16.2815 7 16.0771 6.886 15.9661 6.69774C14.6621 4.48484 12.2544 3 9.5 3C5.35786 3 2 6.35786 2 10.5C2 12.5661 2.83545 14.4371 4.18695 15.7935'],
  'neo-log-out-01': ['M14 15L19 10M19 10L14 5M19 10H7M7 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V14.2C1 15.8802 1 16.7202 1.32698 17.362C1.6146 17.9265 2.07354 18.3854 2.63803 18.673C3.27976 19 4.11984 19 5.8 19H7'],
  'neo-x-close': ['M18 6L6 18M6 6L18 18'],
  // arrows
  'neo-arrow-left': ['M19 12H5M5 12L12 19M5 12L12 5'],
  'neo-arrow-right': ['M5 12H19M19 12L12 5M19 12L12 19'],
  'neo-chevron-down': ['M6 9L12 15L18 9'],
  // communication
  'neo-mail-01': ['M2 7L10.1649 12.7154C10.8261 13.1783 11.1567 13.4097 11.5163 13.4993C11.8339 13.5785 12.1661 13.5785 12.4837 13.4993C12.8433 13.4097 13.1739 13.1783 13.8351 12.7154L22 7M6.8 20H17.2C18.8802 20 19.7202 20 20.362 19.673C20.9265 19.3854 21.3854 18.9265 21.673 18.362C22 17.7202 22 16.8802 22 15.2V8.8C22 7.11984 22 6.27976 21.673 5.63803C21.3854 5.07354 20.9265 4.6146 20.362 4.32698C19.7202 4 18.8802 4 17.2 4H6.8C5.11984 4 4.27976 4 3.63803 4.32698C3.07354 4.6146 2.6146 5.07354 2.32698 5.63803C2 6.27976 2 7.11984 2 8.8V15.2C2 16.8802 2 17.7202 2.32698 18.362C2.6146 18.9265 3.07354 19.3854 3.63803 19.673C4.27976 20 5.11984 20 6.8 20Z'],
  // users
  'neo-user-circle': ['M5.3163 19.4384C5.92462 18.0052 7.34492 17 9 17H15C16.6551 17 18.0754 18.0052 18.6837 19.4384M16 9.5C16 11.7091 14.2091 13.5 12 13.5C9.79086 13.5 8 11.7091 8 9.5C8 7.29086 9.79086 5.5 12 5.5C14.2091 5.5 16 7.29086 16 9.5ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z'],
  'neo-user-plus-01': ['M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M19 21V15M16 18H22M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z'],
  'neo-user-01': ['M20 21C20 19.6044 20 18.9067 19.8278 18.3389C19.44 17.0605 18.4395 16.06 17.1611 15.6722C16.5933 15.5 15.8956 15.5 14.5 15.5H9.5C8.10444 15.5 7.40665 15.5 6.83886 15.6722C5.56045 16.06 4.56004 17.0605 4.17224 18.3389C4 18.9067 4 19.6044 4 21M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z'],
  'neo-folder-plus': ['M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7ZM12 17V11M9 14H15'],
  // time
  'neo-clock': ['M12 6V12L16 14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z'],
  // informative
  'neo-alert-triangle': ['M11.9998 8.99999V13M11.9998 17H12.0098M10.6151 3.89171L2.39019 18.0983C1.93398 18.8863 1.70588 19.2803 1.73959 19.6037C1.769 19.8857 1.91677 20.142 2.14613 20.3088C2.40908 20.5 2.86435 20.5 3.77487 20.5H20.2246C21.1352 20.5 21.5904 20.5 21.8534 20.3088C22.0827 20.142 22.2305 19.8857 22.2599 19.6037C22.2936 19.2803 22.0655 18.8863 21.6093 18.0983L13.3844 3.89171C12.9299 3.10654 12.7026 2.71396 12.4061 2.58211C12.1474 2.4671 11.8521 2.4671 11.5935 2.58211C11.2969 2.71396 11.0696 3.10655 10.6151 3.89171Z'],
  'neo-refresh-ccw-01': ['M2 10C2 10 4.00498 7.26822 5.63384 5.63824C7.26269 4.00827 9.5136 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.89691 21 4.43511 18.2543 3.35177 14.5M2 10V4M2 10H8'],
  'neo-download-02': ['M21 21H3M18 11L12 17M12 17L6 11M12 17V3'],
  'neo-pencil-01': ['M2.5 21.5001L8.04927 19.3657C8.40421 19.2292 8.58168 19.161 8.74772 19.0718C8.8952 18.9927 9.0358 18.9013 9.16804 18.7987C9.31692 18.6831 9.45137 18.5487 9.72028 18.2798L21 7.00006C22.1046 5.89549 22.1046 4.10463 21 3.00006C19.8955 1.89549 18.1046 1.89549 17 3.00006L5.72028 14.2798C5.45138 14.5487 5.31692 14.6831 5.20139 14.832C5.09877 14.9643 5.0074 15.1049 4.92823 15.2523C4.83911 15.4184 4.77085 15.5959 4.63433 15.9508L2.5 21.5001ZM2.5 21.5001L4.55812 16.149C4.7054 15.7661 4.77903 15.5746 4.90534 15.4869C5.01572 15.4103 5.1523 15.3813 5.2843 15.4065C5.43533 15.4354 5.58038 15.5804 5.87048 15.8705L8.12957 18.1296C8.41967 18.4197 8.56472 18.5648 8.59356 18.7158C8.61877 18.8478 8.58979 18.9844 8.51314 19.0947C8.42545 19.2211 8.23399 19.2947 7.85107 19.442L2.5 21.5001Z'],
  'neo-coins-04': ['M10.101 4C11.3636 2.76281 13.0927 2 15 2C18.866 2 22 5.13401 22 9C22 10.9073 21.2372 12.6365 19.9999 13.899M7.5 13L9 12V17.5M7.5 17.5H10.5M16 15C16 18.866 12.866 22 9 22C5.13401 22 2 18.866 2 15C2 11.134 5.13401 8 9 8C12.866 8 16 11.134 16 15Z'],
  'neo-switch-horizontal-01': ['M20 17H4M4 17L8 13M4 17L8 21M4 7H20M20 7L16 3M20 7L16 11'],
  'neo-fingerprint-04': ['M5.80688 18.5304C5.82459 18.5005 5.84273 18.4709 5.8613 18.4413C7.2158 16.2881 7.99991 13.7418 7.99991 11C7.99991 8.79086 9.79077 7 11.9999 7C14.209 7 15.9999 8.79086 15.9999 11C15.9999 12.017 15.9307 13.0186 15.7966 14M13.6792 20.8436C14.2909 19.6226 14.7924 18.3369 15.1707 17M19.0097 18.132C19.6547 15.8657 20 13.4732 20 11C20 6.58172 16.4183 3 12 3C10.5429 3 9.17669 3.38958 8 4.07026M3 15.3641C3.64066 14.0454 4 12.5646 4 11C4 9.54285 4.38958 8.17669 5.07026 7M11.9999 11C11.9999 14.5172 10.9911 17.7988 9.24707 20.5712']
};
class NeoIconComponent {
  constructor() {
    this.size = 16;
    this.name = '';
    this.iconPaths = [];
  }
  ngOnInit() {
    this.iconPaths = iconSet[this.name];
  }
  ngOnChanges(changes) {
    if (changes['name']?.currentValue) {
      this.name = changes['name'].currentValue;
    }
    if (changes['size']?.currentValue) {
      this.size = changes['size'].currentValue;
    }
    this.ngOnInit();
  }
  static {
    this.ɵfac = function NeoIconComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoIconComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NeoIconComponent,
      selectors: [["neo-icon"]],
      inputs: {
        size: [2, "size", "size", numberAttribute],
        name: "name"
      },
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵNgOnChangesFeature],
      decls: 2,
      vars: 4,
      consts: [["fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["stroke-width", "2", "stroke-linecap", "round", "stroke-linejoin", "round", 4, "ngFor", "ngForOf"], ["stroke-width", "2", "stroke-linecap", "round", "stroke-linejoin", "round"]],
      template: function NeoIconComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵnamespaceSVG();
          i0.ɵɵelementStart(0, "svg", 0);
          i0.ɵɵtemplate(1, NeoIconComponent__svg_path_1_Template, 1, 1, "path", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵattribute("width", ctx.size)("height", ctx.size)("viewBox", "0 0 24 24");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.iconPaths);
        }
      },
      dependencies: [CommonModule, i1.NgForOf],
      styles: ["[_nghost-%COMP%]{display:flex}svg[_ngcontent-%COMP%]{stroke:currentColor}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoIconComponent, [{
    type: Component,
    args: [{
      selector: 'neo-icon',
      imports: [CommonModule],
      template: "<svg\n    [attr.width]=\"this.size\"\n    [attr.height]=\"this.size\"\n    [attr.viewBox]=\"'0 0 24 24'\"\n    fill=\"none\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n>\n    <path\n        *ngFor=\"let iconPath of iconPaths\"\n        [attr.d]=\"iconPath\"\n        stroke-width=\"2\"\n        stroke-linecap=\"round\"\n        stroke-linejoin=\"round\"\n    />\n</svg>\n",
      styles: [":host{display:flex}svg{stroke:currentColor}\n"]
    }]
  }], null, {
    size: [{
      type: Input,
      args: [{
        transform: numberAttribute
      }]
    }],
    name: [{
      type: Input
    }]
  });
})();

/**
 * @deprecated Superseded my NeoButton. Use only if you need old styles.
 */
class NeoButtonComponent {
  constructor() {
    this.disabled = false;
    this.class = 'green-fill';
    this.size = 'medium';
    this.leftIcon = '';
    this.rightIcon = '';
    this.isTooltipVisible = false;
  }
  toggleTooltip() {
    this.isTooltipVisible = !this.isTooltipVisible;
  }
  static {
    this.ɵfac = function NeoButtonComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoButtonComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NeoButtonComponent,
      selectors: [["neo-button"]],
      inputs: {
        disabled: "disabled",
        class: "class",
        size: "size",
        leftIcon: "leftIcon",
        rightIcon: "rightIcon",
        type: "type",
        tooltipText: "tooltipText"
      },
      ngContentSelectors: _c0,
      decls: 5,
      vars: 13,
      consts: [[3, "mouseenter", "mouseleave", "disabled", "ngClass"], [4, "ngIf"], ["class", "tooltip", 3, "visible", 4, "ngIf"], [3, "name"], [1, "tooltip"]],
      template: function NeoButtonComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "button", 0);
          i0.ɵɵlistener("mouseenter", function NeoButtonComponent_Template_button_mouseenter_0_listener() {
            return ctx.toggleTooltip();
          })("mouseleave", function NeoButtonComponent_Template_button_mouseleave_0_listener() {
            return ctx.toggleTooltip();
          });
          i0.ɵɵtemplate(1, NeoButtonComponent_ng_container_1_Template, 2, 1, "ng-container", 1);
          i0.ɵɵprojection(2);
          i0.ɵɵtemplate(3, NeoButtonComponent_ng_container_3_Template, 2, 1, "ng-container", 1)(4, NeoButtonComponent_div_4_Template, 2, 3, "div", 2);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassMapInterpolate2("neo-button ", ctx.class, " ", ctx.size, "");
          i0.ɵɵproperty("disabled", ctx.disabled)("ngClass", i0.ɵɵpureFunction2(10, _c1, ctx.class.includes("borderless"), ctx.class.includes("empty")));
          i0.ɵɵattribute("type", ctx.type);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.leftIcon !== "");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.rightIcon !== "");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.tooltipText);
        }
      },
      dependencies: [CommonModule, i1.NgClass, i1.NgIf, NeoIconComponent],
      styles: ["[_nghost-%COMP%]{display:flex;width:fit-content}.small[_ngcontent-%COMP%]{--padding: 0 10px;--height: 28px;--fontSize: 12px}.medium[_ngcontent-%COMP%]{--padding: 8px 8px;--height: 36px;--fontSize: 14px}.large[_ngcontent-%COMP%]{--padding: 10px 16px;--height: 40px;--fontSize: 14px}.xlarge[_ngcontent-%COMP%]{--padding: 10px 18px;--height: 44px;--fontSize: 16px}.mobile[_ngcontent-%COMP%]{--padding: 12px 20px;--height: 48px;--fontSize: 16px}.green-fill[_ngcontent-%COMP%]{--borderColorDefault: var(--theme-color-main);--backgroundColorDefault: var(--theme-color-main);--colorDefault: var(--theme-color-secondary);--borderColorHover: var(--theme-color-secondary);--backgroundColorHover: var(--theme-color-secondary);--colorHover: var(--theme-color-main);--boxShadowFocus: var(--neoBlue-200);--borderColorDisabled: var(--neoGreen-25);--backgroundColorDisabled: var(--neoGrayNeutral-50);--colorDisabled: var(--neoGreen-50)}.yellow-fill[_ngcontent-%COMP%]{--borderColorDefault: var(--theme-color-secondary);--backgroundColorDefault: var(--theme-color-secondary);--colorDefault: var(--theme-color-font);--borderColorHover: var(--theme-color-secondary);--backgroundColorHover: var(--neoYellow-25);--colorHover: var(--theme-color-font);--boxShadowFocus: var(--neoYellow-25);--borderColorDisabled: var(--neoGreen-25);--backgroundColorDisabled: var(--neoGrayNeutral-50);--colorDisabled: var(--neoGreen-50)}.red-fill[_ngcontent-%COMP%]{--borderColorDefault: var(--neoError-600);--backgroundColorDefault: var(--neoError-600);--colorDefault: var(--neoBase-white);--borderColorHover: var(--neoError-700);--backgroundColorHover: var(--neoError-700);--colorHover: var(--neoBase-white);--boxShadowFocus: var(--neoBase-white);--borderColorDisabled: var(--neoError-200);--backgroundColorDisabled: var(--neoError-200);--colorDisabled: var(--neoBase-white)}.white-empty[_ngcontent-%COMP%]{--borderColorDefault: var(--neoGrayNeutral-300);--backgroundColorDefault: var(--neoBase-white);--colorDefault: var(--theme-color-font);--borderColorHover: var(--neoGrayNeutral-300);--backgroundColorHover: var(--neoGrayNeutral-50);--colorHover: var(--theme-color-font);--boxShadowFocus: var(--neoBlue-600);--borderColorDisabled: var(--neoGreen-25);--backgroundColorDisabled: var(--neoGrayNeutral-50);--colorDisabled: var(--neoGreen-50)}.red-empty[_ngcontent-%COMP%]{--borderColorDefault: var(--neoError-300);--backgroundColorDefault: var(--neoBase-white);--colorDefault: var(--neoError-700);--borderColorHover: var(--neoError-300);--backgroundColorHover: var(--neoError-50);--colorHover: var(--neoError-800);--boxShadowFocus: var(--neoError-300);--borderColorDisabled: var(--neoError-200);--backgroundColorDisabled: var(--neoBase-white);--colorDisabled: var(--neoError-300)}.white-borderless[_ngcontent-%COMP%]{--borderColorDefault: transparent;--backgroundColorDefault: transparent;--colorDefault: var(--theme-color-font);--borderColorHover: transparent;--backgroundColorHover: var(--neoGrayNeutral-100);--colorHover: var(--theme-color-font);--boxShadowFocus: transparent;--borderColorDisabled: transparent;--backgroundColorDisabled: transparent;--colorDisabled: var(--neoGrayNeutral-300)}.red-borderless[_ngcontent-%COMP%]{--borderColorDefault: transparent;--backgroundColorDefault: transparent;--colorDefault: var(--neoError-700);--borderColorHover: transparent;--backgroundColorHover: var(--neoError-50);--colorHover: var(--neoError-800);--boxShadowFocus: transparent;--borderColorDisabled: transparent;--backgroundColorDisabled: transparent;--colorDisabled: var(--neoError-300)}.neo-button[_ngcontent-%COMP%]{border:1px solid var(--borderColorDefault);background-color:var(--backgroundColorDefault);color:var(--colorDefault);border-radius:10px;display:flex;width:inherit;flex-direction:row;justify-content:center;align-items:center;padding:var(--padding);min-height:var(--height);cursor:pointer;font-size:var(--fontSize);font-family:Roobert,sans-serif;font-style:normal;font-weight:400;line-height:24px}.neo-button[_ngcontent-%COMP%]:hover{border:1px solid var(--borderColorHover);background-color:var(--backgroundColorHover);color:var(--colorHover)}.neo-button[_ngcontent-%COMP%]:focus-visible{outline:3px solid var(--neoBlue-main);outline-offset:-1px;box-shadow:0 0 0 3px var(--theme-color-main)}.neo-button[_ngcontent-%COMP%]:disabled{border:1px solid var(--borderColorDisabled);background-color:var(--backgroundColorDisabled);color:var(--colorDisabled);cursor:default}.tooltip[_ngcontent-%COMP%]{position:absolute;bottom:calc(100% + 5px);transform:translate(-50%);background-color:var(--neoBase-black);color:var(--neoBase-white);padding:5px 10px;border-radius:5px;opacity:0;transition:opacity .3s ease-in-out;pointer-events:none}.tooltip.visible[_ngcontent-%COMP%]{opacity:1}.borderless[_ngcontent-%COMP%]{text-decoration:underline;text-underline-offset:7px}.borderless[_ngcontent-%COMP%]:disabled{text-decoration:none}.borderless[_ngcontent-%COMP%]:focus-visible{border-color:var(--theme-color-main);outline-offset:0;box-shadow:none}.empty[_ngcontent-%COMP%]:focus-visible{border-color:var(--theme-color-main);outline-offset:0;box-shadow:none}.neo-icon-button[_ngcontent-%COMP%]{display:flex;border:none;background-color:transparent;align-items:center;cursor:pointer;border-radius:6px;width:inherit;flex-direction:row;justify-content:inherit;padding:var(--padding);height:var(--height)}.neo-icon-button[_ngcontent-%COMP%]:disabled{cursor:default}.neo-icon-button[_ngcontent-%COMP%]:focus-visible{outline:2px solid var(--neoBlue-main);outline-offset:1px;box-shadow:0 0 0 1px var(--theme-color-main)}.neo-icon-button[_ngcontent-%COMP%]:active{background-color:#0000001a;box-shadow:inset 0 2px 4px #0003}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoButtonComponent, [{
    type: Component,
    args: [{
      selector: 'neo-button',
      imports: [CommonModule, NeoIconComponent],
      template: "<button\n        [disabled]=\"disabled\"\n        [ngClass]=\"{\n        borderless: class.includes('borderless'),\n        empty: class.includes('empty')\n    }\"\n        class=\"neo-button {{ class }} {{ size }}\"\n        [attr.type]=\"type\"\n        (mouseenter)=\"toggleTooltip()\"\n        (mouseleave)=\"toggleTooltip()\"\n>\n    <ng-container *ngIf=\"leftIcon !== ''\">\n        <neo-icon [name]=\"leftIcon\"></neo-icon>\n    </ng-container>\n    <ng-content></ng-content>\n    <ng-container *ngIf=\"rightIcon !== ''\">\n        <neo-icon [name]=\"rightIcon\"></neo-icon>\n    </ng-container>\n    <div *ngIf=\"tooltipText\" class=\"tooltip\" [class.visible]=\"isTooltipVisible\">{{ tooltipText }}</div>\n</button>",
      styles: [":host{display:flex;width:fit-content}.small{--padding: 0 10px;--height: 28px;--fontSize: 12px}.medium{--padding: 8px 8px;--height: 36px;--fontSize: 14px}.large{--padding: 10px 16px;--height: 40px;--fontSize: 14px}.xlarge{--padding: 10px 18px;--height: 44px;--fontSize: 16px}.mobile{--padding: 12px 20px;--height: 48px;--fontSize: 16px}.green-fill{--borderColorDefault: var(--theme-color-main);--backgroundColorDefault: var(--theme-color-main);--colorDefault: var(--theme-color-secondary);--borderColorHover: var(--theme-color-secondary);--backgroundColorHover: var(--theme-color-secondary);--colorHover: var(--theme-color-main);--boxShadowFocus: var(--neoBlue-200);--borderColorDisabled: var(--neoGreen-25);--backgroundColorDisabled: var(--neoGrayNeutral-50);--colorDisabled: var(--neoGreen-50)}.yellow-fill{--borderColorDefault: var(--theme-color-secondary);--backgroundColorDefault: var(--theme-color-secondary);--colorDefault: var(--theme-color-font);--borderColorHover: var(--theme-color-secondary);--backgroundColorHover: var(--neoYellow-25);--colorHover: var(--theme-color-font);--boxShadowFocus: var(--neoYellow-25);--borderColorDisabled: var(--neoGreen-25);--backgroundColorDisabled: var(--neoGrayNeutral-50);--colorDisabled: var(--neoGreen-50)}.red-fill{--borderColorDefault: var(--neoError-600);--backgroundColorDefault: var(--neoError-600);--colorDefault: var(--neoBase-white);--borderColorHover: var(--neoError-700);--backgroundColorHover: var(--neoError-700);--colorHover: var(--neoBase-white);--boxShadowFocus: var(--neoBase-white);--borderColorDisabled: var(--neoError-200);--backgroundColorDisabled: var(--neoError-200);--colorDisabled: var(--neoBase-white)}.white-empty{--borderColorDefault: var(--neoGrayNeutral-300);--backgroundColorDefault: var(--neoBase-white);--colorDefault: var(--theme-color-font);--borderColorHover: var(--neoGrayNeutral-300);--backgroundColorHover: var(--neoGrayNeutral-50);--colorHover: var(--theme-color-font);--boxShadowFocus: var(--neoBlue-600);--borderColorDisabled: var(--neoGreen-25);--backgroundColorDisabled: var(--neoGrayNeutral-50);--colorDisabled: var(--neoGreen-50)}.red-empty{--borderColorDefault: var(--neoError-300);--backgroundColorDefault: var(--neoBase-white);--colorDefault: var(--neoError-700);--borderColorHover: var(--neoError-300);--backgroundColorHover: var(--neoError-50);--colorHover: var(--neoError-800);--boxShadowFocus: var(--neoError-300);--borderColorDisabled: var(--neoError-200);--backgroundColorDisabled: var(--neoBase-white);--colorDisabled: var(--neoError-300)}.white-borderless{--borderColorDefault: transparent;--backgroundColorDefault: transparent;--colorDefault: var(--theme-color-font);--borderColorHover: transparent;--backgroundColorHover: var(--neoGrayNeutral-100);--colorHover: var(--theme-color-font);--boxShadowFocus: transparent;--borderColorDisabled: transparent;--backgroundColorDisabled: transparent;--colorDisabled: var(--neoGrayNeutral-300)}.red-borderless{--borderColorDefault: transparent;--backgroundColorDefault: transparent;--colorDefault: var(--neoError-700);--borderColorHover: transparent;--backgroundColorHover: var(--neoError-50);--colorHover: var(--neoError-800);--boxShadowFocus: transparent;--borderColorDisabled: transparent;--backgroundColorDisabled: transparent;--colorDisabled: var(--neoError-300)}.neo-button{border:1px solid var(--borderColorDefault);background-color:var(--backgroundColorDefault);color:var(--colorDefault);border-radius:10px;display:flex;width:inherit;flex-direction:row;justify-content:center;align-items:center;padding:var(--padding);min-height:var(--height);cursor:pointer;font-size:var(--fontSize);font-family:Roobert,sans-serif;font-style:normal;font-weight:400;line-height:24px}.neo-button:hover{border:1px solid var(--borderColorHover);background-color:var(--backgroundColorHover);color:var(--colorHover)}.neo-button:focus-visible{outline:3px solid var(--neoBlue-main);outline-offset:-1px;box-shadow:0 0 0 3px var(--theme-color-main)}.neo-button:disabled{border:1px solid var(--borderColorDisabled);background-color:var(--backgroundColorDisabled);color:var(--colorDisabled);cursor:default}.tooltip{position:absolute;bottom:calc(100% + 5px);transform:translate(-50%);background-color:var(--neoBase-black);color:var(--neoBase-white);padding:5px 10px;border-radius:5px;opacity:0;transition:opacity .3s ease-in-out;pointer-events:none}.tooltip.visible{opacity:1}.borderless{text-decoration:underline;text-underline-offset:7px}.borderless:disabled{text-decoration:none}.borderless:focus-visible{border-color:var(--theme-color-main);outline-offset:0;box-shadow:none}.empty:focus-visible{border-color:var(--theme-color-main);outline-offset:0;box-shadow:none}.neo-icon-button{display:flex;border:none;background-color:transparent;align-items:center;cursor:pointer;border-radius:6px;width:inherit;flex-direction:row;justify-content:inherit;padding:var(--padding);height:var(--height)}.neo-icon-button:disabled{cursor:default}.neo-icon-button:focus-visible{outline:2px solid var(--neoBlue-main);outline-offset:1px;box-shadow:0 0 0 1px var(--theme-color-main)}.neo-icon-button:active{background-color:#0000001a;box-shadow:inset 0 2px 4px #0003}\n"]
    }]
  }], null, {
    disabled: [{
      type: Input
    }],
    class: [{
      type: Input
    }],
    size: [{
      type: Input
    }],
    leftIcon: [{
      type: Input
    }],
    rightIcon: [{
      type: Input
    }],
    type: [{
      type: Input
    }],
    tooltipText: [{
      type: Input
    }]
  });
})();

// The .ts part of this component is a simplified version of the angular material checkbox
class NeoCheckboxComponent {
  static {
    this.nextUniqueId = 0;
  }
  /** Focuses the checkbox. */
  focus() {
    this._inputElement.nativeElement.focus();
  }
  /** Returns the unique id for the visual hidden input. */
  get inputId() {
    return `${this.id || this._uniqueId}-input`;
  }
  constructor(_elementRef, _changeDetectorRef, tabIndex) {
    this._elementRef = _elementRef;
    this._changeDetectorRef = _changeDetectorRef;
    /**
     * Attached to the aria-label attribute of the host element. In most cases, aria-labelledby will
     * take precedence so this may be omitted.
     */
    this.ariaLabel = '';
    /**
     * Users can specify the `aria-labelledby` attribute which will be forwarded to the input element
     */
    this.ariaLabelledby = null;
    /** Name value will be applied to the input element if present */
    this.name = null;
    /** Event emitted when the checkbox's `checked` value changes. */
    this.checkedChange = new EventEmitter();
    /**
     * Called when the checkbox is blurred. Needed to properly implement ControlValueAccessor.
     * @docs-private
     */
    this._onTouched = () => {};
    this._controlValueAccessorChangeFn = () => {};
    this._checked = false;
    this._disabled = false;
    this.tabIndex = parseInt(tabIndex) || 0;
    this.id = this._uniqueId = `neo-checkbox-${++NeoCheckboxComponent.nextUniqueId}`;
  }
  /** Whether the checkbox is checked. */
  get checked() {
    return this._checked;
  }
  set checked(value) {
    if (value != this.checked) {
      this._checked = value;
      this._changeDetectorRef.markForCheck();
    }
  }
  /** Whether the checkbox is disabled. */
  get disabled() {
    return this._disabled;
  }
  set disabled(value) {
    if (value !== this.disabled) {
      this._disabled = value;
      this._changeDetectorRef.markForCheck();
    }
  }
  // Implemented as part of ControlValueAccessor.
  writeValue(value) {
    this.checked = !!value;
  }
  // Implemented as part of ControlValueAccessor.
  registerOnChange(fn) {
    this._controlValueAccessorChangeFn = fn;
  }
  // Implemented as part of ControlValueAccessor.
  registerOnTouched(fn) {
    this._onTouched = fn;
  }
  // Implemented as part of ControlValueAccessor.
  setDisabledState(isDisabled) {
    this.disabled = isDisabled;
  }
  _emitChangeEvent() {
    this._controlValueAccessorChangeFn(this.checked);
    this.checkedChange.emit(this.checked);
    // Assigning the value again here is redundant, but we have to do it in case it was
    // changed inside the `change` listener which will cause the input to be out of sync.
    if (this._inputElement) {
      this._inputElement.nativeElement.checked = this.checked;
    }
  }
  /** Toggles the `checked` state of the checkbox. */
  toggle() {
    this.checked = !this.checked;
    this._controlValueAccessorChangeFn(this.checked);
  }
  _handleInputClick() {
    if (!this.disabled) {
      this._checked = !this._checked;
      // Emit our custom change event if the native input emitted one.
      // It is important to only emit it, if the native input triggered one, because
      // we don't want to trigger a change event, when the `checked` variable changes for example.
      this._emitChangeEvent();
    }
  }
  _onBlur() {
    // When a focused element becomes disabled, the browser *immediately* fires a blur event.
    // Angular does not expect events to be raised during change detection, so any state change
    // (such as a form control's 'ng-touched') will cause a changed-after-checked error.
    // See https://github.com/angular/angular/issues/17793. To work around this, we defer
    // telling the form control it has been touched until the next tick.
    Promise.resolve().then(() => {
      this._onTouched();
      this._changeDetectorRef.markForCheck();
    });
  }
  _onInputClick() {
    this._handleInputClick();
  }
  /**
   *  Prevent click events that come from the `<label/>` element from bubbling. This prevents the
   *  click handler on the host from triggering twice when clicking on the `<label/>` element. After
   *  the click event on the `<label/>` propagates, the browsers dispatches click on the associated
   *  `<input/>`. By preventing clicks on the label by bubbling, we ensure only one click event
   *  bubbles when the label is clicked.
   */
  _preventBubblingFromLabel(event) {
    if (!!event.target && this._labelElement.nativeElement.contains(event.target)) {
      event.stopPropagation();
    }
  }
  static {
    this.ɵfac = function NeoCheckboxComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoCheckboxComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵinjectAttribute('tabindex'));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NeoCheckboxComponent,
      selectors: [["neo-checkbox"]],
      viewQuery: function NeoCheckboxComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c2, 5);
          i0.ɵɵviewQuery(_c3, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._inputElement = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._labelElement = _t.first);
        }
      },
      inputs: {
        ariaLabel: [0, "aria-label", "ariaLabel"],
        ariaLabelledby: [0, "aria-labelledby", "ariaLabelledby"],
        ariaDescribedby: [0, "aria-describedby", "ariaDescribedby"],
        id: "id",
        name: "name",
        value: "value",
        tabIndex: [2, "tabIndex", "tabIndex", value => value == null ? undefined : numberAttribute(value)],
        checked: [2, "checked", "checked", booleanAttribute],
        disabled: [2, "disabled", "disabled", booleanAttribute]
      },
      outputs: {
        checkedChange: "checkedChange"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => NeoCheckboxComponent),
        multi: true
      }]), i0.ɵɵInputTransformsFeature],
      ngContentSelectors: _c0,
      decls: 9,
      vars: 11,
      consts: [["label", ""], ["checkbox", ""], ["input", ""], [3, "for"], [1, "neo-checkbox"], ["type", "checkbox", 1, "neo-checkbox__native-control", 3, "blur", "click", "checked", "disabled", "id", "tabIndex"], [1, "neo-checkbox__control"], [3, "name", "size", 4, "ngIf"], [3, "name", "size"]],
      template: function NeoCheckboxComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "label", 3, 0);
          i0.ɵɵprojection(2);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "div", 4, 1)(5, "input", 5, 2);
          i0.ɵɵlistener("blur", function NeoCheckboxComponent_Template_input_blur_5_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx._onBlur());
          })("click", function NeoCheckboxComponent_Template_input_click_5_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx._onInputClick());
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(7, "div", 6);
          i0.ɵɵtemplate(8, NeoCheckboxComponent_neo_icon_8_Template, 1, 2, "neo-icon", 7);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("for", ctx.inputId);
          i0.ɵɵadvance(5);
          i0.ɵɵproperty("checked", ctx.checked)("disabled", ctx.disabled)("id", ctx.inputId)("tabIndex", ctx.disabled ? -1 : ctx.tabIndex);
          i0.ɵɵattribute("aria-label", ctx.ariaLabel || null)("aria-labelledby", ctx.ariaLabelledby)("aria-describedby", ctx.ariaDescribedby)("name", ctx.name)("value", ctx.value);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.checked);
        }
      },
      dependencies: [CommonModule, i1.NgIf, NeoIconComponent],
      styles: ["[_nghost-%COMP%]{display:flex;align-items:center;cursor:pointer;flex-direction:row-reverse;width:fit-content}[_nghost-%COMP%]:focus-visible{outline:none}.neo-checkbox[_ngcontent-%COMP%]{box-sizing:border-box;position:relative;flex:1 0 24px;width:24px;height:16px;padding-right:8px}.neo-checkbox__native-control[_ngcontent-%COMP%]{height:100%;width:100%;position:absolute;top:0;left:0;opacity:0;margin:0}.neo-checkbox__control[_ngcontent-%COMP%]{box-sizing:border-box;height:100%;width:100%;border-radius:4px;border:1px solid var(--neoGrayNeutral-300)}.neo-checkbox__native-control[_ngcontent-%COMP%]:checked + .neo-checkbox__control[_ngcontent-%COMP%]{border:1px solid var(--theme-color-secondary)}.neo-checkbox__native-control[_ngcontent-%COMP%]:hover + .neo-checkbox__control[_ngcontent-%COMP%]{background-color:var(--neoYellow-25);border:1px solid var(--theme-color-secondary)}label[_ngcontent-%COMP%]:focus + .neo-checkbox[_ngcontent-%COMP%]   .neo-checkbox__control[_ngcontent-%COMP%], label[_ngcontent-%COMP%]:active + .neo-checkbox[_ngcontent-%COMP%]   .neo-checkbox__control[_ngcontent-%COMP%], .neo-checkbox__native-control[_ngcontent-%COMP%]:focus + .neo-checkbox__control[_ngcontent-%COMP%], .neo-checkbox__native-control[_ngcontent-%COMP%]:active + .neo-checkbox__control[_ngcontent-%COMP%]{outline:2px solid var(--neoBlue-300)}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoCheckboxComponent, [{
    type: Component,
    args: [{
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => NeoCheckboxComponent),
        multi: true
      }],
      selector: 'neo-checkbox',
      imports: [CommonModule, NeoIconComponent],
      template: "<!--\n    Avoid putting a click handler on the <label/> to fix duplicate navigation stop on Talk Back\n    (#14385). Putting a click handler on the <label/> caused this bug because the browser produced\n    an unnecessary accessibility tree node.\n  -->\n<label #label [for]=\"inputId\">\n    <ng-content></ng-content>\n</label>\n<div #checkbox class=\"neo-checkbox\">\n    <input\n        #input\n        type=\"checkbox\"\n        class=\"neo-checkbox__native-control\"\n        [attr.aria-label]=\"ariaLabel || null\"\n        [attr.aria-labelledby]=\"ariaLabelledby\"\n        [attr.aria-describedby]=\"ariaDescribedby\"\n        [attr.name]=\"name\"\n        [attr.value]=\"value\"\n        [checked]=\"checked\"\n        [disabled]=\"disabled\"\n        [id]=\"inputId\"\n        [tabIndex]=\"disabled ? -1 : tabIndex\"\n        (blur)=\"_onBlur()\"\n        (click)=\"_onInputClick()\"\n    />\n    <div class=\"neo-checkbox__control\">\n        <neo-icon *ngIf=\"checked\" [name]=\"'neo-check'\" [size]=\"14\"></neo-icon>\n    </div>\n</div>\n",
      styles: [":host{display:flex;align-items:center;cursor:pointer;flex-direction:row-reverse;width:fit-content}:host:focus-visible{outline:none}.neo-checkbox{box-sizing:border-box;position:relative;flex:1 0 24px;width:24px;height:16px;padding-right:8px}.neo-checkbox__native-control{height:100%;width:100%;position:absolute;top:0;left:0;opacity:0;margin:0}.neo-checkbox__control{box-sizing:border-box;height:100%;width:100%;border-radius:4px;border:1px solid var(--neoGrayNeutral-300)}.neo-checkbox__native-control:checked+.neo-checkbox__control{border:1px solid var(--theme-color-secondary)}.neo-checkbox__native-control:hover+.neo-checkbox__control{background-color:var(--neoYellow-25);border:1px solid var(--theme-color-secondary)}label:focus+.neo-checkbox .neo-checkbox__control,label:active+.neo-checkbox .neo-checkbox__control,.neo-checkbox__native-control:focus+.neo-checkbox__control,.neo-checkbox__native-control:active+.neo-checkbox__control{outline:2px solid var(--neoBlue-300)}\n"]
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: undefined,
    decorators: [{
      type: Attribute,
      args: ['tabindex']
    }]
  }], {
    ariaLabel: [{
      type: Input,
      args: ['aria-label']
    }],
    ariaLabelledby: [{
      type: Input,
      args: ['aria-labelledby']
    }],
    ariaDescribedby: [{
      type: Input,
      args: ['aria-describedby']
    }],
    id: [{
      type: Input
    }],
    name: [{
      type: Input
    }],
    checkedChange: [{
      type: Output
    }],
    value: [{
      type: Input
    }],
    _inputElement: [{
      type: ViewChild,
      args: ['input']
    }],
    _labelElement: [{
      type: ViewChild,
      args: ['label']
    }],
    tabIndex: [{
      type: Input,
      args: [{
        transform: value => value == null ? undefined : numberAttribute(value)
      }]
    }],
    checked: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    disabled: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }]
  });
})();
class NeoIconButtonComponent {
  constructor() {
    this.disabled = false;
    this.iconName = '';
    this.iconSize = 16;
  }
  ngOnChanges(changes) {
    if (changes['iconName'] && changes['iconName'].currentValue) {
      this.iconName = changes['iconName'].currentValue;
    }
    if (changes['disabled'] && changes['disabled'].currentValue) {
      this.disabled = changes['disabled'].currentValue;
    }
    if (changes['iconSize'] && changes['iconSize'].currentValue) {
      this.iconSize = changes['iconSize'].currentValue;
    }
  }
  static {
    this.ɵfac = function NeoIconButtonComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoIconButtonComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NeoIconButtonComponent,
      selectors: [["neo-icon-button"]],
      inputs: {
        disabled: "disabled",
        iconName: "iconName",
        iconSize: "iconSize"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 2,
      vars: 3,
      consts: [[3, "disabled"], [3, "name", "size"]],
      template: function NeoIconButtonComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "button", 0);
          i0.ɵɵelement(1, "neo-icon", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("disabled", ctx.disabled);
          i0.ɵɵadvance();
          i0.ɵɵproperty("name", ctx.iconName)("size", ctx.iconSize);
        }
      },
      dependencies: [NeoIconComponent, CommonModule],
      styles: ["button[_ngcontent-%COMP%]{border:none;background-color:transparent;display:flex;justify-content:center;align-items:center}button[_ngcontent-%COMP%]:focus-visible{outline:2px solid var(--neoBlue-300);border-radius:10px}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoIconButtonComponent, [{
    type: Component,
    args: [{
      selector: 'neo-icon-button',
      imports: [NeoIconComponent, CommonModule],
      template: "<button [disabled]=\"disabled\">\n    <neo-icon [name]=\"iconName\" [size]=\"iconSize\"></neo-icon>\n</button>\n",
      styles: ["button{border:none;background-color:transparent;display:flex;justify-content:center;align-items:center}button:focus-visible{outline:2px solid var(--neoBlue-300);border-radius:10px}\n"]
    }]
  }], null, {
    disabled: [{
      type: Input
    }],
    iconName: [{
      type: Input
    }],
    iconSize: [{
      type: Input
    }]
  });
})();
class NeoInputComponent {
  constructor(clipboard) {
    this.clipboard = clipboard;
    this.placeholder = '';
    this.masked = false;
    this.copy = false;
    this.value = '';
    this.isDisabled = false;
    this.isHidden = false;
    this.isCopied = false;
    this.copyTimeout = null;
    this.onChangeFn = () => {};
    this.onTouch = () => {};
  }
  copyToClipboard() {
    this.clipboard.copy(this.value);
    this.isCopied = true;
    if (this.copyTimeout) {
      clearTimeout(this.copyTimeout); // Clear existing timeout if it exists
    }
    this.copyTimeout = setTimeout(() => {
      this.isCopied = false;
    }, 3000);
  }
  registerOnChange(fn) {
    this.onChangeFn = fn;
  }
  registerOnTouched(fn) {
    this.onTouch = fn;
  }
  setDisabledState(isDisabled) {
    this.isDisabled = isDisabled;
  }
  writeValue(obj) {
    this.value = obj;
  }
  onChange(value) {
    this.value = value;
    this.onChangeFn(this.value);
  }
  ngOnInit() {
    this.isHidden = this.masked;
  }
  static {
    this.ɵfac = function NeoInputComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoInputComponent)(i0.ɵɵdirectiveInject(i1$1.Clipboard));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NeoInputComponent,
      selectors: [["neo-input"]],
      inputs: {
        placeholder: "placeholder",
        masked: "masked",
        copy: "copy",
        autocomplete: "autocomplete",
        inputId: "inputId"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => NeoInputComponent),
        multi: true
      }])],
      ngContentSelectors: _c0,
      decls: 5,
      vars: 11,
      consts: [[3, "ngModelChange", "blur", "ngModel", "disabled", "placeholder", "type", "ngClass", "id"], [1, "icon-container"], [4, "ngIf"], ["type", "button", 3, "click"], [3, "name", "size", "ngClass"], ["type", "button", 3, "click", "tooltipText"], [3, "name", "size"]],
      template: function NeoInputComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "input", 0);
          i0.ɵɵlistener("ngModelChange", function NeoInputComponent_Template_input_ngModelChange_0_listener($event) {
            return ctx.onChange($event);
          })("blur", function NeoInputComponent_Template_input_blur_0_listener() {
            return ctx.onTouch();
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(1, "div", 1);
          i0.ɵɵtemplate(2, NeoInputComponent_ng_container_2_Template, 3, 7, "ng-container", 2)(3, NeoInputComponent_ng_container_3_Template, 3, 5, "ng-container", 2);
          i0.ɵɵelementEnd();
          i0.ɵɵprojection(4);
        }
        if (rf & 2) {
          i0.ɵɵpropertyInterpolate("type", ctx.isHidden ? "password" : "default");
          i0.ɵɵproperty("ngModel", ctx.value)("disabled", ctx.isDisabled)("placeholder", ctx.placeholder)("ngClass", i0.ɵɵpureFunction1(9, _c4, ctx.masked))("id", ctx.inputId);
          i0.ɵɵattribute("autocomplete", ctx.autocomplete);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.masked);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.copy);
        }
      },
      dependencies: [NeoIconComponent, NeoButtonComponent, FormsModule, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgModel, CommonModule, i1.NgClass, i1.NgIf],
      styles: ["[_nghost-%COMP%]{border-radius:12px;display:flex;align-items:center;background:none;width:100%;position:relative;box-shadow:0 0 0 50px var(--neo-input-bg-color) inset}input[_ngcontent-%COMP%]{background:transparent;border:1px solid var(--neo-input-border-color);border-radius:12px;color:var(--neo-input-color);padding:11px 12px;width:100%;font-size:16px;font-family:Roobert,sans-serif;font-style:normal;font-weight:400;line-height:24px}input[_ngcontent-%COMP%]::placeholder{color:var(--neo-input-placeholder-color)}input[_ngcontent-%COMP%]:focus-visible{outline:3px solid var(--neo-input-outline-color);outline-offset:1px;border-color:var(--neo-input-border-focused)}input[_ngcontent-%COMP%]:-webkit-autofill, input[_ngcontent-%COMP%]:-webkit-autofill:focus{transition:background-color 600000s 0s,color 600000s 0s}.icon-container[_ngcontent-%COMP%]{position:absolute;top:50%;transform:translateY(-50%);right:0;display:flex;align-items:end}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoInputComponent, [{
    type: Component,
    args: [{
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => NeoInputComponent),
        multi: true
      }],
      selector: 'neo-input',
      imports: [NeoIconComponent, NeoButtonComponent, FormsModule, CommonModule],
      template: "<input\n    (ngModelChange)=\"onChange($event)\"\n    [ngModel]=\"value\"\n    [disabled]=\"isDisabled\"\n    [placeholder]=\"placeholder\"\n    [attr.autocomplete]=\"autocomplete\"\n    (blur)=\"onTouch()\"\n    type=\"{{ isHidden ? 'password' : 'default' }}\"\n    [ngClass]=\"{'with-button': masked}\"\n    [id]=\"inputId\"\n/>\n\n<div class=\"icon-container\">\n    <ng-container *ngIf=\"masked\">\n        <neo-button (click)=\"isHidden = !isHidden\" [class]=\"'neo-icon-button'\" type=\"button\">\n            <neo-icon [name]=\"isHidden ? 'neo-eye' : 'neo-eye-off'\" [size]=\"20\" [ngClass]=\"{'with-button': masked && copy}\"></neo-icon>\n        </neo-button>\n    </ng-container>\n    <ng-container *ngIf=\"copy\">\n        <neo-button (click)=\"copyToClipboard()\" [class]=\"'neo-icon-button'\" type=\"button\" [tooltipText]=\"isCopied? 'Copied': 'Copy to clipboard'\">\n            <neo-icon [name]=\"'neo-copy-06'\" [size]=\"20\"></neo-icon>\n        </neo-button>\n    </ng-container>\n</div>\n<ng-content></ng-content>",
      styles: [":host{border-radius:12px;display:flex;align-items:center;background:none;width:100%;position:relative;box-shadow:0 0 0 50px var(--neo-input-bg-color) inset}input{background:transparent;border:1px solid var(--neo-input-border-color);border-radius:12px;color:var(--neo-input-color);padding:11px 12px;width:100%;font-size:16px;font-family:Roobert,sans-serif;font-style:normal;font-weight:400;line-height:24px}input::placeholder{color:var(--neo-input-placeholder-color)}input:focus-visible{outline:3px solid var(--neo-input-outline-color);outline-offset:1px;border-color:var(--neo-input-border-focused)}input:-webkit-autofill,input:-webkit-autofill:focus{transition:background-color 600000s 0s,color 600000s 0s}.icon-container{position:absolute;top:50%;transform:translateY(-50%);right:0;display:flex;align-items:end}\n"]
    }]
  }], () => [{
    type: i1$1.Clipboard
  }], {
    placeholder: [{
      type: Input
    }],
    masked: [{
      type: Input
    }],
    copy: [{
      type: Input
    }],
    autocomplete: [{
      type: Input
    }],
    inputId: [{
      type: Input
    }]
  });
})();
class NeoLinkComponent {
  constructor(router) {
    this.router = router;
    this.to = '';
    this.openNewPage = false;
  }
  ngOnChanges(changes) {
    if (changes['to']) {
      this.to = changes['to'].currentValue;
    }
    if (changes['openNewPage']) {
      this.openNewPage = changes['openNewPage'].currentValue;
    }
  }
  navigate() {
    try {
      new URL(this.to);
      if (this.openNewPage) {
        const win = window.open(this.to, '_blank');
        win.focus();
      } else {
        window.open(this.to, '_self');
      }
    } catch (_) {
      this.router.navigate([this.to]).then(r => r);
    }
  }
  static {
    this.ɵfac = function NeoLinkComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoLinkComponent)(i0.ɵɵdirectiveInject(i1$2.Router));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NeoLinkComponent,
      selectors: [["neo-link"]],
      inputs: {
        to: "to",
        openNewPage: "openNewPage"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      ngContentSelectors: _c0,
      decls: 3,
      vars: 0,
      consts: [["tabindex", "0", 1, "link-container", 3, "keydown.enter", "click"], [1, "link"]],
      template: function NeoLinkComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵlistener("keydown.enter", function NeoLinkComponent_Template_div_keydown_enter_0_listener() {
            return ctx.navigate();
          })("click", function NeoLinkComponent_Template_div_click_0_listener() {
            return ctx.navigate();
          });
          i0.ɵɵelementStart(1, "a", 1);
          i0.ɵɵprojection(2);
          i0.ɵɵelementEnd()();
        }
      },
      dependencies: [CommonModule],
      styles: [".link-container[_ngcontent-%COMP%]{width:fit-content;padding:10px 0;border:1px solid transparent;border-radius:100px;transition:ease-in-out all .1s}.link-container[_ngcontent-%COMP%]:focus-visible{transition:ease-in-out all .1s;padding:10px;background-color:#fff9;border-radius:100px;border:1px solid var(--theme-color-main);outline:1px solid transparent}.link[_ngcontent-%COMP%]{display:flex;align-items:center;cursor:pointer;text-decoration:underline;text-underline-offset:5px;text-decoration-thickness:1px}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoLinkComponent, [{
    type: Component,
    args: [{
      selector: 'neo-link',
      imports: [CommonModule],
      template: "<div tabindex=\"0\" class=\"link-container\" (keydown.enter)=\"navigate()\" (click)=\"navigate()\">\n    <a class=\"link\">\n        <ng-content></ng-content>\n    </a>\n</div>\n",
      styles: [".link-container{width:fit-content;padding:10px 0;border:1px solid transparent;border-radius:100px;transition:ease-in-out all .1s}.link-container:focus-visible{transition:ease-in-out all .1s;padding:10px;background-color:#fff9;border-radius:100px;border:1px solid var(--theme-color-main);outline:1px solid transparent}.link{display:flex;align-items:center;cursor:pointer;text-decoration:underline;text-underline-offset:5px;text-decoration-thickness:1px}\n"]
    }]
  }], () => [{
    type: i1$2.Router
  }], {
    to: [{
      type: Input
    }],
    openNewPage: [{
      type: Input
    }]
  });
})();
class NeoModalComponent {
  static {
    this.ɵfac = function NeoModalComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoModalComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NeoModalComponent,
      selectors: [["neo-modal"]],
      ngContentSelectors: _c0,
      decls: 3,
      vars: 0,
      consts: [[1, "background"], [1, "modal-wrapper"]],
      template: function NeoModalComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelement(0, "div", 0);
          i0.ɵɵelementStart(1, "div", 1);
          i0.ɵɵprojection(2);
          i0.ɵɵelementEnd();
        }
      },
      styles: [".modal-wrapper[_ngcontent-%COMP%]{position:fixed;display:flex;justify-content:center;align-items:center;width:100%;height:100%;top:0;left:0;animation:ease-in-out .4 linear;z-index:10}.background[_ngcontent-%COMP%]{position:fixed;background-color:#000;opacity:60%;width:100%;height:100%;top:0;left:0;animation:ease-in-out .4 linear;z-index:10}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoModalComponent, [{
    type: Component,
    args: [{
      selector: 'neo-modal',
      template: "<div class=\"background\"></div>\n<div class=\"modal-wrapper\">\n    <ng-content></ng-content>\n</div>\n",
      styles: [".modal-wrapper{position:fixed;display:flex;justify-content:center;align-items:center;width:100%;height:100%;top:0;left:0;animation:ease-in-out .4 linear;z-index:10}.background{position:fixed;background-color:#000;opacity:60%;width:100%;height:100%;top:0;left:0;animation:ease-in-out .4 linear;z-index:10}\n"]
    }]
  }], null, null);
})();
class NeoTextAreaComponent {
  constructor() {
    this.placeholder = 'Put some text';
    this.disabled = false;
    this.value = '';
    this.isDisabled = false;
    this.onChangeFn = () => {};
    this.onTouch = () => {};
  }
  registerOnChange(fn) {
    this.onChangeFn = fn;
  }
  registerOnTouched(fn) {
    this.onTouch = fn;
  }
  setDisabledState(isDisabled) {
    this.isDisabled = isDisabled;
  }
  writeValue(obj) {
    this.value = obj;
  }
  onChange() {
    this.onChangeFn(this.value);
    this.onTouch();
  }
  static {
    this.ɵfac = function NeoTextAreaComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoTextAreaComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NeoTextAreaComponent,
      selectors: [["neo-text-area"]],
      inputs: {
        placeholder: "placeholder",
        disabled: "disabled"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => NeoTextAreaComponent),
        multi: true
      }])],
      decls: 1,
      vars: 3,
      consts: [[3, "ngModelChange", "ngModel", "disabled", "placeholder"]],
      template: function NeoTextAreaComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "textarea", 0);
          i0.ɵɵtwoWayListener("ngModelChange", function NeoTextAreaComponent_Template_textarea_ngModelChange_0_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.value, $event) || (ctx.value = $event);
            return $event;
          });
          i0.ɵɵlistener("ngModelChange", function NeoTextAreaComponent_Template_textarea_ngModelChange_0_listener() {
            return ctx.onChange();
          });
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵtwoWayProperty("ngModel", ctx.value);
          i0.ɵɵproperty("disabled", ctx.isDisabled)("placeholder", ctx.placeholder);
        }
      },
      dependencies: [CommonModule, FormsModule, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgModel],
      styles: ["[_nghost-%COMP%]{display:flex;border:1px solid var(--neoGrayNeutral-300);border-radius:10px}textarea[_ngcontent-%COMP%]{width:100%;min-height:100px;max-height:max-content;font-family:Roobert,sans-serif;font-size:16px;font-weight:400;border:none;border-radius:10px;padding:10px;resize:vertical}textarea[_ngcontent-%COMP%]:focus-visible{outline:var(--neoBlue-300) solid 2px}.invalid[_ngcontent-%COMP%]{border:1px solid red;color:red}textarea.invalid[_ngcontent-%COMP%]::placeholder{color:red}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoTextAreaComponent, [{
    type: Component,
    args: [{
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => NeoTextAreaComponent),
        multi: true
      }],
      selector: 'neo-text-area',
      imports: [CommonModule, FormsModule],
      template: "<textarea\n    [(ngModel)]=\"value\"\n    [disabled]=\"isDisabled\"\n    (ngModelChange)=\"onChange()\"\n    [placeholder]=\"placeholder\"\n></textarea>\n",
      styles: [":host{display:flex;border:1px solid var(--neoGrayNeutral-300);border-radius:10px}textarea{width:100%;min-height:100px;max-height:max-content;font-family:Roobert,sans-serif;font-size:16px;font-weight:400;border:none;border-radius:10px;padding:10px;resize:vertical}textarea:focus-visible{outline:var(--neoBlue-300) solid 2px}.invalid{border:1px solid red;color:red}textarea.invalid::placeholder{color:red}\n"]
    }]
  }], null, {
    placeholder: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }]
  });
})();
class NeoToggleComponent {
  constructor() {
    this.toggle = false;
    this.disabled = false;
    this.onChangeFn = () => {};
    this.onTouch = () => {};
  }
  registerOnChange(fn) {
    this.onChangeFn = fn;
  }
  registerOnTouched(fn) {
    this.onTouch = fn;
  }
  setDisabledState(disabled) {
    this.disabled = disabled;
  }
  writeValue(obj) {
    this.toggle = obj;
  }
  ngOnChanges(changes) {
    if (changes['toggle']?.currentValue) {
      this.toggle = changes['toggle'].currentValue;
    }
    if (changes['disabled']?.currentValue) {
      this.disabled = changes['disabled'].currentValue;
    }
  }
  onToggle() {
    if (this.disabled) {
      return;
    }
    this.toggle = !this.toggle;
    this.onChangeFn(this.toggle);
  }
  static {
    this.ɵfac = function NeoToggleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoToggleComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NeoToggleComponent,
      selectors: [["neo-toggle"]],
      inputs: {
        toggle: "toggle",
        disabled: "disabled"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => NeoToggleComponent),
        multi: true
      }]), i0.ɵɵNgOnChangesFeature],
      decls: 3,
      vars: 6,
      consts: [[3, "click", "keydown.enter", "tabindex", "ngClass"], ["height", "22", "width", "22"], ["cx", "11", "cy", "11", "r", "10", "stroke", "white", "stroke-width", "1", "fill", "white"]],
      template: function NeoToggleComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "span", 0);
          i0.ɵɵlistener("click", function NeoToggleComponent_Template_span_click_0_listener() {
            return ctx.onToggle();
          })("keydown.enter", function NeoToggleComponent_Template_span_keydown_enter_0_listener() {
            return ctx.onToggle();
          });
          i0.ɵɵnamespaceSVG();
          i0.ɵɵelementStart(1, "svg", 1);
          i0.ɵɵelement(2, "circle", 2);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("tabindex", 0)("ngClass", i0.ɵɵpureFunction3(2, _c5, ctx.toggle, !ctx.toggle, ctx.disabled));
        }
      },
      dependencies: [CommonModule, i1.NgClass],
      styles: ["span[_ngcontent-%COMP%]{display:flex;width:45px;border-radius:20px;height:fit-content;cursor:pointer}span[_ngcontent-%COMP%]:focus-visible{outline:var(--neoBlue-300) solid 2px}svg[_ngcontent-%COMP%]{border-radius:20px}.disabled[_ngcontent-%COMP%]{cursor:default;opacity:40%}.toggle-off[_ngcontent-%COMP%]{background-color:var(--neoGrayNeutral-200);border:1px solid var(--neoGrayNeutral-200);transition:background-color .2s ease-in-out}.toggle-off[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{margin-left:0;transition:margin-left .2s ease-in-out}.toggle-on[_ngcontent-%COMP%]{background-color:var(--neoPurple-600);border:1px solid var(--neoPurple-600);transition:background-color .2s ease-in-out}.toggle-on[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{margin-left:23px;transition:margin-left .2s ease-in-out}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoToggleComponent, [{
    type: Component,
    args: [{
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => NeoToggleComponent),
        multi: true
      }],
      selector: 'neo-toggle',
      imports: [CommonModule],
      template: "<span\n    [tabindex]=\"0\"\n    [ngClass]=\"{ 'toggle-on': toggle, 'toggle-off': !toggle, disabled: disabled }\"\n    (click)=\"onToggle()\"\n    (keydown.enter)=\"onToggle()\"\n>\n    <svg height=\"22\" width=\"22\">\n        <circle cx=\"11\" cy=\"11\" r=\"10\" stroke=\"white\" stroke-width=\"1\" fill=\"white\" />\n    </svg>\n</span>\n",
      styles: ["span{display:flex;width:45px;border-radius:20px;height:fit-content;cursor:pointer}span:focus-visible{outline:var(--neoBlue-300) solid 2px}svg{border-radius:20px}.disabled{cursor:default;opacity:40%}.toggle-off{background-color:var(--neoGrayNeutral-200);border:1px solid var(--neoGrayNeutral-200);transition:background-color .2s ease-in-out}.toggle-off svg{margin-left:0;transition:margin-left .2s ease-in-out}.toggle-on{background-color:var(--neoPurple-600);border:1px solid var(--neoPurple-600);transition:background-color .2s ease-in-out}.toggle-on svg{margin-left:23px;transition:margin-left .2s ease-in-out}\n"]
    }]
  }], null, {
    toggle: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }]
  });
})();
class NeoInputCodeComponent {
  constructor() {
    this.globalTemplate = [];
    this.placeholders = [];
    this.patterns = [];
    this.displayInputs = [];
    this.cumulativeLengths = [];
    this.onTouch = () => {};
    this.onChangeFn = () => {};
  }
  ngOnInit() {
    this.patterns = this.globalTemplate.flat(1).map(pattern => new RegExp(pattern));
    this.displayInputs = new Array(this.patterns.length);
    // compute cumulative lengths
    for (let i = 0; i < this.globalTemplate.length; ++i) {
      const cumulativeLength = i === 0 ? 0 : this.cumulativeLengths[i - 1] + this.globalTemplate[i - 1].length;
      this.cumulativeLengths.push(cumulativeLength);
    }
  }
  writeValue(value) {
    if (value) {
      let filteredValues = '';
      let i = 0;
      let j = 0;
      while (i < this.displayInputs.length && j < value.length) {
        const char = value.charAt(j++);
        if (this.patterns[i].test(char)) {
          filteredValues = filteredValues + char;
          i++;
        }
      }
      this.focusOn(i);
    }
  }
  registerOnChange(fn) {
    this.onChangeFn = fn;
  }
  registerOnTouched(fn) {
    this.onTouch = fn;
  }
  writeAndMoveToNext(digit, i) {
    if (!digit || !this.patterns[i].test(digit)) {
      this.inputs.toArray()[i].nativeElement.value = '';
      return;
    }
    this.displayInputs[i] = digit;
    this.focusOn(i + 1);
    this.onTouch();
    this.onChangeFn(this.displayInputs.join(''));
  }
  clearFieldAndBacktrack(i) {
    if (i === -1) {
      return;
    }
    // on second backspace, clear and focus on previous input field
    if (this.displayInputs[i] === null) {
      this.clearFieldAndBacktrack(i - 1);
      return;
    }
    this.focusOn(i);
    this.displayInputs[i] = null;
    this.onTouch();
    this.onChangeFn(this.displayInputs.join(''));
  }
  pasteValue(event) {
    const pastedValue = event.clipboardData?.getData('text') || '';
    this.writeValue(pastedValue);
  }
  focusOn(i) {
    if (i < 0 || i >= this.displayInputs.length) {
      return;
    }
    this.inputs.toArray()[i].nativeElement.focus();
    this.inputs.toArray()[i].nativeElement.select();
  }
  static {
    this.ɵfac = function NeoInputCodeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoInputCodeComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NeoInputCodeComponent,
      selectors: [["neo-input-code"]],
      viewQuery: function NeoInputCodeComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c6, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputs = _t);
        }
      },
      inputs: {
        globalTemplate: "globalTemplate",
        placeholders: "placeholders"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => NeoInputCodeComponent),
        multi: true
      }])],
      decls: 1,
      vars: 1,
      consts: [["inputField", ""], [4, "ngFor", "ngForOf"], ["type", "text", "maxlength", "1", 3, "ngModel", "placeholder", "paste", "keydown.backspace", "ngModelChange", 4, "ngFor", "ngForOf"], ["class", "splitter", 4, "ngIf"], ["type", "text", "maxlength", "1", 3, "paste", "keydown.backspace", "ngModelChange", "ngModel", "placeholder"], [1, "splitter"]],
      template: function NeoInputCodeComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, NeoInputCodeComponent_ng_container_0_Template, 3, 2, "ng-container", 1);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngForOf", ctx.globalTemplate);
        }
      },
      dependencies: [CommonModule, i1.NgForOf, i1.NgIf, FormsModule, i2.DefaultValueAccessor, i2.NgControlStatus, i2.MaxLengthValidator, i2.NgModel],
      styles: ["[_nghost-%COMP%]{display:flex;align-items:center;justify-content:center}@media only screen and (max-width: 374px){[_nghost-%COMP%]{gap:unset}}[_nghost-%COMP%]   *[_ngcontent-%COMP%]{font-size:48px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]{color:var(--neoPurple-600);border:1px solid var(--neoGrayNeutral-300);border-radius:7.65px;height:100%;width:100%;max-width:61px;max-height:61px;text-align:center;margin:0 5px}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:first-child{margin-left:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:last-child{margin-right:0}[_nghost-%COMP%]   input[_ngcontent-%COMP%]::placeholder{color:var(--neoGrayNeutral-300)}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus::placeholder{color:transparent}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus-visible{outline:var(--neoBlue-300) solid 2px}@media only screen and (max-width: 433px){[_nghost-%COMP%]   input[_ngcontent-%COMP%]{font-size:30px}}[_nghost-%COMP%]   .splitter[_ngcontent-%COMP%]{display:flex;justify-content:center;color:var(--neoGrayNeutral-300);width:100%}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoInputCodeComponent, [{
    type: Component,
    args: [{
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => NeoInputCodeComponent),
        multi: true
      }],
      selector: 'neo-input-code',
      imports: [CommonModule, FormsModule],
      template: "<ng-container *ngFor=\"let template of this.globalTemplate; let i = index; last as isLast\">\n    <input\n            *ngFor=\"let _ of template; let j = index\"\n            #inputField\n            (paste)=\"pasteValue($event)\"\n            (keydown.backspace)=\"clearFieldAndBacktrack(cumulativeLengths[i]+j)\"\n            (ngModelChange)=\"writeAndMoveToNext($event, cumulativeLengths[i]+j)\"\n            [ngModel]=\"displayInputs[cumulativeLengths[i]+j]\"\n            type=\"text\"\n            maxlength=\"1\"\n            [placeholder]=\"placeholders[cumulativeLengths[i]+j] || '0'\"\n    />\n    <span *ngIf=\"!isLast\" class=\"splitter\">-</span>\n</ng-container>\n",
      styles: [":host{display:flex;align-items:center;justify-content:center}@media only screen and (max-width: 374px){:host{gap:unset}}:host *{font-size:48px}:host input{color:var(--neoPurple-600);border:1px solid var(--neoGrayNeutral-300);border-radius:7.65px;height:100%;width:100%;max-width:61px;max-height:61px;text-align:center;margin:0 5px}:host input:first-child{margin-left:0}:host input:last-child{margin-right:0}:host input::placeholder{color:var(--neoGrayNeutral-300)}:host input:focus::placeholder{color:transparent}:host input:focus-visible{outline:var(--neoBlue-300) solid 2px}@media only screen and (max-width: 433px){:host input{font-size:30px}}:host .splitter{display:flex;justify-content:center;color:var(--neoGrayNeutral-300);width:100%}\n"]
    }]
  }], null, {
    globalTemplate: [{
      type: Input
    }],
    placeholders: [{
      type: Input
    }],
    inputs: [{
      type: ViewChildren,
      args: ['inputField']
    }]
  });
})();
class NeoWithMenuDirective {
  constructor(el, renderer) {
    this.el = el;
    this.renderer = renderer;
    this.el.nativeElement.style.position = 'relative';
  }
  ngAfterViewInit() {
    this.renderer.appendChild(this.el.nativeElement, this.neoWithMenu.elementRef.nativeElement);
    this.el.nativeElement.addEventListener('click', () => {
      this.neoWithMenu.showDropdown = !this.neoWithMenu.showDropdown;
    });
  }
  onClick(event) {
    if (!this.isClickOnMenu(event)) {
      this.neoWithMenu.showDropdown = false;
    }
  }
  clickOut(event) {
    if (event.key === 'Escape') {
      this.neoWithMenu.showDropdown = false;
    }
  }
  isClickOnMenu(event) {
    return this.el.nativeElement.contains(event.target) || this.neoWithMenu.elementRef.nativeElement.contains(event.target);
  }
  static {
    this.ɵfac = function NeoWithMenuDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoWithMenuDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NeoWithMenuDirective,
      selectors: [["", "neoWithMenu", ""]],
      hostBindings: function NeoWithMenuDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function NeoWithMenuDirective_click_HostBindingHandler($event) {
            return ctx.onClick($event);
          }, false, i0.ɵɵresolveDocument)("keydown", function NeoWithMenuDirective_keydown_HostBindingHandler($event) {
            return ctx.clickOut($event);
          }, false, i0.ɵɵresolveDocument);
        }
      },
      inputs: {
        neoWithMenu: "neoWithMenu"
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoWithMenuDirective, [{
    type: Directive,
    args: [{
      selector: '[neoWithMenu]'
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i0.Renderer2
  }], {
    neoWithMenu: [{
      type: Input
    }],
    onClick: [{
      type: HostListener,
      args: ['document:click', ['$event']]
    }],
    clickOut: [{
      type: HostListener,
      args: ['document:keydown', ['$event']]
    }]
  });
})();
class NeoMenuButtonComponent {
  constructor() {
    this.disabled = false;
  }
  static {
    this.ɵfac = function NeoMenuButtonComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoMenuButtonComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NeoMenuButtonComponent,
      selectors: [["neo-menu-button"]],
      inputs: {
        disabled: "disabled"
      },
      ngContentSelectors: _c0,
      decls: 2,
      vars: 1,
      consts: [[1, "menu-button", 3, "disabled"]],
      template: function NeoMenuButtonComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "button", 0);
          i0.ɵɵprojection(1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("disabled", ctx.disabled);
        }
      },
      styles: [".menu-button[_ngcontent-%COMP%]{background-color:transparent;border:none;width:100%;display:flex;padding:10px;align-items:center;cursor:pointer;overflow:hidden}.menu-button[_ngcontent-%COMP%]:hover{background-color:var(--neoYellow-50)}.menu-button[_ngcontent-%COMP%]:focus-visible{outline:2px solid var(--neoBlue-300);outline-offset:-1px;border-radius:10px}.menu-button[_ngcontent-%COMP%]:disabled{border:1px solid var(--neoGreen-25);background-color:var(--neoGrayNeutral-50);color:var(--neoGreen-50);cursor:default}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoMenuButtonComponent, [{
    type: Component,
    args: [{
      selector: 'neo-menu-button',
      template: "<button class=\"menu-button\"[disabled]=\"disabled\">\n    <ng-content></ng-content>\n</button>\n",
      styles: [".menu-button{background-color:transparent;border:none;width:100%;display:flex;padding:10px;align-items:center;cursor:pointer;overflow:hidden}.menu-button:hover{background-color:var(--neoYellow-50)}.menu-button:focus-visible{outline:2px solid var(--neoBlue-300);outline-offset:-1px;border-radius:10px}.menu-button:disabled{border:1px solid var(--neoGreen-25);background-color:var(--neoGrayNeutral-50);color:var(--neoGreen-50);cursor:default}\n"]
    }]
  }], null, {
    disabled: [{
      type: Input
    }]
  });
})();
class NeoMenuComponent {
  constructor(elementRef) {
    this.elementRef = elementRef;
    this.showDropdown = false;
  }
  static {
    this.ɵfac = function NeoMenuComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoMenuComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NeoMenuComponent,
      selectors: [["neo-menu"]],
      inputs: {
        style: "style"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 1,
      consts: [["class", "dropdown-content", 3, "style", 4, "ngIf"], [1, "dropdown-content"]],
      template: function NeoMenuComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, NeoMenuComponent_div_0_Template, 2, 2, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.showDropdown);
        }
      },
      dependencies: [CommonModule, i1.NgIf],
      styles: [".dropdown-content[_ngcontent-%COMP%]{position:absolute;border:1px solid var(--neoGrayNeutral-300);border-radius:10px;display:flex;flex-direction:column;z-index:10;background-color:var(--theme-color-background);max-height:300px;padding:0;overflow:auto;margin:0;min-width:fit-content;width:100%}.bottom-left[_ngcontent-%COMP%]{top:40px;left:0}.bottom-right[_ngcontent-%COMP%]{top:40px;right:0}.top-left[_ngcontent-%COMP%]{top:-40px;left:0}.top-right[_ngcontent-%COMP%]{top:-60px;right:0}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoMenuComponent, [{
    type: Component,
    args: [{
      selector: 'neo-menu',
      imports: [CommonModule],
      template: "<div class=\"dropdown-content\" *ngIf=\"showDropdown\" [style]=\"style\">\n    <ng-content></ng-content>\n</div>\n",
      styles: [".dropdown-content{position:absolute;border:1px solid var(--neoGrayNeutral-300);border-radius:10px;display:flex;flex-direction:column;z-index:10;background-color:var(--theme-color-background);max-height:300px;padding:0;overflow:auto;margin:0;min-width:fit-content;width:100%}.bottom-left{top:40px;left:0}.bottom-right{top:40px;right:0}.top-left{top:-40px;left:0}.top-right{top:-60px;right:0}\n"]
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    style: [{
      type: Input
    }]
  });
})();
class NeoMenuSeparatorComponent {
  static {
    this.ɵfac = function NeoMenuSeparatorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoMenuSeparatorComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NeoMenuSeparatorComponent,
      selectors: [["neo-menu-separator"]],
      decls: 0,
      vars: 0,
      template: function NeoMenuSeparatorComponent_Template(rf, ctx) {},
      styles: ["[_nghost-%COMP%]{border-bottom:1px solid var(--neoGrayNeutral-300)}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoMenuSeparatorComponent, [{
    type: Component,
    args: [{
      selector: 'neo-menu-separator',
      template: "",
      styles: [":host{border-bottom:1px solid var(--neoGrayNeutral-300)}\n"]
    }]
  }], null, null);
})();
class NeoMenuModule {
  static {
    this.ɵfac = function NeoMenuModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoMenuModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NeoMenuModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [NeoMenuComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoMenuModule, [{
    type: NgModule,
    args: [{
      imports: [NeoWithMenuDirective, NeoMenuButtonComponent, NeoMenuComponent, NeoMenuSeparatorComponent],
      exports: [NeoWithMenuDirective, NeoMenuButtonComponent, NeoMenuComponent, NeoMenuSeparatorComponent],
      providers: []
    }]
  }], null, null);
})();
class NeoOtpDirective {
  constructor(component) {
    this.component = component;
    component.globalTemplate = [['[0-9]', '[0-9]', '[0-9]'], ['[0-9]', '[0-9]', '[0-9]']];
  }
  static {
    this.ɵfac = function NeoOtpDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoOtpDirective)(i0.ɵɵdirectiveInject(NeoInputCodeComponent));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NeoOtpDirective,
      selectors: [["", "neoOtp", ""]]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoOtpDirective, [{
    type: Directive,
    args: [{
      selector: '[neoOtp]'
    }]
  }], () => [{
    type: NeoInputCodeComponent
  }], null);
})();
class NeoRecoveryCodeDirective {
  constructor(component) {
    this.component = component;
    component.globalTemplate = [['[a-zA-Z0-9]', '[a-zA-Z0-9]', '[a-zA-Z0-9]', '[a-zA-Z0-9]'], ['[a-zA-Z0-9]', '[a-zA-Z0-9]', '[a-zA-Z0-9]', '[a-zA-Z0-9]']];
    component.placeholders = ['A', '0', '0', '0', 'A', '0', '0', '0'];
  }
  static {
    this.ɵfac = function NeoRecoveryCodeDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoRecoveryCodeDirective)(i0.ɵɵdirectiveInject(NeoInputCodeComponent));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NeoRecoveryCodeDirective,
      selectors: [["", "neoRecoveryCode", ""]]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoRecoveryCodeDirective, [{
    type: Directive,
    args: [{
      selector: '[neoRecoveryCode]'
    }]
  }], () => [{
    type: NeoInputCodeComponent
  }], null);
})();
class NeoAutofillDirective {
  constructor(_hostEl, _ngControl) {
    this._hostEl = _hostEl;
    this._ngControl = _ngControl;
  }
  ngAfterViewInit() {
    if (this._hostEl.nativeElement.matches('input')) {
      this._inputEl = this._hostEl.nativeElement;
    } else {
      this._inputEl = this._hostEl.nativeElement.querySelector('input');
    }
    const isChrome = !!navigator.userAgent.match(/chrome|chromium|crios/i);
    if (isChrome) {
      this.detectAutofill();
    }
  }
  detectAutofill() {
    let intervalTimer = 0;
    const interval = setInterval(() => {
      intervalTimer++;
      if (intervalTimer >= 11) {
        clearInterval(interval);
      }
      if (this._inputEl.matches(':-webkit-autofill')) {
        this._ngControl.control?.setErrors(null);
        clearInterval(interval);
      }
    }, 100);
  }
  static {
    this.ɵfac = function NeoAutofillDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoAutofillDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i2.NgControl, 2));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NeoAutofillDirective,
      selectors: [["", "neoAutofill", ""]]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoAutofillDirective, [{
    type: Directive,
    args: [{
      selector: '[neoAutofill]'
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i2.NgControl,
    decorators: [{
      type: Self
    }]
  }], null);
})();
class RadioButton {
  static {
    this.ɵfac = function RadioButton_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RadioButton)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: RadioButton,
      factory: RadioButton.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RadioButton, [{
    type: Injectable
  }], null, null);
})();
class RadioGroup {
  static {
    this.ɵfac = function RadioGroup_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RadioGroup)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: RadioGroup,
      factory: RadioGroup.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RadioGroup, [{
    type: Injectable
  }], null, null);
})();

/**
 * A group of radio buttons. May contain one or more `<neo-radio-button>` elements.
 */
class NeoRadioButtonComponent extends RadioButton {
  // Increasing integer for generating unique ids for radio components.
  static {
    this.nextUniqueId = 0;
  }
  /** Whether this radio button is checked. */
  get checked() {
    return this._checked;
  }
  set checked(value) {
    if (this._checked !== value) {
      this._checked = value;
      if (value && this.radioGroup && this.radioGroup.value !== this.value) {
        this.radioGroup.selected = this;
      } else if (!value && this.radioGroup && this.radioGroup.value === this.value) {
        // When unchecking the selected radio button, update the selected radio
        // property on the group.
        this.radioGroup.selected = null;
      }
      if (value) {
        // Notify all radio buttons with the same name to un-check.
        this._radioDispatcher.notify(this.id, this.name);
      }
      this._changeDetector.markForCheck();
    }
  }
  /** The value of this radio button. */
  get value() {
    return this._value;
  }
  set value(value) {
    if (this._value !== value) {
      this._value = value;
      if (this.radioGroup) {
        if (!this.checked) {
          // Update checked when the value changed to match the radio group's value
          this.checked = this.radioGroup.value === value;
        }
        if (this.checked) {
          this.radioGroup.selected = this;
        }
      }
    }
  }
  /** Whether the radio button is disabled. */
  get disabled() {
    return this._disabled || !!(this.radioGroup && this.radioGroup.disabled);
  }
  set disabled(value) {
    this._setDisabled(value);
  }
  /** ID of the native input element inside `<neo-radio-button>` */
  get inputId() {
    return `${this.id || this._uniqueId}-input`;
  }
  constructor(_elementRef, _changeDetector, _focusMonitor, _radioDispatcher, radioGroup, tabIndex) {
    super();
    this._elementRef = _elementRef;
    this._changeDetector = _changeDetector;
    this._focusMonitor = _focusMonitor;
    this._radioDispatcher = _radioDispatcher;
    this.radioGroup = radioGroup;
    this._uniqueId = `neo-radio-${++NeoRadioButtonComponent.nextUniqueId}`;
    /** The unique ID for the radio button. */
    this.id = this._uniqueId;
    /** Used to set the 'aria-label' attribute on the underlying input element. */
    this.ariaLabel = null;
    /** The 'aria-labelledby' attribute takes precedence as the element's text alternative. */
    this.ariaLabelledby = null;
    /** The 'aria-describedby' attribute is read after the element's label and field type. */
    this.ariaDescribedby = null;
    /** Tabindex of the radio button. */
    this.tabIndex = 0;
    // Needs to be removed since it causes some a11y issues (see #21266).
    this.unsetAccessibilityAttributes = null;
    /**
     * Event emitted when the checked state of this radio button changes.
     * Change events are only emitted when the value changes due to user interaction with
     * the radio button (the same behavior as `<input type-"radio">`).
     */
    this.valueChange = new EventEmitter();
    /** Whether this radio is checked. */
    this._checked = false;
    /** Whether this radio is disabled. */
    this._disabled = false;
    /** Value assigned to this radio. */
    this._value = null;
    /** Unregister function for _radioDispatcher */
    this._removeUniqueSelectionListener = () => {};
    if (tabIndex) {
      this.tabIndex = numberAttribute(tabIndex, 0);
    }
  }
  /** Focuses the radio button. */
  focus(options, origin) {
    if (origin) {
      this._focusMonitor.focusVia(this._inputElement, origin, options);
    } else {
      this._inputElement.nativeElement.focus(options);
    }
  }
  /**
   * Marks the radio button as needing checking for change detection.
   * This method is exposed because the parent radio group will directly
   * update bound properties of the radio button.
   */
  _markForCheck() {
    // When group value changes, the button will not be notified. Use `markForCheck` to explicit
    // update radio button's status
    this._changeDetector.markForCheck();
  }
  ngOnInit() {
    if (this.radioGroup) {
      // If the radio is inside a radio group, determine if it should be checked
      this.checked = this.radioGroup.value === this._value;
      if (this.checked) {
        this.radioGroup.selected = this;
      }
      // Copy name from parent radio group
      this.name = this.radioGroup.name;
    }
    this._removeUniqueSelectionListener = this._radioDispatcher.listen((id, name) => {
      if (id !== this.id && name === this.name) {
        this.checked = false;
      }
    });
  }
  ngDoCheck() {
    this._updateTabIndex();
  }
  ngAfterViewInit() {
    this._updateTabIndex();
    this._focusMonitor.monitor(this._elementRef, true).subscribe(focusOrigin => {
      if (!focusOrigin && this.radioGroup) {
        this.radioGroup._touch();
      }
    });
  }
  ngOnDestroy() {
    this._focusMonitor.stopMonitoring(this._elementRef);
    this._removeUniqueSelectionListener();
  }
  forwardFocus() {
    // Note: under normal conditions focus shouldn't land on this element, however it may be
    // programmatically set, for example inside of a focus trap, in this case we want to forward
    // the focus to the native element.
    this._inputElement.nativeElement.focus();
  }
  /** Dispatch change event with current value. */
  _emitChangeEvent() {
    this.valueChange.emit(this._value);
  }
  _onInputClick(event) {
    // We have to stop propagation for click events on the visual hidden input element.
    // By default, when a user clicks on a label element, a generated click event will be
    // dispatched on the associated input element. Since we are using a label element as our
    // root container, the click event on the `radio-button` will be executed twice.
    // The real click event will bubble up, and the generated click event also tries to bubble up.
    // This will lead to multiple click events.
    // Preventing bubbling for the second event will solve that issue.
    event.stopPropagation();
  }
  /** Triggered when the radio button receives an interaction from the user. */
  _onInputInteraction(event) {
    // We always have to stop propagation on the change event.
    // Otherwise the change event, from the input element, will bubble up and
    // emit its event object to the `change` output.
    event.stopPropagation();
    if (!this.checked && !this.disabled) {
      const groupValueChanged = this.radioGroup && this.value !== this.radioGroup.value;
      this.checked = true;
      this._emitChangeEvent();
      if (this.radioGroup) {
        this.radioGroup._controlValueAccessorChangeFn(this.value);
        if (groupValueChanged) {
          this.radioGroup._emitChangeEvent();
        }
      }
    }
  }
  /** Sets the disabled state and marks for check if a change occurred. */
  _setDisabled(value) {
    if (this._disabled !== value) {
      this._disabled = value;
      this._changeDetector.markForCheck();
    }
  }
  /** Gets the tabindex for the underlying input element. */
  _updateTabIndex() {
    const group = this.radioGroup;
    let value;
    // Implement a roving tabindex if the button is inside a group. For most cases this isn't
    // necessary, because the browser handles the tab order for inputs inside a group automatically,
    // but we need an explicitly higher tabindex for the selected button in order for things like
    // the focus trap to pick it up correctly.
    if (!group || !group.selected || this.disabled) {
      value = this.tabIndex;
    } else {
      value = group.selected === this ? this.tabIndex : -1;
    }
    if (value !== this._previousTabIndex) {
      // We have to set the tabindex directly on the DOM node, because it depends on
      // the selected state which is prone to "changed after checked errors".
      const input = this._inputElement?.nativeElement;
      if (input) {
        input.setAttribute('tabindex', value + '');
        this._previousTabIndex = value;
      }
    }
  }
  static {
    this.ɵfac = function NeoRadioButtonComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoRadioButtonComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$3.FocusMonitor), i0.ɵɵdirectiveInject(i2$1.UniqueSelectionDispatcher), i0.ɵɵdirectiveInject(RadioGroup, 8), i0.ɵɵinjectAttribute('tabindex'));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NeoRadioButtonComponent,
      selectors: [["neo-radio-button"]],
      viewQuery: function NeoRadioButtonComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c2, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._inputElement = _t.first);
        }
      },
      hostVars: 5,
      hostBindings: function NeoRadioButtonComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("focus", function NeoRadioButtonComponent_focus_HostBindingHandler() {
            return ctx.forwardFocus();
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("id", ctx.id)("tabindex", ctx.unsetAccessibilityAttributes)("aria-label", ctx.unsetAccessibilityAttributes)("aria-labelledby", ctx.unsetAccessibilityAttributes)("aria-describedby", ctx.unsetAccessibilityAttributes);
        }
      },
      inputs: {
        id: "id",
        name: "name",
        ariaLabel: [0, "aria-label", "ariaLabel"],
        ariaLabelledby: [0, "aria-labelledby", "ariaLabelledby"],
        ariaDescribedby: [0, "aria-describedby", "ariaDescribedby"],
        tabIndex: [2, "tabIndex", "tabIndex", value => value === null ? 0 : numberAttribute(value)],
        checked: [2, "checked", "checked", booleanAttribute],
        value: "value",
        disabled: [2, "disabled", "disabled", booleanAttribute]
      },
      outputs: {
        valueChange: "valueChange"
      },
      exportAs: ["neoRadioButton"],
      features: [i0.ɵɵProvidersFeature([{
        provide: RadioButton,
        useExisting: NeoRadioButtonComponent
      }]), i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 7,
      vars: 11,
      consts: [["input", ""], [1, "neo-radio-label", 3, "for"], [1, "neo-radio"], ["type", "radio", 1, "neo-radio__native-control", 3, "change", "id", "checked", "disabled"], [1, "neo-radio__background"], [1, "neo-radio__inner-circle"]],
      template: function NeoRadioButtonComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "label", 1);
          i0.ɵɵprojection(1);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(2, "div", 2)(3, "input", 3, 0);
          i0.ɵɵlistener("change", function NeoRadioButtonComponent_Template_input_change_3_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx._onInputInteraction($event));
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "div", 4);
          i0.ɵɵelement(6, "div", 5);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("for", ctx.inputId);
          i0.ɵɵadvance(2);
          i0.ɵɵclassProp("mdc-radio--disabled", ctx.disabled);
          i0.ɵɵadvance();
          i0.ɵɵproperty("id", ctx.inputId)("checked", ctx.checked)("disabled", ctx.disabled);
          i0.ɵɵattribute("name", ctx.name)("value", ctx.value)("aria-label", ctx.ariaLabel)("aria-labelledby", ctx.ariaLabelledby)("aria-describedby", ctx.ariaDescribedby);
        }
      },
      styles: ["[_nghost-%COMP%]{display:flex;align-items:center;cursor:pointer;flex-direction:row-reverse;width:fit-content}[_nghost-%COMP%]:focus-visible{outline:none}.neo-radio-label[_ngcontent-%COMP%]{color:var(--theme-color-font);font-size:14px;font-weight:500;line-height:24px}.neo-radio[_ngcontent-%COMP%]{box-sizing:border-box;position:relative;flex:1 0 32px;width:32px;height:20px;padding-right:12px}.neo-radio__native-control[_ngcontent-%COMP%]{height:100%;width:100%;position:absolute;top:0;left:0;opacity:0;margin:0}.neo-radio__background[_ngcontent-%COMP%]{align-items:center;box-sizing:border-box;border-radius:50%;border:1px solid var(--neoGrayNeutral-300);background:var(--neoBase-white);display:flex;height:100%;justify-content:center;width:100%}.neo-radio__native-control[_ngcontent-%COMP%]:hover + .neo-radio__background[_ngcontent-%COMP%]{background-color:var(--neoYellow-25)}.neo-radio__native-control[_ngcontent-%COMP%]:checked + .neo-radio__background[_ngcontent-%COMP%]{border:1px solid var(--neoBase-black);background-color:var(--theme-color-secondary)}.neo-radio__native-control[_ngcontent-%COMP%]:checked + .neo-radio__background[_ngcontent-%COMP%]   .neo-radio__inner-circle[_ngcontent-%COMP%]{background-color:var(--neoBase-black);border-radius:4px;height:8px;width:8px}label[_ngcontent-%COMP%]:focus + .neo-radio[_ngcontent-%COMP%]   .neo-radio__background[_ngcontent-%COMP%], label[_ngcontent-%COMP%]:active + .neo-radio[_ngcontent-%COMP%]   .neo-radio__background[_ngcontent-%COMP%], .neo-radio__native-control[_ngcontent-%COMP%]:focus + .neo-radio__background[_ngcontent-%COMP%], .neo-radio__native-control[_ngcontent-%COMP%]:active + .neo-radio__background[_ngcontent-%COMP%]{outline:2px solid var(--neoBlue-300)}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoRadioButtonComponent, [{
    type: Component,
    args: [{
      selector: 'neo-radio-button',
      exportAs: 'neoRadioButton',
      changeDetection: ChangeDetectionStrategy.OnPush,
      providers: [{
        provide: RadioButton,
        useExisting: NeoRadioButtonComponent
      }],
      template: "<label class=\"neo-radio-label\" [for]=\"inputId\">\n    <ng-content></ng-content>\n</label>\n<div class=\"neo-radio\" [class.mdc-radio--disabled]=\"disabled\">\n    <input\n        #input\n        class=\"neo-radio__native-control\"\n        type=\"radio\"\n        [id]=\"inputId\"\n        [checked]=\"checked\"\n        [disabled]=\"disabled\"\n        [attr.name]=\"name\"\n        [attr.value]=\"value\"\n        [attr.aria-label]=\"ariaLabel\"\n        [attr.aria-labelledby]=\"ariaLabelledby\"\n        [attr.aria-describedby]=\"ariaDescribedby\"\n        (change)=\"_onInputInteraction($event)\"\n    />\n    <div class=\"neo-radio__background\">\n        <div class=\"neo-radio__inner-circle\"></div>\n    </div>\n</div>\n",
      styles: [":host{display:flex;align-items:center;cursor:pointer;flex-direction:row-reverse;width:fit-content}:host:focus-visible{outline:none}.neo-radio-label{color:var(--theme-color-font);font-size:14px;font-weight:500;line-height:24px}.neo-radio{box-sizing:border-box;position:relative;flex:1 0 32px;width:32px;height:20px;padding-right:12px}.neo-radio__native-control{height:100%;width:100%;position:absolute;top:0;left:0;opacity:0;margin:0}.neo-radio__background{align-items:center;box-sizing:border-box;border-radius:50%;border:1px solid var(--neoGrayNeutral-300);background:var(--neoBase-white);display:flex;height:100%;justify-content:center;width:100%}.neo-radio__native-control:hover+.neo-radio__background{background-color:var(--neoYellow-25)}.neo-radio__native-control:checked+.neo-radio__background{border:1px solid var(--neoBase-black);background-color:var(--theme-color-secondary)}.neo-radio__native-control:checked+.neo-radio__background .neo-radio__inner-circle{background-color:var(--neoBase-black);border-radius:4px;height:8px;width:8px}label:focus+.neo-radio .neo-radio__background,label:active+.neo-radio .neo-radio__background,.neo-radio__native-control:focus+.neo-radio__background,.neo-radio__native-control:active+.neo-radio__background{outline:2px solid var(--neoBlue-300)}\n"]
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i1$3.FocusMonitor
  }, {
    type: i2$1.UniqueSelectionDispatcher
  }, {
    type: RadioGroup,
    decorators: [{
      type: Optional
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Attribute,
      args: ['tabindex']
    }]
  }], {
    id: [{
      type: Input
    }, {
      type: HostBinding,
      args: ['attr.id']
    }],
    name: [{
      type: Input
    }],
    ariaLabel: [{
      type: Input,
      args: ['aria-label']
    }],
    ariaLabelledby: [{
      type: Input,
      args: ['aria-labelledby']
    }],
    ariaDescribedby: [{
      type: Input,
      args: ['aria-describedby']
    }],
    tabIndex: [{
      type: Input,
      args: [{
        transform: value => value === null ? 0 : numberAttribute(value)
      }]
    }],
    unsetAccessibilityAttributes: [{
      type: HostBinding,
      args: ['attr.tabindex']
    }, {
      type: HostBinding,
      args: ['attr.aria-label']
    }, {
      type: HostBinding,
      args: ['attr.aria-labelledby']
    }, {
      type: HostBinding,
      args: ['attr.aria-describedby']
    }],
    checked: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    value: [{
      type: Input
    }],
    disabled: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    valueChange: [{
      type: Output
    }],
    _inputElement: [{
      type: ViewChild,
      args: ['input']
    }],
    forwardFocus: [{
      type: HostListener,
      args: ['focus']
    }]
  });
})();
class NeoRadioGroupComponent extends RadioGroup {
  // Increasing integer for generating unique ids for radio components.
  static {
    this.nextUniqueId = 0;
  }
  /** Name of the radio button group. All radio buttons inside this group will use this name. */
  get name() {
    return this._name;
  }
  set name(value) {
    this._name = value;
    this._updateRadioButtonNames();
  }
  /**
   * Value for the radio-group. Should equal the value of the selected radio button if there is
   * a corresponding radio button with a matching value. If there is not such a corresponding
   * radio button, this value persists to be applied in case a new radio button is added with a
   * matching value.
   */
  get value() {
    return this._value;
  }
  set value(newValue) {
    if (this._value !== newValue) {
      // Set this before proceeding to ensure no circular loop occurs with selection.
      this._value = newValue;
      this._updateSelectedRadioFromValue();
      this._checkSelectedRadioButton();
    }
  }
  _checkSelectedRadioButton() {
    if (this._selected && !this._selected.checked) {
      this._selected.checked = true;
    }
  }
  /**
   * The currently selected radio button. If set to a new radio button, the radio group value
   * will be updated to match the new selected button.
   */
  get selected() {
    return this._selected;
  }
  set selected(selected) {
    this._selected = selected;
    this.value = selected ? selected.value : null;
    this._checkSelectedRadioButton();
  }
  /** Whether the radio group is disabled */
  get disabled() {
    return this._disabled;
  }
  set disabled(value) {
    this._disabled = value;
    this._markRadiosForCheck();
  }
  constructor(_changeDetector) {
    super();
    this._changeDetector = _changeDetector;
    /** Selected value for the radio group. */
    this._value = null;
    /** The HTML name attribute applied to radio buttons in this group. */
    this._name = `neo-radio-group-${NeoRadioGroupComponent.nextUniqueId++}`;
    /** The currently selected radio button. Should match value. */
    this._selected = null;
    /** Whether the `value` has been set to its initial value. */
    this._isInitialized = false;
    /** Whether the radio group is disabled. */
    this._disabled = false;
    this.role = 'radiogroup';
    /** The method to be called in order to update ngModel */
    this._controlValueAccessorChangeFn = () => {};
    /**
     * onTouch function registered via registerOnTouch (ControlValueAccessor).
     * @docs-private
     */
    this.onTouched = () => {};
    /**
     * Event emitted when the group value changes.
     * Change events are only emitted when the value changes due to user interaction with
     * a radio button (the same behavior as `<input type-"radio">`).
     */
    this.valueChange = new EventEmitter();
  }
  /**
   * Initialize properties once content children are available.
   * This allows us to propagate relevant attributes to associated buttons.
   */
  ngAfterContentInit() {
    // Mark this component as initialized in AfterContentInit because the initial value can
    // possibly be set by NgModel on RadioGroup, and it is possible that the OnInit of the
    // NgModel occurs *after* the OnInit of the RadioGroup.
    this._isInitialized = true;
    // Clear the `selected` button when it's destroyed since the tabindex of the rest of the
    // buttons depends on it. Note that we don't clear the `value`, because the radio button
    // may be swapped out with a similar one and there are some internal apps that depend on
    // that behavior.
    this._buttonChanges = this._radios.changes.subscribe(() => {
      if (this.selected && !this._radios.find(radio => radio === this.selected)) {
        this._selected = null;
      }
    });
  }
  ngOnDestroy() {
    this._buttonChanges?.unsubscribe();
  }
  /**
   * Mark this group as being "touched" (for ngModel). Meant to be called by the contained
   * radio buttons upon their blur.
   */
  _touch() {
    if (this.onTouched) {
      this.onTouched();
    }
  }
  _updateRadioButtonNames() {
    if (this._radios) {
      this._radios.forEach(radio => {
        radio.name = this.name;
        radio._markForCheck();
      });
    }
  }
  /** Updates the `selected` radio button from the internal _value state. */
  _updateSelectedRadioFromValue() {
    // If the value already matches the selected radio, do nothing.
    const isAlreadySelected = this._selected !== null && this._selected.value === this._value;
    if (this._radios && !isAlreadySelected) {
      this._selected = null;
      this._radios.forEach(radio => {
        radio.checked = this.value === radio.value;
        if (radio.checked) {
          this._selected = radio;
        }
      });
    }
  }
  /** Dispatch change event with current selection and group value. */
  _emitChangeEvent() {
    if (this._isInitialized) {
      this.valueChange.emit(this._value);
    }
  }
  _markRadiosForCheck() {
    if (this._radios) {
      this._radios.forEach(radio => radio._markForCheck());
    }
  }
  /**
   * Sets the model value. Implemented as part of ControlValueAccessor.
   * @param value
   */
  writeValue(value) {
    this.value = value;
    this._changeDetector.markForCheck();
  }
  /**
   * Registers a callback to be triggered when the model value changes.
   * Implemented as part of ControlValueAccessor.
   * @param fn Callback to be registered.
   */
  registerOnChange(fn) {
    this._controlValueAccessorChangeFn = fn;
  }
  /**
   * Registers a callback to be triggered when the control is touched.
   * Implemented as part of ControlValueAccessor.
   * @param fn Callback to be registered.
   */
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  /**
   * Sets the disabled state of the control. Implemented as a part of ControlValueAccessor.
   * @param isDisabled Whether the control should be disabled.
   */
  setDisabledState(isDisabled) {
    this.disabled = isDisabled;
    this._changeDetector.markForCheck();
  }
  static {
    this.ɵfac = function NeoRadioGroupComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoRadioGroupComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NeoRadioGroupComponent,
      selectors: [["neo-radio-group"]],
      contentQueries: function NeoRadioGroupComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, RadioButton, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._radios = _t);
        }
      },
      hostVars: 1,
      hostBindings: function NeoRadioGroupComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx.role);
        }
      },
      inputs: {
        name: "name",
        value: "value",
        selected: "selected",
        disabled: [2, "disabled", "disabled", booleanAttribute]
      },
      outputs: {
        valueChange: "valueChange"
      },
      exportAs: ["neoRadioGroup"],
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => NeoRadioGroupComponent),
        multi: true
      }, {
        provide: RadioGroup,
        useExisting: NeoRadioGroupComponent
      }]), i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function NeoRadioGroupComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoRadioGroupComponent, [{
    type: Component,
    args: [{
      selector: 'neo-radio-group',
      template: '<ng-content></ng-content>',
      exportAs: 'neoRadioGroup',
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => NeoRadioGroupComponent),
        multi: true
      }, {
        provide: RadioGroup,
        useExisting: NeoRadioGroupComponent
      }]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }], {
    role: [{
      type: HostBinding,
      args: ['attr.role']
    }],
    valueChange: [{
      type: Output
    }],
    _radios: [{
      type: ContentChildren,
      args: [RadioButton, {
        descendants: true
      }]
    }],
    name: [{
      type: Input
    }],
    value: [{
      type: Input
    }],
    selected: [{
      type: Input
    }],
    disabled: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }]
  });
})();
class NeoSelectButtonDirective {
  set selectListbox(selectListbox) {
    this._selectListbox = selectListbox;
    this.setupSelectListbox();
  }
  static {
    this.currentSelectId = 0;
  }
  get selectId() {
    return this.id || `select-button-${this._defaultSelectId.toString()}`;
  }
  get selectListboxId() {
    return this._selectListbox?.selectListboxId;
  }
  get isDisabled() {
    return this._selectListbox?.valueAccessor.isDisabled;
  }
  get tabindex() {
    return this.isDisabled || this.isExpanded ? -1 : 0;
  }
  touched() {
    this._selectListbox?.touched();
  }
  handleMouseDown() {
    this._clickIsExpandedTarget = !this.isExpanded;
  }
  handleClick() {
    this.toggleOptions(this._clickIsExpandedTarget);
  }
  handleKeydown(e) {
    if (e.code === 'ArrowDown') {
      this.toggleOptions(true);
      return;
    }
    if (e.code === 'Enter' || e.code === 'Space') {
      this.toggleOptions();
      e.preventDefault();
      return;
    }
    if (e.key.length === 1) {
      this.toggleOptions(true, e);
      return;
    }
  }
  constructor(_elementRef) {
    this._elementRef = _elementRef;
    this._defaultSelectId = ++NeoSelectButtonDirective.currentSelectId;
    this.isExpanded = false;
    this.role = 'combobox';
    this.autocomplete = 'none';
    this._selectListboxSubscription = Subscription.EMPTY;
  }
  ngOnDestroy() {
    this._selectListboxSubscription.unsubscribe();
  }
  async toggleOptions(force, keyboardEvent) {
    if (this.isDisabled) {
      return;
    }
    this.isExpanded = force === undefined ? !this.isExpanded : force;
    if (this.isExpanded) {
      await this._selectListbox?.open(this._elementRef, keyboardEvent);
    } else {
      await this._selectListbox?.close();
    }
  }
  async setupSelectListbox() {
    if (this.id) {
      this._selectListbox.id = this.id;
    }
    this._selectListboxSubscription.unsubscribe();
    this._selectListboxSubscription = new Subscription();
    this._selectListboxSubscription.add(this._selectListbox.isExpandedChange.subscribe(isExpanded => {
      this.isExpanded = isExpanded;
      if (!this.isExpanded) {
        this._elementRef.nativeElement.focus();
      }
    }));
  }
  static {
    this.ɵfac = function NeoSelectButtonDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoSelectButtonDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NeoSelectButtonDirective,
      selectors: [["", "neoSelectButton", ""]],
      hostVars: 7,
      hostBindings: function NeoSelectButtonDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("focusout", function NeoSelectButtonDirective_focusout_HostBindingHandler() {
            return ctx.touched();
          })("mousedown", function NeoSelectButtonDirective_mousedown_HostBindingHandler() {
            return ctx.handleMouseDown();
          })("click", function NeoSelectButtonDirective_click_HostBindingHandler() {
            return ctx.handleClick();
          })("keydown", function NeoSelectButtonDirective_keydown_HostBindingHandler($event) {
            return ctx.handleKeydown($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("id", ctx.selectId)("aria-controls", ctx.selectListboxId)("aria-disabled", ctx.isDisabled)("aria-expanded", ctx.isExpanded)("tabindex", ctx.tabindex)("role", ctx.role)("aria-autocomplete", ctx.autocomplete);
        }
      },
      inputs: {
        id: "id",
        selectListbox: "selectListbox"
      },
      exportAs: ["selectButton"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoSelectButtonDirective, [{
    type: Directive,
    args: [{
      selector: '[neoSelectButton]',
      exportAs: 'selectButton'
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    id: [{
      type: Input
    }],
    selectListbox: [{
      type: Input
    }],
    selectId: [{
      type: HostBinding,
      args: ['attr.id']
    }],
    selectListboxId: [{
      type: HostBinding,
      args: ['attr.aria-controls']
    }],
    isDisabled: [{
      type: HostBinding,
      args: ['attr.aria-disabled']
    }],
    isExpanded: [{
      type: HostBinding,
      args: ['attr.aria-expanded']
    }],
    tabindex: [{
      type: HostBinding,
      args: ['attr.tabindex']
    }],
    role: [{
      type: HostBinding,
      args: ['attr.role']
    }],
    autocomplete: [{
      type: HostBinding,
      args: ['attr.aria-autocomplete']
    }],
    touched: [{
      type: HostListener,
      args: ['focusout']
    }],
    handleMouseDown: [{
      type: HostListener,
      args: ['mousedown']
    }],
    handleClick: [{
      type: HostListener,
      args: ['click']
    }],
    handleKeydown: [{
      type: HostListener,
      args: ['keydown', ['$event']]
    }]
  });
})();
class NeoSelectButtonComponent {
  constructor(selectButton) {
    this.selectButton = selectButton;
    this.selectListbox = input.required();
    this._setSelectButtonListboxEffect = effect(() => {
      this.selectButton.selectListbox = this.selectListbox().selectListbox;
    });
    this._setupListboxValueSubscriptionsEffect = afterRenderEffect(onCleanup => {
      const selectListbox = this.selectListbox();
      const selectItem = this.selectItem();
      const subscription = this.setupListboxValueSubscription(selectListbox, selectItem);
      onCleanup(() => subscription.unsubscribe());
    });
    this.selectItem = computed(() => {
      return this.selectListbox().selectItemDirective();
    });
  }
  setupListboxValueSubscription(selectListbox, selectItem) {
    const valueAccessor = selectListbox.selectListbox.valueAccessor;
    const value$ = merge(valueAccessor.valueChange, valueAccessor.modelToViewValueChange).pipe(startWith(valueAccessor.value));
    const items = selectItem.neoSelectItemOf();
    return value$.subscribe(value => {
      // Get the current value that we should show on the button.
      // We have to look up the value from the list of items
      // because it could be different because of the valueKey.
      if (selectListbox.valueKey) {
        this.value = items.find(item => selectListbox.getValue(item) === value);
      } else {
        this.value = value;
      }
    });
  }
  static {
    this.ɵfac = function NeoSelectButtonComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoSelectButtonComponent)(i0.ɵɵdirectiveInject(NeoSelectButtonDirective));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NeoSelectButtonComponent,
      selectors: [["neo-select-button"]],
      hostVars: 1,
      hostBindings: function NeoSelectButtonComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("aria-label", ctx.placeholder);
        }
      },
      inputs: {
        placeholder: "placeholder",
        selectListbox: [1, "selectListbox"]
      },
      features: [i0.ɵɵHostDirectivesFeature([{
        directive: NeoSelectButtonDirective,
        inputs: ["id", "id"]
      }])],
      ngContentSelectors: _c0,
      decls: 3,
      vars: 2,
      consts: [[1, "select-placeholder"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]],
      template: function NeoSelectButtonComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, NeoSelectButtonComponent_Conditional_0_Template, 2, 1, "span", 0)(1, NeoSelectButtonComponent_Conditional_1_Template, 1, 6, "ng-container");
          i0.ɵɵprojection(2);
        }
        if (rf & 2) {
          i0.ɵɵconditional(!ctx.value ? 0 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.value && ctx.selectItem() ? 1 : -1);
        }
      },
      dependencies: [CommonModule, i1.NgTemplateOutlet],
      styles: ["[_nghost-%COMP%]{align-items:center;display:flex;justify-content:space-between;outline:0;font-size:16px;font-weight:400;line-height:24px;color:var(--neo-input-color)}.select-placeholder[_ngcontent-%COMP%]{color:var(--neo-input-placeholder-color)}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoSelectButtonComponent, [{
    type: Component,
    args: [{
      selector: 'neo-select-button',
      imports: [CommonModule],
      hostDirectives: [{
        directive: NeoSelectButtonDirective,
        inputs: ['id']
      }],
      template: "@if (!value) {\n    <span class=\"select-placeholder\">{{ placeholder }}</span>\n}\n@if (value && selectItem()) {\n    <ng-container\n        *ngTemplateOutlet=\"\n            selectItem()!.templateRef;\n            context: {\n                $implicit: value,\n                item: value,\n                isPanel: true,\n                isOpen: selectButton.isExpanded,\n                first: false,\n                last: false\n            }\n        \"\n    ></ng-container>\n}\n<ng-content></ng-content>\n",
      styles: [":host{align-items:center;display:flex;justify-content:space-between;outline:0;font-size:16px;font-weight:400;line-height:24px;color:var(--neo-input-color)}.select-placeholder{color:var(--neo-input-placeholder-color)}\n"]
    }]
  }], () => [{
    type: NeoSelectButtonDirective
  }], {
    placeholder: [{
      type: HostBinding,
      args: ['attr.aria-label']
    }, {
      type: Input
    }]
  });
})();
class NeoBasicValueAccessorDirective {
  constructor() {
    this.valueChange = new EventEmitter();
    this.modelToViewValueChange = new EventEmitter();
    this.isDisabled$ = new BehaviorSubject(false);
  }
  set isDisabled(isDisabled) {
    this.isDisabled$.next(isDisabled);
  }
  get isDisabled() {
    return this.isDisabled$.value;
  }
  ngOnChanges(changes) {
    if (changes['value']) {
      this.modelToViewValueChange.emit(this.value);
    }
  }
  setValue(value) {
    this.value = value;
    this._propagateChange?.(value);
    this.valueChange.emit(value);
  }
  touch() {
    this._propagateTouch?.();
  }
  writeValue(value) {
    this.value = value;
    this.modelToViewValueChange.emit(value);
  }
  registerOnChange(fn) {
    this._propagateChange = fn;
  }
  registerOnTouched(fn) {
    this._propagateTouch = fn;
  }
  setDisabledState(isDisabled) {
    this.isDisabled = isDisabled;
  }
  static {
    this.ɵfac = function NeoBasicValueAccessorDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoBasicValueAccessorDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NeoBasicValueAccessorDirective,
      selectors: [["", "neoBasicValueAccessor", ""]],
      inputs: {
        value: "value",
        isDisabled: "isDisabled"
      },
      outputs: {
        valueChange: "valueChange"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => NeoBasicValueAccessorDirective),
        multi: true
      }]), i0.ɵɵNgOnChangesFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoBasicValueAccessorDirective, [{
    type: Directive,
    args: [{
      selector: '[neoBasicValueAccessor]',
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => NeoBasicValueAccessorDirective),
        multi: true
      }]
    }]
  }], null, {
    value: [{
      type: Input
    }],
    valueChange: [{
      type: Output
    }],
    isDisabled: [{
      type: Input
    }]
  });
})();
class NeoSelectListboxAnimationDirective {
  constructor(_animationBuilder, _elementRef, _renderer) {
    this._animationBuilder = _animationBuilder;
    this._elementRef = _elementRef;
    this._renderer = _renderer;
    this._animationTarget = this._elementRef;
    this.closedStyle = {
      maxHeight: 0
    };
    this.hiddenStyle = {
      display: 'none'
    };
    // We need exact pixels so the animation doesn't jump
    this.openStyle = {
      maxHeight: '{{ maxHeight }}'
    };
    this.openInitialStyle = {
      maxHeight: '*'
    };
    this.visibleStyle = {
      display: '*'
    };
    this.slideInAnimationPlayerFactory = this._animationBuilder.build([style(this.closedStyle), animate('.2s ease-in', style(this.openStyle))]);
    this.slideOutAnimationPlayerFactory = this._animationBuilder.build([style(this.openStyle), animate('.2s ease-out', style(this.closedStyle))]);
    this.saveOpenInitialStyle();
    this.setClosedStyles();
  }
  async open(prepareAnimationArea) {
    if (this._isExpanded) {
      return this.openAnimationPromise;
    }
    this._isExpanded = true;
    return this.runOpenAnimation(prepareAnimationArea);
  }
  async close(skipAnimations = false) {
    if (!this._isExpanded) {
      return this.closeAnimationPromise;
    }
    this._isExpanded = false;
    if (skipAnimations) {
      this.setClosedStyles();
    } else {
      return this.runCloseAnimation();
    }
  }
  setAnimationTarget(animationTarget) {
    // Remove styles from old animationTarget first
    this.setOpenStyles();
    this._animationTarget = animationTarget ?? this._elementRef;
    this.saveOpenInitialStyle();
    this.setClosedStyles();
  }
  runCloseAnimation() {
    const animationTargetRect = this._animationTarget.nativeElement.getBoundingClientRect();
    const slideOutAnimationPlayer = this.slideOutAnimationPlayerFactory.create(this._animationTarget.nativeElement, {
      params: {
        maxHeight: animationTargetRect.height + 'px'
      }
    });
    this.closeAnimationPromise = new Promise(resolve => {
      slideOutAnimationPlayer.onDone(() => {
        slideOutAnimationPlayer.destroy();
        this.setClosedStyles();
        this.closeAnimationPromise = undefined;
        resolve();
      });
      slideOutAnimationPlayer.play();
    });
    return this.closeAnimationPromise;
  }
  async runOpenAnimation(prepareAnimationArea) {
    this.setOpenStyles();
    // Hide overflow so the scrollbar appearing and disappearing doesn't cause jumps
    if (this._animationTarget.nativeElement.scrollHeight === this._animationTarget.nativeElement.clientHeight) {
      this._renderer.setStyle(this._animationTarget.nativeElement, 'overflow', 'hidden');
    } else {
      this._renderer.removeStyle(this._animationTarget.nativeElement, 'overflow');
    }
    const animationTargetRect = this._animationTarget.nativeElement.getBoundingClientRect();
    const positionChange = await prepareAnimationArea?.(animationTargetRect, this._animationTarget);
    if (positionChange) {
      if (positionChange.connectionPair.overlayY === 'bottom') {
        this.setStyle({
          position: 'absolute',
          bottom: 0
        });
      } else {
        this.setStyle({
          position: '*',
          bottom: '*'
        });
      }
    }
    const slideInAnimationPlayer = this.slideInAnimationPlayerFactory.create(this._animationTarget.nativeElement, {
      params: {
        maxHeight: animationTargetRect.height + 'px'
      }
    });
    this.openAnimationPromise = new Promise(resolve => {
      slideInAnimationPlayer.onDone(() => {
        slideInAnimationPlayer.destroy();
        this.openAnimationPromise = undefined;
        resolve();
      });
      slideInAnimationPlayer.play();
    });
    return this.openAnimationPromise;
  }
  setStyle(styl, targetElement = this._animationTarget) {
    for (const [key, value] of Object.entries(styl)) {
      if (value === '*') {
        this._renderer.removeStyle(targetElement.nativeElement, key);
      } else {
        this._renderer.setStyle(targetElement.nativeElement, key, value);
      }
    }
  }
  setOpenStyles() {
    this.setStyle({
      ...this.openInitialStyle,
      ...this.visibleStyle
    });
  }
  setClosedStyles() {
    this.setStyle({
      ...this.closedStyle,
      ...this.hiddenStyle
    });
  }
  saveOpenInitialStyle() {
    const styles = window.getComputedStyle(this._animationTarget.nativeElement);
    const maxHeight = styles.maxHeight;
    this.openInitialStyle = {
      maxHeight
    };
  }
  static {
    this.ɵfac = function NeoSelectListboxAnimationDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoSelectListboxAnimationDirective)(i0.ɵɵdirectiveInject(i1$4.AnimationBuilder), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NeoSelectListboxAnimationDirective,
      selectors: [["", "neoSelectListboxAnimation", ""]]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoSelectListboxAnimationDirective, [{
    type: Directive,
    args: [{
      selector: '[neoSelectListboxAnimation]'
    }]
  }], () => [{
    type: i1$4.AnimationBuilder
  }, {
    type: i0.ElementRef
  }, {
    type: i0.Renderer2
  }], null);
})();

/**
 * Strategy that will close the overlay when the user starts scrolling.
 *
 * This is a copy of the CloseScrollStrategy without a threshold and with the added beforeDetach command
 * We need to hide the dropdown before we detach the overlay otherwise the listbox get reattached to the dom
 * before being hidden and that causes scroll jumps
 */
class SelectListboxScrollStrategy {
  constructor(_scrollDispatcher, _ngZone, _config) {
    this._scrollDispatcher = _scrollDispatcher;
    this._ngZone = _ngZone;
    this._config = _config;
    this._scrollSubscription = null;
    /** Detaches the overlay ref and disables the scroll strategy. */
    this._detach = () => {
      this.disable();
      if (this._overlayRef.hasAttached()) {
        this._ngZone.run(async () => {
          await this._config?.beforeDetach();
          this._overlayRef.detach();
        });
      }
    };
  }
  /** Attaches this scroll strategy to an overlay. */
  attach(overlayRef) {
    this._overlayRef = overlayRef;
  }
  /** Enables the closing of the attached overlay on scroll. */
  enable() {
    if (this._scrollSubscription) {
      return;
    }
    const stream = this._scrollDispatcher.scrolled(0).pipe(filter(scrollable => {
      return !scrollable || !this._overlayRef.overlayElement.contains(scrollable.getElementRef().nativeElement);
    }));
    this._scrollSubscription = stream.subscribe(this._detach);
  }
  /** Disables the closing the attached overlay on scroll. */
  disable() {
    if (this._scrollSubscription) {
      this._scrollSubscription.unsubscribe();
      this._scrollSubscription = null;
    }
  }
  detach() {
    this.disable();
    this._overlayRef = null;
  }
}
class SelectListboxScrollStrategyFactory {
  constructor(_scrollDispatcher, _ngZone) {
    this._scrollDispatcher = _scrollDispatcher;
    this._ngZone = _ngZone;
  }
  create(config) {
    return new SelectListboxScrollStrategy(this._scrollDispatcher, this._ngZone, config);
  }
  static {
    this.ɵfac = function SelectListboxScrollStrategyFactory_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SelectListboxScrollStrategyFactory)(i0.ɵɵinject(i1$5.ScrollDispatcher), i0.ɵɵinject(i0.NgZone));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SelectListboxScrollStrategyFactory,
      factory: SelectListboxScrollStrategyFactory.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectListboxScrollStrategyFactory, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1$5.ScrollDispatcher
  }, {
    type: i0.NgZone
  }], null);
})();
class NeoSelectListboxDirective {
  static {
    this.currentSelectListboxId = 0;
  }
  get selectListboxId() {
    return 'select-listbox-' + (this.id || this._defaultSelectListboxId.toString());
  }
  get _listboxValue() {
    const value = this.valueAccessor.value;
    if (value === undefined || value === null) {
      return [];
    } else {
      return [value];
    }
  }
  set isExpanded(isExpanded) {
    this._isExpanded$.next(isExpanded);
  }
  get isExpanded() {
    return this._isExpanded$.value;
  }
  get isClosed() {
    return !this.isExpanded;
  }
  set overlayContainer(overlayContainer) {
    this._overlayContainer = overlayContainer;
    this._selectListboxAnimationDirective.setAnimationTarget(this.overlayContent);
  }
  get overlayContainer() {
    return this._overlayContainer;
  }
  get overlayContent() {
    return this.overlayContainer ?? this._elementRef;
  }
  handleFocusOut(e) {
    if (!this.isElementInside(e.relatedTarget)) {
      this.close();
    }
    this.touched();
  }
  handleClick() {
    this.close();
  }
  handleKeydown(e) {
    if (e.code === 'Enter' || e.code === 'Space' || e.code === 'Escape' || e.code === 'NumpadEnter') {
      this.close();
      e.preventDefault();
      return;
    }
  }
  constructor(_listbox, valueAccessor, _elementRef, _selectListboxAnimationDirective, _overlay, _scrollStrategyFactory) {
    this._listbox = _listbox;
    this.valueAccessor = valueAccessor;
    this._elementRef = _elementRef;
    this._selectListboxAnimationDirective = _selectListboxAnimationDirective;
    this._overlay = _overlay;
    this._scrollStrategyFactory = _scrollStrategyFactory;
    this._defaultSelectListboxId = ++NeoSelectListboxDirective.currentSelectListboxId;
    /**
     * Not required when there are items with custom templates.
     */
    this.items = [];
    this.isExpandedChange = new EventEmitter();
    this._isExpanded$ = new BehaviorSubject(false);
    this.trackBy = item => {
      if (!this.key) {
        return item;
      } else if (typeof this.key === 'function') {
        return this.key(item);
      } else {
        return item[this.key];
      }
    };
    this._compareWith = (o1, o2) => {
      if (this.compareWith) {
        return this.compareWith(o1, o2);
      } else {
        return this.trackBy(o1) === this.trackBy(o2);
      }
    };
    this._typeaheadLabel = item => {
      if (this.typeaheadLabel === null) {
        return '';
      } else if (!this.typeaheadLabel) {
        return null;
      } else if (typeof this.typeaheadLabel === 'function') {
        return this.typeaheadLabel(item);
      } else {
        return item[this.typeaheadLabel];
      }
    };
    this.showListboxInOverlay = true;
    this._scrollStrategy = this._scrollStrategyFactory.create({
      beforeDetach: () => this.close(true)
    });
    this._preventDetach = false;
    this._componentDestroyed$ = new Subject();
    this._listbox.valueChange.pipe(takeUntil(this._componentDestroyed$)).subscribe(event => {
      this.valueAccessor.setValue(event.option?.value);
    });
    this.valueAccessor.modelToViewValueChange.pipe(
    // If the options and the value is set in the same macrotask then the listbox might throw an error.
    // So if the options are not yet available we assume that they will be and we delay forwarding the
    // value to the listbox to the next macrotask. If that still throws then the options and the value
    // are not in sync and should be synchronized.
    switchMap(value => this.options?.length ? of(value) : timer(0)), takeUntil(this._componentDestroyed$)).subscribe(() => {
      this._listbox.writeValue(this._listboxValue);
    });
    combineLatest([this.valueAccessor.isDisabled$, this._isExpanded$]).pipe(takeUntil(this._componentDestroyed$)).subscribe(([isDisabled, isExpanded]) => this._listbox.setDisabledState(isDisabled || !isExpanded));
    this._listbox.compareWith = this._compareWith;
  }
  ngOnChanges(changes) {
    if (changes['showListboxInOverlay'] && !this.showListboxInOverlay) {
      this.teardownOverlay();
    }
  }
  ngOnDestroy() {
    this._componentDestroyed$.next();
    this.teardownOverlay();
  }
  async open(opener, keyboardEvent) {
    if (this.showListboxInOverlay) {
      this.setupOverlay(opener);
    }
    this.isExpandedChange.emit(true);
    this.isExpanded = true;
    this.attachOverlay();
    await this._selectListboxAnimationDirective.open(animationTargetRect => {
      const positionChange = this._positionStrategy ? firstValueFrom(this._positionStrategy.positionChanges) : Promise.resolve(null);
      this._overlayRef?.updateSize({
        height: animationTargetRect.height
      });
      this.setupInitialListboxActiveItem(keyboardEvent);
      return positionChange;
    });
  }
  async close(skipAnimations = false) {
    this.isExpandedChange.emit(false);
    this.isExpanded = false;
    await this._selectListboxAnimationDirective.close(skipAnimations);
    if (this._preventDetach) {
      this._preventDetach = false;
      return;
    }
    this._overlayRef?.detach();
  }
  touched() {
    this.valueAccessor.touch();
  }
  setupInitialListboxActiveItem(keyboardEvent) {
    this._listbox.focus();
    this._elementRef.nativeElement.scroll(0, 0);
    if (keyboardEvent) {
      const eventCopy = new KeyboardEvent(keyboardEvent.type, keyboardEvent);
      this._elementRef.nativeElement.dispatchEvent(eventCopy);
    } else {
      this.selectValueOption();
    }
  }
  selectValueOption() {
    const selectedOption = this.options.find(option => option.value === this._listbox.value[0]);
    if (selectedOption) {
      this._elementRef.nativeElement.scroll(0, selectedOption.element.offsetTop);
      this._listbox._setActiveOption(selectedOption);
    } else if (this.options.length) {
      this._listbox._setActiveOption(this.options.get(0));
    }
  }
  isElementInside(element) {
    return this._elementRef.nativeElement.contains(element);
  }
  attachOverlay() {
    if (this._overlayRef) {
      const openerRect = this._opener.nativeElement.getBoundingClientRect();
      this._overlayRef.updateSize({
        height: '100%',
        minWidth: openerRect.width
      });
      const selectListboxPortal = new DomPortal(this.overlayContent);
      if (this._overlayRef.hasAttached()) {
        // This is an edge case where the closing animation is still running but we open
        this._preventDetach = true;
      } else {
        this._overlayRef.attach(selectListboxPortal);
      }
      // Force sync updatePosition otherwise it is 1px high and wide in this event loop
      this._overlayRef.updatePosition();
    }
  }
  setupOverlay(opener) {
    if (this._opener !== opener) {
      this.teardownOverlay();
      this._opener = opener;
    } else {
      return;
    }
    this._positionStrategy = this._overlay.position().flexibleConnectedTo(this._opener).withFlexibleDimensions(false).withPositions(STANDARD_DROPDOWN_BELOW_POSITIONS.map(position => ({
      ...position,
      offsetY: position.originY === 'bottom' ? 8 : -8
    })));
    const openerRect = this._opener.nativeElement.getBoundingClientRect();
    this._overlayRef = this._overlay.create({
      positionStrategy: this._positionStrategy,
      scrollStrategy: this._scrollStrategy,
      minWidth: openerRect.width
    });
  }
  teardownOverlay() {
    this._overlayRef?.detach();
    this._overlayRef?.dispose();
    this._overlayRef = undefined;
    this._positionStrategy?.detach();
    this._positionStrategy?.dispose();
    this._positionStrategy = undefined;
    this._opener = undefined;
  }
  static {
    this.ɵfac = function NeoSelectListboxDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoSelectListboxDirective)(i0.ɵɵdirectiveInject(i1$6.CdkListbox), i0.ɵɵdirectiveInject(NeoBasicValueAccessorDirective), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(NeoSelectListboxAnimationDirective), i0.ɵɵdirectiveInject(i1$5.Overlay), i0.ɵɵdirectiveInject(SelectListboxScrollStrategyFactory));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NeoSelectListboxDirective,
      selectors: [["", "neoSelectListbox", ""]],
      contentQueries: function NeoSelectListboxDirective_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, CdkOption, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.options = _t);
        }
      },
      hostVars: 2,
      hostBindings: function NeoSelectListboxDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("focusout", function NeoSelectListboxDirective_focusout_HostBindingHandler($event) {
            return ctx.handleFocusOut($event);
          })("click", function NeoSelectListboxDirective_click_HostBindingHandler() {
            return ctx.handleClick();
          })("keydown", function NeoSelectListboxDirective_keydown_HostBindingHandler($event) {
            return ctx.handleKeydown($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("id", ctx.selectListboxId)("aria-hidden", ctx.isClosed);
        }
      },
      inputs: {
        items: "items",
        key: "key",
        compareWith: "compareWith",
        typeaheadLabel: "typeaheadLabel",
        showListboxInOverlay: [2, "showListboxInOverlay", "showListboxInOverlay", booleanAttribute],
        overlayContainer: "overlayContainer"
      },
      outputs: {
        isExpandedChange: "isExpandedChange"
      },
      exportAs: ["selectListbox"],
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵHostDirectivesFeature([{
        directive: NeoBasicValueAccessorDirective,
        inputs: ["value", "value", "isDisabled", "isDisabled"],
        outputs: ["valueChange", "valueChange"]
      }, NeoSelectListboxAnimationDirective, i1$6.CdkListbox]), i0.ɵɵNgOnChangesFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoSelectListboxDirective, [{
    type: Directive,
    args: [{
      selector: '[neoSelectListbox]',
      exportAs: 'selectListbox',
      hostDirectives: [{
        directive: NeoBasicValueAccessorDirective,
        inputs: ['value', 'isDisabled'],
        outputs: ['valueChange']
      }, NeoSelectListboxAnimationDirective, CdkListbox]
    }]
  }], () => [{
    type: i1$6.CdkListbox
  }, {
    type: NeoBasicValueAccessorDirective
  }, {
    type: i0.ElementRef
  }, {
    type: NeoSelectListboxAnimationDirective
  }, {
    type: i1$5.Overlay
  }, {
    type: SelectListboxScrollStrategyFactory
  }], {
    selectListboxId: [{
      type: HostBinding,
      args: ['attr.id']
    }],
    items: [{
      type: Input
    }],
    isExpandedChange: [{
      type: Output
    }],
    isClosed: [{
      type: HostBinding,
      args: ['attr.aria-hidden']
    }],
    key: [{
      type: Input
    }],
    compareWith: [{
      type: Input
    }],
    typeaheadLabel: [{
      type: Input
    }],
    showListboxInOverlay: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    overlayContainer: [{
      type: Input
    }],
    handleFocusOut: [{
      type: HostListener,
      args: ['focusout', ['$event']]
    }],
    handleClick: [{
      type: HostListener,
      args: ['click']
    }],
    handleKeydown: [{
      type: HostListener,
      args: ['keydown', ['$event']]
    }],
    options: [{
      type: ContentChildren,
      args: [CdkOption]
    }]
  });
})();
class NeoSelectListboxItemDirective {
  set neoSelectListboxItem(selectItem) {
    this._selectItem = selectItem;
    this._cdkOption.value = selectItem;
    this._cdkOption.typeaheadLabel = this._selectListboxDirective._typeaheadLabel(selectItem);
  }
  get neoSelectListboxItem() {
    return this._selectItem;
  }
  handleKeydown(e) {
    if (e.code === 'Tab') {
      this._elementRef.nativeElement.dispatchEvent(new KeyboardEvent('keydown', {
        keyCode: 32,
        code: 'Space',
        bubbles: true
      }));
      return;
    }
  }
  get id() {
    const trackByValue = this._selectListboxDirective.trackBy(this.neoSelectListboxItem);
    if (trackByValue.toString === Object.prototype.toString) {
      return null;
    }
    return NeoSelectListboxItemDirective.createId(this._selectListboxDirective.selectListboxId, trackByValue.toString());
  }
  static createId(listboxId, listItemId) {
    return `${listboxId}-item-${listItemId}`;
  }
  constructor(_elementRef, _selectListboxDirective, _cdkOption) {
    this._elementRef = _elementRef;
    this._selectListboxDirective = _selectListboxDirective;
    this._cdkOption = _cdkOption;
    this.listboxItemKlass = true;
  }
  static {
    this.ɵfac = function NeoSelectListboxItemDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoSelectListboxItemDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(NeoSelectListboxDirective), i0.ɵɵdirectiveInject(i1$6.CdkOption));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NeoSelectListboxItemDirective,
      selectors: [["", "neoSelectListboxItem", ""]],
      hostVars: 3,
      hostBindings: function NeoSelectListboxItemDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keydown", function NeoSelectListboxItemDirective_keydown_HostBindingHandler($event) {
            return ctx.handleKeydown($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("id", ctx.id);
          i0.ɵɵclassProp("select-listbox-item", ctx.listboxItemKlass);
        }
      },
      inputs: {
        neoSelectListboxItem: "neoSelectListboxItem"
      },
      features: [i0.ɵɵHostDirectivesFeature([i1$6.CdkOption])]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoSelectListboxItemDirective, [{
    type: Directive,
    args: [{
      selector: '[neoSelectListboxItem]',
      hostDirectives: [CdkOption]
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: NeoSelectListboxDirective
  }, {
    type: i1$6.CdkOption
  }], {
    neoSelectListboxItem: [{
      type: Input
    }],
    handleKeydown: [{
      type: HostListener,
      args: ['keydown', ['$event']]
    }],
    id: [{
      type: HostBinding,
      args: ['attr.id']
    }],
    listboxItemKlass: [{
      type: HostBinding,
      args: ['class.select-listbox-item']
    }]
  });
})();
class NeoSelectItemDirective {
  static ngTemplateContextGuard(dir, context) {
    return true;
  }
  constructor(templateRef) {
    this.templateRef = templateRef;
    this.neoSelectItemOf = input.required();
  }
  static {
    this.ɵfac = function NeoSelectItemDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoSelectItemDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NeoSelectItemDirective,
      selectors: [["", "neoSelectItem", ""]],
      inputs: {
        neoSelectItemOf: [1, "neoSelectItemOf"]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoSelectItemDirective, [{
    type: Directive,
    args: [{
      selector: '[neoSelectItem]'
    }]
  }], () => [{
    type: i0.TemplateRef
  }], null);
})();
class NeoSelectListboxComponent {
  constructor(_elementRef) {
    this._elementRef = _elementRef;
    /**
     * Not required when there are items with custom templates.
     */
    this.items = [];
    /**
     * This should be turned off when the default hover, selected highlight is not appropriate.
     */
    this.useDefaultHighlights = true;
    this.showListboxInOverlay = true;
    // In this part we are selecting the select item template and items to use.
    this.childSelectItem = contentChild(NeoSelectItemDirective);
    this.selectItem = input();
    this.defaultSelectItem = viewChild.required(NeoSelectItemDirective);
    this.selectItemDirective = computed(() => {
      const childSelectItem = this.childSelectItem();
      const selectItem = this.selectItem();
      const defaultSelectItem = this.defaultSelectItem();
      return childSelectItem || selectItem || defaultSelectItem;
    });
    this.getLabel = item => item;
    this.getValue = item => item;
  }
  ngOnChanges(changes) {
    if (changes['labelKey']) {
      if (!this.labelKey) {
        this.getLabel = item => item;
      }
      const type = typeof this.labelKey;
      if (type === 'string') {
        this.getLabel = item => item[this.labelKey];
      }
      if (typeof this.labelKey === 'function') {
        this.getLabel = item => this.labelKey(item);
      }
    }
    if (changes['valueKey']) {
      if (!this.valueKey) {
        this.getValue = item => item;
      }
      const type = typeof this.valueKey;
      if (type === 'string') {
        this.getValue = item => item[this.valueKey];
      }
      if (typeof this.valueKey === 'function') {
        this.getValue = item => this.valueKey(item);
      }
    }
  }
  writeValue(obj) {
    this.selectListbox.valueAccessor.writeValue(obj);
  }
  registerOnChange(fn) {
    this.selectListbox.valueAccessor.registerOnChange(fn);
  }
  registerOnTouched(fn) {
    this.selectListbox.valueAccessor.registerOnTouched(fn);
  }
  setDisabledState(isDisabled) {
    this.selectListbox.valueAccessor.setDisabledState(isDisabled);
  }
  static {
    this.ɵfac = function NeoSelectListboxComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoSelectListboxComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NeoSelectListboxComponent,
      selectors: [["neo-select-listbox"]],
      contentQueries: function NeoSelectListboxComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.childSelectItem, NeoSelectItemDirective, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
        }
      },
      viewQuery: function NeoSelectListboxComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuerySignal(ctx.defaultSelectItem, NeoSelectItemDirective, 5);
          i0.ɵɵviewQuery(NeoSelectListboxDirective, 7);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.selectListbox = _t.first);
        }
      },
      inputs: {
        items: "items",
        key: "key",
        labelKey: "labelKey",
        valueKey: "valueKey",
        useDefaultHighlights: "useDefaultHighlights",
        showListboxInOverlay: [2, "showListboxInOverlay", "showListboxInOverlay", booleanAttribute],
        selectItem: [1, "selectItem"]
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        multi: true,
        useExisting: forwardRef(() => NeoSelectListboxComponent)
      }]), i0.ɵɵInputTransformsFeature, i0.ɵɵNgOnChangesFeature],
      decls: 3,
      vars: 5,
      consts: [["option", "cdkOption"], ["class", "select-listbox-item--default", 4, "neoSelectItem", "neoSelectItemOf"], ["neoSelectListbox", "", 3, "key", "overlayContainer", "showListboxInOverlay"], [1, "select-listbox-item--default"], ["name", "neo-check", "size", "20"], [3, "neoSelectListboxItem", "default-highlight"], [3, "neoSelectListboxItem"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]],
      template: function NeoSelectListboxComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, NeoSelectListboxComponent_div_0_Template, 4, 2, "div", 1);
          i0.ɵɵelementStart(1, "ul", 2);
          i0.ɵɵtemplate(2, NeoSelectListboxComponent_Conditional_2_Template, 2, 0);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          let tmp_4_0;
          i0.ɵɵproperty("neoSelectItemOf", ctx.items);
          i0.ɵɵadvance();
          i0.ɵɵproperty("key", ctx.valueKey ? undefined : ctx.key)("overlayContainer", ctx._elementRef)("showListboxInOverlay", ctx.showListboxInOverlay);
          i0.ɵɵadvance();
          i0.ɵɵconditional((tmp_4_0 = ctx.selectItemDirective()) ? 2 : -1, tmp_4_0);
        }
      },
      dependencies: [CommonModule, i1.NgTemplateOutlet, NeoSelectListboxDirective, NeoSelectListboxItemDirective, NeoSelectItemDirective, NeoIconComponent],
      styles: ["[_nghost-%COMP%]{display:block;overflow-y:auto;width:100%;align-self:start;max-height:min(100%,320px)}ul[_ngcontent-%COMP%]{list-style:none;position:relative;margin:0;padding:0}li[_ngcontent-%COMP%]{cursor:pointer;outline:none;padding:10px 14px;font-size:16px;font-weight:400;line-height:24px;color:var(--theme-color-font)}li.default-highlight[aria-selected=true][_ngcontent-%COMP%]{background-color:var(--neoGrayNeutral-25)}li.default-highlight[_ngcontent-%COMP%]:hover, li.default-highlight[_ngcontent-%COMP%]:focus-visible{background-color:var(--neoLightblue-main)}.select-listbox-item--default[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoSelectListboxComponent, [{
    type: Component,
    args: [{
      selector: 'neo-select-listbox',
      imports: [CommonModule, NeoSelectListboxDirective, NeoSelectListboxItemDirective, NeoSelectItemDirective, NeoIconComponent],
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        multi: true,
        useExisting: forwardRef(() => NeoSelectListboxComponent)
      }],
      template: "<div\n    *neoSelectItem=\"let item of items; let isSelected = isSelected; let isPanel = isPanel\"\n    class=\"select-listbox-item--default\"\n>\n    <span>{{ getLabel(item) }}</span>\n    @if (!isPanel && isSelected) {\n        <neo-icon name=\"neo-check\" size=\"20\"></neo-icon>\n    }\n</div>\n\n<ul\n    neoSelectListbox\n    [key]=\"valueKey ? undefined : key\"\n    [overlayContainer]=\"_elementRef\"\n    [showListboxInOverlay]=\"showListboxInOverlay\"\n>\n    @if (selectItemDirective(); as selectItemDirective) {\n        @for (\n            item of selectItemDirective.neoSelectItemOf();\n            track selectListbox.trackBy(getValue(item));\n            let first = $first, last = $last, index = $index\n        ) {\n            <li\n                [neoSelectListboxItem]=\"getValue(item)\"\n                #option=\"cdkOption\"\n                [class.default-highlight]=\"useDefaultHighlights\"\n            >\n                <ng-container\n                    *ngTemplateOutlet=\"\n                        selectItemDirective.templateRef;\n                        context: {\n                            $implicit: item,\n                            item: item,\n                            isPanel: false,\n                            isSelected: option.isSelected(),\n                            isActive: option.isActive(),\n                            first: first,\n                            last: last\n                        }\n                    \"\n                ></ng-container>\n            </li>\n        }\n    }\n</ul>\n",
      styles: [":host{display:block;overflow-y:auto;width:100%;align-self:start;max-height:min(100%,320px)}ul{list-style:none;position:relative;margin:0;padding:0}li{cursor:pointer;outline:none;padding:10px 14px;font-size:16px;font-weight:400;line-height:24px;color:var(--theme-color-font)}li.default-highlight[aria-selected=true]{background-color:var(--neoGrayNeutral-25)}li.default-highlight:hover,li.default-highlight:focus-visible{background-color:var(--neoLightblue-main)}.select-listbox-item--default{display:flex;justify-content:space-between;align-items:center}\n"]
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    items: [{
      type: Input
    }],
    key: [{
      type: Input
    }],
    labelKey: [{
      type: Input
    }],
    valueKey: [{
      type: Input
    }],
    useDefaultHighlights: [{
      type: Input
    }],
    showListboxInOverlay: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    selectListbox: [{
      type: ViewChild,
      args: [NeoSelectListboxDirective, {
        static: true
      }]
    }]
  });
})();
class NeoSelectComponent {
  constructor(_focusMonitor, _elementRef) {
    this._focusMonitor = _focusMonitor;
    this._elementRef = _elementRef;
    /**
     * Not required when there are items with custom templates.
     */
    this.items = [];
    this.placeholder = '';
    /**
     * This should be turned off when the default hover, selected highlight is not appropriate.
     */
    this.useDefaultHighlights = true;
    this.showListboxInOverlay = true;
    this.toggleMonitoring(true);
  }
  ngOnDestroy() {
    this.toggleMonitoring(false);
  }
  writeValue(obj) {
    this.selectListbox.writeValue(obj);
  }
  registerOnChange(fn) {
    this.selectListbox.registerOnChange(fn);
  }
  registerOnTouched(fn) {
    this.selectListbox.registerOnTouched(fn);
  }
  setDisabledState(isDisabled) {
    this.selectListbox.setDisabledState(isDisabled);
    this.toggleMonitoring(!isDisabled);
  }
  toggleMonitoring(shouldMonitor) {
    if (shouldMonitor && !this._focusStateChange$) {
      this._focusStateChange$ = this._focusMonitor.monitor(this._elementRef, true);
    } else if (!shouldMonitor && this._focusStateChange$) {
      this._focusMonitor.stopMonitoring(this._elementRef);
      this._focusStateChange$ = undefined;
    }
  }
  static {
    this.ɵfac = function NeoSelectComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoSelectComponent)(i0.ɵɵdirectiveInject(i1$3.FocusMonitor), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NeoSelectComponent,
      selectors: [["neo-select"]],
      contentQueries: function NeoSelectComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, NeoSelectItemDirective, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.childSelectItem = _t.first);
        }
      },
      viewQuery: function NeoSelectComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(NeoSelectListboxComponent, 7);
          i0.ɵɵviewQuery(NeoSelectListboxComponent, 7, ElementRef);
          i0.ɵɵviewQuery(NeoSelectButtonComponent, 7, ElementRef);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.selectListbox = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.selectListboxElement = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.selectButtonElement = _t.first);
        }
      },
      inputs: {
        items: "items",
        placeholder: "placeholder",
        selectId: "selectId",
        key: "key",
        labelKey: "labelKey",
        valueKey: "valueKey",
        useDefaultHighlights: "useDefaultHighlights",
        showListboxInOverlay: "showListboxInOverlay"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        multi: true,
        useExisting: forwardRef(() => NeoSelectComponent)
      }])],
      decls: 4,
      vars: 15,
      consts: [["selectButton", ""], [3, "id", "placeholder", "selectListbox"], ["tabindex", "-1", "aria-hidden", "true", "type", "button", 1, "select-button-arrow", 3, "select-button-arrow-inverted"], [3, "items", "key", "selectItem", "useDefaultHighlights", "showListboxInOverlay", "labelKey", "valueKey"], ["tabindex", "-1", "aria-hidden", "true", "type", "button", 1, "select-button-arrow"], [3, "name", "size"]],
      template: function NeoSelectComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "neo-select-button", 1, 0);
          i0.ɵɵtemplate(2, NeoSelectComponent_Conditional_2_Template, 2, 4, "button", 2);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(3, "neo-select-listbox", 3);
        }
        if (rf & 2) {
          const selectButton_r1 = i0.ɵɵreference(1);
          i0.ɵɵclassProp("select--with-overlay", ctx.showListboxInOverlay);
          i0.ɵɵproperty("id", ctx.selectId)("placeholder", ctx.placeholder)("selectListbox", ctx.selectListbox);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(!selectButton_r1.selectButton.isDisabled ? 2 : -1);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("select--with-overlay", ctx.showListboxInOverlay);
          i0.ɵɵproperty("items", ctx.items)("key", ctx.key)("selectItem", ctx.childSelectItem)("useDefaultHighlights", ctx.useDefaultHighlights)("showListboxInOverlay", ctx.showListboxInOverlay)("labelKey", ctx.labelKey)("valueKey", ctx.valueKey);
        }
      },
      dependencies: [CommonModule, NeoSelectButtonComponent, NeoSelectListboxComponent, NeoIconComponent],
      styles: ["[_nghost-%COMP%]{display:block;border-radius:12px;border:1px solid var(--neo-input-border-color);box-shadow:0 1px 2px #1018280d;overflow:hidden}.cdk-keyboard-focused[_nghost-%COMP%]{outline:3px solid var(--neo-input-outline-color);outline-offset:1px}.select-button-arrow[_ngcontent-%COMP%]{background:none;border:none;display:block;transition:transform .2s ease-in-out;padding:2px 12px;color:var(--neo-input-icon-color);cursor:pointer}.select-button-arrow-inverted[_ngcontent-%COMP%]{transform:rotate(-180deg)}neo-select-button[_ngcontent-%COMP%]{background:var(--neo-input-bg-color);cursor:pointer;width:100%;outline:none;padding:8px 0 8px 12px;box-sizing:border-box}neo-select-button[aria-disabled=true][_ngcontent-%COMP%]{cursor:default}neo-select-button[_ngcontent-%COMP%]:not(.select--with-overlay)[aria-expanded=true]{border-bottom:1px solid var(--neo-input-border-color)}neo-select-listbox[_ngcontent-%COMP%]:not(.select--with-overlay){max-height:260px}neo-select-listbox.select--with-overlay[_ngcontent-%COMP%]{border-radius:12px;border:1px solid #f2f4f7;background:#fff;box-shadow:0 4px 6px -2px #10182808,0 12px 16px -4px #10182814;box-sizing:content-box}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoSelectComponent, [{
    type: Component,
    args: [{
      selector: 'neo-select',
      imports: [CommonModule, NeoSelectButtonComponent, NeoSelectListboxComponent, NeoIconComponent],
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        multi: true,
        useExisting: forwardRef(() => NeoSelectComponent)
      }],
      template: "<neo-select-button\n    #selectButton\n    [id]=\"selectId\"\n    [placeholder]=\"placeholder\"\n    [selectListbox]=\"selectListbox\"\n    [class.select--with-overlay]=\"showListboxInOverlay\"\n>\n    @if (!selectButton.selectButton.isDisabled) {\n        <button\n            class=\"select-button-arrow\"\n            [class.select-button-arrow-inverted]=\"selectButton.selectButton.isExpanded\"\n            tabindex=\"-1\"\n            aria-hidden=\"true\"\n            type=\"button\"\n        >\n            <neo-icon [name]=\"'neo-chevron-down'\" [size]=\"20\"></neo-icon>\n        </button>\n    }\n</neo-select-button>\n<neo-select-listbox\n    [items]=\"items\"\n    [key]=\"key\"\n    [selectItem]=\"childSelectItem\"\n    [useDefaultHighlights]=\"useDefaultHighlights\"\n    [showListboxInOverlay]=\"showListboxInOverlay\"\n    [labelKey]=\"labelKey\"\n    [valueKey]=\"valueKey\"\n    [class.select--with-overlay]=\"showListboxInOverlay\"\n></neo-select-listbox>\n",
      styles: [":host{display:block;border-radius:12px;border:1px solid var(--neo-input-border-color);box-shadow:0 1px 2px #1018280d;overflow:hidden}:host.cdk-keyboard-focused{outline:3px solid var(--neo-input-outline-color);outline-offset:1px}.select-button-arrow{background:none;border:none;display:block;transition:transform .2s ease-in-out;padding:2px 12px;color:var(--neo-input-icon-color);cursor:pointer}.select-button-arrow-inverted{transform:rotate(-180deg)}neo-select-button{background:var(--neo-input-bg-color);cursor:pointer;width:100%;outline:none;padding:8px 0 8px 12px;box-sizing:border-box}neo-select-button[aria-disabled=true]{cursor:default}neo-select-button:not(.select--with-overlay)[aria-expanded=true]{border-bottom:1px solid var(--neo-input-border-color)}neo-select-listbox:not(.select--with-overlay){max-height:260px}neo-select-listbox.select--with-overlay{border-radius:12px;border:1px solid #f2f4f7;background:#fff;box-shadow:0 4px 6px -2px #10182808,0 12px 16px -4px #10182814;box-sizing:content-box}\n"]
    }]
  }], () => [{
    type: i1$3.FocusMonitor
  }, {
    type: i0.ElementRef
  }], {
    items: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }],
    selectId: [{
      type: Input
    }],
    key: [{
      type: Input
    }],
    labelKey: [{
      type: Input
    }],
    valueKey: [{
      type: Input
    }],
    useDefaultHighlights: [{
      type: Input
    }],
    showListboxInOverlay: [{
      type: Input
    }],
    childSelectItem: [{
      type: ContentChild,
      args: [NeoSelectItemDirective]
    }],
    selectListbox: [{
      type: ViewChild,
      args: [NeoSelectListboxComponent, {
        static: true
      }]
    }],
    selectListboxElement: [{
      type: ViewChild,
      args: [NeoSelectListboxComponent, {
        static: true,
        read: ElementRef
      }]
    }],
    selectButtonElement: [{
      type: ViewChild,
      args: [NeoSelectButtonComponent, {
        static: true,
        read: ElementRef
      }]
    }]
  });
})();
class NeoSelectModule {
  static {
    this.ɵfac = function NeoSelectModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoSelectModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NeoSelectModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [NeoSelectComponent, NeoSelectListboxComponent, NeoSelectButtonComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoSelectModule, [{
    type: NgModule,
    args: [{
      imports: [NeoSelectComponent, NeoSelectItemDirective, NeoSelectButtonDirective, NeoSelectListboxDirective, NeoSelectListboxItemDirective, NeoSelectListboxComponent, NeoSelectButtonComponent],
      exports: [NeoSelectComponent, NeoSelectItemDirective, NeoSelectButtonDirective, NeoSelectListboxDirective, NeoSelectListboxItemDirective, NeoSelectListboxComponent, NeoSelectButtonComponent],
      providers: []
    }]
  }], null, null);
})();
const NEO_SELECT_DIRECTIVES = [NeoSelectButtonComponent, NeoSelectButtonDirective, NeoSelectListboxItemDirective, NeoSelectListboxComponent, NeoSelectListboxDirective, NeoSelectComponent, NeoSelectItemDirective];
class NeoLoaderComponent {
  static {
    this.ɵfac = function NeoLoaderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoLoaderComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NeoLoaderComponent,
      selectors: [["neo-loader"]],
      decls: 2,
      vars: 0,
      consts: [["viewBox", "0 0 200 200", 2, "height", "100%", "width", "100%"], ["cx", "100", "cy", "100", "r", "88", "fill", "none", "stroke-width", "24", 1, "path"]],
      template: function NeoLoaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵnamespaceSVG();
          i0.ɵɵelementStart(0, "svg", 0);
          i0.ɵɵelement(1, "circle", 1);
          i0.ɵɵelementEnd();
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}svg[_ngcontent-%COMP%]{stroke:currentColor;animation:_ngcontent-%COMP%_loader-spin 2s infinite cubic-bezier(.3,.2,.7,.8)}circle[_ngcontent-%COMP%]{stroke-linecap:round;animation:_ngcontent-%COMP%_loader-dash 1.5s ease-in-out infinite}@keyframes _ngcontent-%COMP%_loader-spin{to{transform:rotate(360deg)}}@keyframes _ngcontent-%COMP%_loader-dash{0%{stroke-dasharray:1,600;stroke-dashoffset:0}50%{stroke-dasharray:414,600;stroke-dashoffset:-155}to{stroke-dasharray:414,600;stroke-dashoffset:-550}}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoLoaderComponent, [{
    type: Component,
    args: [{
      selector: 'neo-loader',
      template: `
        <svg style="height: 100%; width: 100%;" viewBox="0 0 200 200">
            <circle class="path" cx="100" cy="100" r="88" fill="none" stroke-width="24"></circle>
        </svg>
    `,
      changeDetection: ChangeDetectionStrategy.OnPush,
      styles: [":host{display:block}svg{stroke:currentColor;animation:loader-spin 2s infinite cubic-bezier(.3,.2,.7,.8)}circle{stroke-linecap:round;animation:loader-dash 1.5s ease-in-out infinite}@keyframes loader-spin{to{transform:rotate(360deg)}}@keyframes loader-dash{0%{stroke-dasharray:1,600;stroke-dashoffset:0}50%{stroke-dasharray:414,600;stroke-dashoffset:-155}to{stroke-dasharray:414,600;stroke-dashoffset:-550}}\n"]
    }]
  }], null, null);
})();

// eslint-disable-next-line @angular-eslint/component-class-suffix
class NeoButton {
  constructor() {
    this.color = input('primary');
    this.purpose = input('normal');
    this.size = input('full');
    this.disabled = input(false, {
      transform: booleanAttribute
    });
    this.loading = input(false, {
      transform: booleanAttribute
    });
    this.colorClass = computed(() => {
      const color = this.color();
      if (!color) {
        return 'neo-btn-unthemed';
      }
      return `neo-btn-${color}`;
    });
    this.purposeClass = computed(() => {
      const purpose = this.purpose();
      if (!purpose) {
        return 'neo-btn-unpurposed';
      }
      return `neo-btn-${purpose}`;
    });
    this.sizeClass = computed(() => {
      const size = this.size();
      return `neo-btn-${size}`;
    });
    this.klass = computed(() => {
      const classes = [this.colorClass(), this.purposeClass(), this.sizeClass()];
      return classes.filter(c => !!c).join(' ');
    });
  }
  haltEventWhenDisabled(event) {
    const disabled = this.disabled();
    const loading = this.loading();
    if (disabled || loading) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  }
  static {
    this.ɵfac = function NeoButton_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoButton)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NeoButton,
      selectors: [["", "neoButton", ""]],
      hostVars: 7,
      hostBindings: function NeoButton_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function NeoButton_click_HostBindingHandler($event) {
            return ctx.haltEventWhenDisabled($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("disabled", ctx.disabled() ? true : null);
          i0.ɵɵclassMap(ctx.klass());
          i0.ɵɵclassProp("neo-btn", true)("neo-btn-loading", ctx.loading());
        }
      },
      inputs: {
        color: [1, "color"],
        purpose: [1, "purpose"],
        size: [1, "size"],
        disabled: [1, "disabled"],
        loading: [1, "loading"]
      },
      exportAs: ["neoButton"],
      attrs: _c9,
      ngContentSelectors: _c11,
      decls: 5,
      vars: 1,
      consts: [[1, "neo-btn__loader-container"], [1, "neo-btn__label"], [1, "neo-btn__loader"]],
      template: function NeoButton_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c10);
          i0.ɵɵtemplate(0, NeoButton_Conditional_0_Template, 2, 0, "div", 0);
          i0.ɵɵprojection(1);
          i0.ɵɵelementStart(2, "span", 1);
          i0.ɵɵprojection(3, 1);
          i0.ɵɵelementEnd();
          i0.ɵɵprojection(4, 2);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.loading() ? 0 : -1);
        }
      },
      dependencies: [NeoLoaderComponent],
      styles: [".neo-btn{align-items:center;display:inline-flex;gap:8px;justify-content:center;background-color:var(--neo-btn-bg-color);color:var(--neo-btn-color);border:1px solid var(--neo-btn-border-color);border-radius:var(--neo-btn-border-radius);padding:var(--neo-btn-padding-vertical) var(--neo-btn-padding-horizontal);font-family:Roobert,sans-serif;font-size:var(--neo-btn-font-size);font-weight:500;line-height:var(--neo-btn-line-height);cursor:pointer;position:relative}.neo-btn:focus-visible{outline:3px solid var(--neo-btn-outline-color);outline-offset:2px}.neo-btn{--neo-btn-bg-color: unset;--neo-btn-border-color: var(--neo-primary-color);--neo-btn-color: var(--neo-primary-font-color);--neo-btn-border: unset;--neo-btn-border-radius: 12px;--neo-btn-padding-vertical: 12px;--neo-btn-padding-horizontal: 20px;--neo-btn-font-size: 16px;--neo-btn-line-height: 24px;--neo-btn-loading-bg-color: var(--neo-btn-bg-color);--neo-btn-loading-border-color: var(--neoGrayNeutral-300);--neo-btn-disabled-color: var(--neoGrayNeutral-500);--neo-btn-disabled-bg-color: var(--neoGrayNeutral-50);--neo-btn-disabled-border-color: var(--neoGreen-25);--neo-btn-hover-color: var(--neo-btn-color);--neo-btn-hover-bg-color: var(--neo-btn-bg-color);--neo-btn-hover-border-color: var(--neo-btn-bg-color);--neo-btn-outline-color: var(--neo-outline-color)}.neo-btn-xs{--neo-btn-padding-vertical: 6px;--neo-btn-padding-horizontal: 10px;--neo-btn-font-size: 12px;--neo-btn-line-height: 16px;--neo-btn-border-radius: 8px}.neo-btn-sm{--neo-btn-padding-vertical: 8px;--neo-btn-padding-horizontal: 14px;--neo-btn-font-size: 14px;--neo-btn-line-height: 20px;--neo-btn-border-radius: 8px}.neo-btn-md{--neo-btn-padding-vertical: 10px;--neo-btn-padding-horizontal: 18px;--neo-btn-font-size: 14px;--neo-btn-line-height: 20px;--neo-btn-border-radius: 12px}.neo-btn-lg{--neo-btn-padding-vertical: 10px;--neo-btn-padding-horizontal: 18px;--neo-btn-font-size: 16px;--neo-btn-line-height: 24px;--neo-btn-border-radius: 12px}.neo-btn-primary.neo-btn-normal{--neo-btn-bg-color: var(--neo-primary-bg-color);--neo-btn-border-color: var(--neo-primary-bg-color);--neo-btn-color: var(--neo-secondary-font-color);--neo-btn-loading-bg-color: var(--theme-color-background);--neo-btn-hover-color: var(--neo-primary-bg-color);--neo-btn-hover-bg-color: var(--neo-secondary-bg-color);--neo-btn-hover-border-color: var(--neo-primary-bg-color)}.neo-btn-secondary.neo-btn-normal{--neo-btn-bg-color: var(--neo-secondary-bg-color);--neo-btn-border-color: var(--neo-secondary-bg-color);--neo-btn-loading-border-color: var(--neo-btn-loading-bg-color);--neo-btn-hover-bg-color: var(--neoYellow-25)}.neo-btn-plain.neo-btn-normal{--neo-btn-bg-color: transparent;--neo-btn-border-color: transparent;--neo-btn-disabled-color: var(--neoGrayNeutral-main);--neo-btn-disabled-bg-color: transparent;--neo-btn-disabled-border-color: transparent;--neo-btn-loading-bg-color: var(--neoGrayNeutral-100);--neo-btn-loading-border-color: var(--neoGrayNeutral-100);--neo-btn-hover-bg-color: var(--neoGrayNeutral-100);--neo-btn-hover-border-color: var(--neoGrayNeutral-100)}.neo-btn-tertiary.neo-btn-normal{--neo-btn-bg-color: transparent;--neo-btn-border-color: transparent;--neo-btn-disabled-color: var(--neoGrayNeutral-main);--neo-btn-disabled-bg-color: transparent;--neo-btn-disabled-border-color: transparent;--neo-btn-loading-bg-color: var(--neoGrayNeutral-100);--neo-btn-loading-border-color: var(--neoGrayNeutral-100);--neo-btn-hover-bg-color: var(--neoGrayNeutral-100);--neo-btn-hover-border-color: var(--neoGrayNeutral-100);text-decoration:underline;text-underline-offset:.3em}.neo-btn-destructive{--neo-btn-outline-color: var(--neo-outline-error-color);--neo-btn-color: var(--neo-primary-error-color)}.neo-btn-primary.neo-btn-destructive{--neo-btn-bg-color: var(--neo-primary-error-bg-color);--neo-btn-border-color: var(--neo-primary-error-bg-color);--neo-btn-color: var(--theme-color-background);--neo-btn-disabled-color: #c8908c;--neo-btn-disabled-bg-color: var(--neoError-100);--neo-btn-disabled-border-color: var(--neoError-200);--neo-btn-loading-bg-color: var(--theme-color-background);--neo-btn-hover-bg-color: var(--neoError-700);--neo-btn-hover-border-color: var(--neoError-700)}.neo-btn-secondary.neo-btn-destructive{--neo-btn-bg-color: var(--theme-color-background);--neo-btn-border-color: var(--neoError-300);--neo-btn-disabled-color: var(--neoError-200);--neo-btn-disabled-bg-color: var(--neo-btn-bg-color);--neo-btn-disabled-border-color: var(--neoError-100);--neo-btn-hover-bg-color: var(--neoError-50);--neo-btn-hover-border-color: var(--neoError-300)}.neo-btn-plain.neo-btn-destructive{--neo-btn-bg-color: transparent;--neo-btn-border-color: transparent;--neo-btn-disabled-color: var(--neoError-200);--neo-btn-disabled-bg-color: transparent;--neo-btn-disabled-border-color: transparent;--neo-btn-loading-bg-color: var(--neoGrayNeutral-100);--neo-btn-loading-border-color: var(--neoGrayNeutral-100);--neo-btn-hover-bg-color: var(--neoError-50);--neo-btn-hover-border-color: var(--neoError-50)}.neo-btn-tertiary.neo-btn-destructive{--neo-btn-bg-color: transparent;--neo-btn-border-color: transparent;--neo-btn-disabled-color: var(--neoError-200);--neo-btn-disabled-bg-color: transparent;--neo-btn-disabled-border-color: transparent;--neo-btn-loading-bg-color: var(--neoGrayNeutral-100);--neo-btn-loading-border-color: var(--neoGrayNeutral-100);--neo-btn-hover-bg-color: var(--neoError-50);--neo-btn-hover-border-color: var(--neoError-50);text-decoration:underline;text-underline-offset:.3em}.neo-btn-secondary.neo-btn-grey{--neo-btn-bg-color: var(--theme-color-background);--neo-btn-border-color: var(--neoGreen-50);--neo-btn-color: var(--neo-primary-font-color);--neo-btn-disabled-color: #728484;--neo-btn-disabled-bg-color: var(--theme-color-background);--neo-btn-disabled-border-color: #d4dada;--neo-btn-hover-bg-color: var(--neoGrayNeutral-50);--neo-btn-hover-border-color: var(--neoGreen-50)}.neo-btn:hover{color:var(--neo-btn-hover-color);background:var(--neo-btn-hover-bg-color);border:1px solid var(--neo-btn-hover-border-color)}.neo-btn:disabled{cursor:default;color:var(--neo-btn-disabled-color);background:var(--neo-btn-disabled-bg-color);border:1px solid var(--neo-btn-disabled-border-color)}.neo-btn.neo-btn-loading{cursor:default;--neo-btn-disabled-color: transparent;--neo-btn-color: transparent;--neo-btn-hover-color: transparent}.neo-btn.neo-btn-loading{background:var(--neo-btn-loading-bg-color);border:1px solid var(--neo-btn-loading-border-color)}.neo-btn__loader-container{display:flex;align-items:center;justify-content:center;color:var(--neo-primary-font-color);position:absolute;inset:0}.neo-btn__loader{height:var(--neo-btn-line-height);width:var(--neo-btn-line-height)}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoButton, [{
    type: Component,
    args: [{
      selector: '[neoButton]',
      changeDetection: ChangeDetectionStrategy.OnPush,
      exportAs: 'neoButton',
      host: {
        '[class.neo-btn]': 'true',
        '[class.neo-btn-loading]': 'loading()',
        '[class]': 'klass()',
        '(click)': 'haltEventWhenDisabled($event)',
        '[attr.disabled]': 'disabled() ? true : null'
      },
      imports: [NeoLoaderComponent],
      encapsulation: ViewEncapsulation.None,
      template: "@if (loading()) {\n    <div class=\"neo-btn__loader-container\">\n        <neo-loader class=\"neo-btn__loader\"></neo-loader>\n    </div>\n}\n<ng-content select=\"neo-icon:not([iconPositionEnd])\"> </ng-content>\n\n<span class=\"neo-btn__label\"><ng-content></ng-content></span>\n\n<ng-content select=\"neo-icon[iconPositionEnd]\"> </ng-content>\n",
      styles: [".neo-btn{align-items:center;display:inline-flex;gap:8px;justify-content:center;background-color:var(--neo-btn-bg-color);color:var(--neo-btn-color);border:1px solid var(--neo-btn-border-color);border-radius:var(--neo-btn-border-radius);padding:var(--neo-btn-padding-vertical) var(--neo-btn-padding-horizontal);font-family:Roobert,sans-serif;font-size:var(--neo-btn-font-size);font-weight:500;line-height:var(--neo-btn-line-height);cursor:pointer;position:relative}.neo-btn:focus-visible{outline:3px solid var(--neo-btn-outline-color);outline-offset:2px}.neo-btn{--neo-btn-bg-color: unset;--neo-btn-border-color: var(--neo-primary-color);--neo-btn-color: var(--neo-primary-font-color);--neo-btn-border: unset;--neo-btn-border-radius: 12px;--neo-btn-padding-vertical: 12px;--neo-btn-padding-horizontal: 20px;--neo-btn-font-size: 16px;--neo-btn-line-height: 24px;--neo-btn-loading-bg-color: var(--neo-btn-bg-color);--neo-btn-loading-border-color: var(--neoGrayNeutral-300);--neo-btn-disabled-color: var(--neoGrayNeutral-500);--neo-btn-disabled-bg-color: var(--neoGrayNeutral-50);--neo-btn-disabled-border-color: var(--neoGreen-25);--neo-btn-hover-color: var(--neo-btn-color);--neo-btn-hover-bg-color: var(--neo-btn-bg-color);--neo-btn-hover-border-color: var(--neo-btn-bg-color);--neo-btn-outline-color: var(--neo-outline-color)}.neo-btn-xs{--neo-btn-padding-vertical: 6px;--neo-btn-padding-horizontal: 10px;--neo-btn-font-size: 12px;--neo-btn-line-height: 16px;--neo-btn-border-radius: 8px}.neo-btn-sm{--neo-btn-padding-vertical: 8px;--neo-btn-padding-horizontal: 14px;--neo-btn-font-size: 14px;--neo-btn-line-height: 20px;--neo-btn-border-radius: 8px}.neo-btn-md{--neo-btn-padding-vertical: 10px;--neo-btn-padding-horizontal: 18px;--neo-btn-font-size: 14px;--neo-btn-line-height: 20px;--neo-btn-border-radius: 12px}.neo-btn-lg{--neo-btn-padding-vertical: 10px;--neo-btn-padding-horizontal: 18px;--neo-btn-font-size: 16px;--neo-btn-line-height: 24px;--neo-btn-border-radius: 12px}.neo-btn-primary.neo-btn-normal{--neo-btn-bg-color: var(--neo-primary-bg-color);--neo-btn-border-color: var(--neo-primary-bg-color);--neo-btn-color: var(--neo-secondary-font-color);--neo-btn-loading-bg-color: var(--theme-color-background);--neo-btn-hover-color: var(--neo-primary-bg-color);--neo-btn-hover-bg-color: var(--neo-secondary-bg-color);--neo-btn-hover-border-color: var(--neo-primary-bg-color)}.neo-btn-secondary.neo-btn-normal{--neo-btn-bg-color: var(--neo-secondary-bg-color);--neo-btn-border-color: var(--neo-secondary-bg-color);--neo-btn-loading-border-color: var(--neo-btn-loading-bg-color);--neo-btn-hover-bg-color: var(--neoYellow-25)}.neo-btn-plain.neo-btn-normal{--neo-btn-bg-color: transparent;--neo-btn-border-color: transparent;--neo-btn-disabled-color: var(--neoGrayNeutral-main);--neo-btn-disabled-bg-color: transparent;--neo-btn-disabled-border-color: transparent;--neo-btn-loading-bg-color: var(--neoGrayNeutral-100);--neo-btn-loading-border-color: var(--neoGrayNeutral-100);--neo-btn-hover-bg-color: var(--neoGrayNeutral-100);--neo-btn-hover-border-color: var(--neoGrayNeutral-100)}.neo-btn-tertiary.neo-btn-normal{--neo-btn-bg-color: transparent;--neo-btn-border-color: transparent;--neo-btn-disabled-color: var(--neoGrayNeutral-main);--neo-btn-disabled-bg-color: transparent;--neo-btn-disabled-border-color: transparent;--neo-btn-loading-bg-color: var(--neoGrayNeutral-100);--neo-btn-loading-border-color: var(--neoGrayNeutral-100);--neo-btn-hover-bg-color: var(--neoGrayNeutral-100);--neo-btn-hover-border-color: var(--neoGrayNeutral-100);text-decoration:underline;text-underline-offset:.3em}.neo-btn-destructive{--neo-btn-outline-color: var(--neo-outline-error-color);--neo-btn-color: var(--neo-primary-error-color)}.neo-btn-primary.neo-btn-destructive{--neo-btn-bg-color: var(--neo-primary-error-bg-color);--neo-btn-border-color: var(--neo-primary-error-bg-color);--neo-btn-color: var(--theme-color-background);--neo-btn-disabled-color: #c8908c;--neo-btn-disabled-bg-color: var(--neoError-100);--neo-btn-disabled-border-color: var(--neoError-200);--neo-btn-loading-bg-color: var(--theme-color-background);--neo-btn-hover-bg-color: var(--neoError-700);--neo-btn-hover-border-color: var(--neoError-700)}.neo-btn-secondary.neo-btn-destructive{--neo-btn-bg-color: var(--theme-color-background);--neo-btn-border-color: var(--neoError-300);--neo-btn-disabled-color: var(--neoError-200);--neo-btn-disabled-bg-color: var(--neo-btn-bg-color);--neo-btn-disabled-border-color: var(--neoError-100);--neo-btn-hover-bg-color: var(--neoError-50);--neo-btn-hover-border-color: var(--neoError-300)}.neo-btn-plain.neo-btn-destructive{--neo-btn-bg-color: transparent;--neo-btn-border-color: transparent;--neo-btn-disabled-color: var(--neoError-200);--neo-btn-disabled-bg-color: transparent;--neo-btn-disabled-border-color: transparent;--neo-btn-loading-bg-color: var(--neoGrayNeutral-100);--neo-btn-loading-border-color: var(--neoGrayNeutral-100);--neo-btn-hover-bg-color: var(--neoError-50);--neo-btn-hover-border-color: var(--neoError-50)}.neo-btn-tertiary.neo-btn-destructive{--neo-btn-bg-color: transparent;--neo-btn-border-color: transparent;--neo-btn-disabled-color: var(--neoError-200);--neo-btn-disabled-bg-color: transparent;--neo-btn-disabled-border-color: transparent;--neo-btn-loading-bg-color: var(--neoGrayNeutral-100);--neo-btn-loading-border-color: var(--neoGrayNeutral-100);--neo-btn-hover-bg-color: var(--neoError-50);--neo-btn-hover-border-color: var(--neoError-50);text-decoration:underline;text-underline-offset:.3em}.neo-btn-secondary.neo-btn-grey{--neo-btn-bg-color: var(--theme-color-background);--neo-btn-border-color: var(--neoGreen-50);--neo-btn-color: var(--neo-primary-font-color);--neo-btn-disabled-color: #728484;--neo-btn-disabled-bg-color: var(--theme-color-background);--neo-btn-disabled-border-color: #d4dada;--neo-btn-hover-bg-color: var(--neoGrayNeutral-50);--neo-btn-hover-border-color: var(--neoGreen-50)}.neo-btn:hover{color:var(--neo-btn-hover-color);background:var(--neo-btn-hover-bg-color);border:1px solid var(--neo-btn-hover-border-color)}.neo-btn:disabled{cursor:default;color:var(--neo-btn-disabled-color);background:var(--neo-btn-disabled-bg-color);border:1px solid var(--neo-btn-disabled-border-color)}.neo-btn.neo-btn-loading{cursor:default;--neo-btn-disabled-color: transparent;--neo-btn-color: transparent;--neo-btn-hover-color: transparent}.neo-btn.neo-btn-loading{background:var(--neo-btn-loading-bg-color);border:1px solid var(--neo-btn-loading-border-color)}.neo-btn__loader-container{display:flex;align-items:center;justify-content:center;color:var(--neo-primary-font-color);position:absolute;inset:0}.neo-btn__loader{height:var(--neo-btn-line-height);width:var(--neo-btn-line-height)}\n"]
    }]
  }], null, null);
})();
class NeoBadgeComponent {
  constructor() {
    this.size = input('sm');
    this.color = input('purple');
    this.colorClass = computed(() => {
      const color = this.color();
      if (!color) {
        return 'neo-badge-unthemed';
      }
      return `neo-badge-${color}`;
    });
    this.sizeClass = computed(() => {
      const size = this.size();
      return `neo-badge-${size}`;
    });
    this.klass = computed(() => {
      const classes = [this.colorClass(), this.sizeClass()];
      return classes.filter(c => !!c).join(' ');
    });
  }
  static {
    this.ɵfac = function NeoBadgeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoBadgeComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NeoBadgeComponent,
      selectors: [["neo-badge"]],
      hostVars: 4,
      hostBindings: function NeoBadgeComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.klass());
          i0.ɵɵclassProp("neo-badge", true);
        }
      },
      inputs: {
        size: [1, "size"],
        color: [1, "color"]
      },
      ngContentSelectors: _c11,
      decls: 4,
      vars: 0,
      consts: [[1, "neo-badge__label"]],
      template: function NeoBadgeComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c10);
          i0.ɵɵprojection(0);
          i0.ɵɵelementStart(1, "span", 0);
          i0.ɵɵprojection(2, 1);
          i0.ɵɵelementEnd();
          i0.ɵɵprojection(3, 2);
        }
      },
      styles: [".neo-badge{align-items:center;display:inline-flex;gap:4px;justify-content:center;background-color:var(--neo-badge-bg-color);color:var(--neo-badge-color);border:1px solid var(--neo-badge-border-color);border-radius:var(--neo-badge-border-radius);padding:var(--neo-badge-padding-vertical) var(--neo-badge-padding-horizontal);font-family:Roobert,sans-serif;font-size:var(--neo-badge-font-size);font-weight:500;line-height:var(--neo-badge-line-height)}.neo-badge{--neo-badge-bg-color: unset;--neo-badge-border-color: var(--neo-badge-bg-color);--neo-badge-color: var(--neo-primary-font-color);--neo-badge-border-radius: 4px;--neo-badge-padding-vertical: 3px;--neo-badge-padding-horizontal: 5px;--neo-badge-font-size: 12px;--neo-badge-line-height: 16px}.neo-badge__label{display:inline-block;padding:0 2px}.neo-badge-sm{--neo-badge-padding-horizontal: 5px;--neo-badge-font-size: 12px;--neo-badge-line-height: 16px}.neo-badge-md{--neo-badge-padding-horizontal: 7px;--neo-badge-font-size: 14px;--neo-badge-line-height: 20px}.neo-badge-lg{--neo-badge-padding-horizontal: 9px;--neo-badge-font-size: 14px;--neo-badge-line-height: 20px}.neo-badge-gray{--neo-badge-bg-color: var(--neoGray-100);--neo-badge-color: var(--neoGray-700)}.neo-badge-purple{--neo-badge-bg-color: var(--neoPurple-100);--neo-badge-color: var(--neoPurple-800)}.neo-badge-error{--neo-badge-bg-color: var(--neoError-100);--neo-badge-color: var(--neoError-800)}.neo-badge-warning{--neo-badge-bg-color: var(--neo-warning-bg-color);--neo-badge-color: var(--neoWarning-800)}.neo-badge-success{--neo-badge-bg-color: var(--neoSuccess-100);--neo-badge-color: var(--neoSuccess-800)}.neo-badge-white{--neo-badge-bg-color: var(--neoBase--white);--neo-badge-border-color: var(--neoGreen-25);--neo-badge-color: var(--theme-color-font)}.neo-badge-neo-blue{--neo-badge-bg-color: var(--neoBlue-100);--neo-badge-color: var(--neoBlue-800)}.neo-badge-neo-green{--neo-badge-bg-color: var(--theme-color-main);--neo-badge-color: var(--theme-color-secondary)}.neo-badge-neo-yellow{--neo-badge-bg-color: var(--theme-color-secondary);--neo-badge-color: var(--theme-color-font)}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoBadgeComponent, [{
    type: Component,
    args: [{
      selector: 'neo-badge',
      host: {
        '[class.neo-badge]': 'true',
        '[class]': 'klass()'
      },
      encapsulation: ViewEncapsulation.None,
      template: "<ng-content select=\"neo-icon:not([iconPositionEnd])\"> </ng-content>\n\n<span class=\"neo-badge__label\"><ng-content></ng-content></span>\n\n<ng-content select=\"neo-icon[iconPositionEnd]\"> </ng-content>\n",
      styles: [".neo-badge{align-items:center;display:inline-flex;gap:4px;justify-content:center;background-color:var(--neo-badge-bg-color);color:var(--neo-badge-color);border:1px solid var(--neo-badge-border-color);border-radius:var(--neo-badge-border-radius);padding:var(--neo-badge-padding-vertical) var(--neo-badge-padding-horizontal);font-family:Roobert,sans-serif;font-size:var(--neo-badge-font-size);font-weight:500;line-height:var(--neo-badge-line-height)}.neo-badge{--neo-badge-bg-color: unset;--neo-badge-border-color: var(--neo-badge-bg-color);--neo-badge-color: var(--neo-primary-font-color);--neo-badge-border-radius: 4px;--neo-badge-padding-vertical: 3px;--neo-badge-padding-horizontal: 5px;--neo-badge-font-size: 12px;--neo-badge-line-height: 16px}.neo-badge__label{display:inline-block;padding:0 2px}.neo-badge-sm{--neo-badge-padding-horizontal: 5px;--neo-badge-font-size: 12px;--neo-badge-line-height: 16px}.neo-badge-md{--neo-badge-padding-horizontal: 7px;--neo-badge-font-size: 14px;--neo-badge-line-height: 20px}.neo-badge-lg{--neo-badge-padding-horizontal: 9px;--neo-badge-font-size: 14px;--neo-badge-line-height: 20px}.neo-badge-gray{--neo-badge-bg-color: var(--neoGray-100);--neo-badge-color: var(--neoGray-700)}.neo-badge-purple{--neo-badge-bg-color: var(--neoPurple-100);--neo-badge-color: var(--neoPurple-800)}.neo-badge-error{--neo-badge-bg-color: var(--neoError-100);--neo-badge-color: var(--neoError-800)}.neo-badge-warning{--neo-badge-bg-color: var(--neo-warning-bg-color);--neo-badge-color: var(--neoWarning-800)}.neo-badge-success{--neo-badge-bg-color: var(--neoSuccess-100);--neo-badge-color: var(--neoSuccess-800)}.neo-badge-white{--neo-badge-bg-color: var(--neoBase--white);--neo-badge-border-color: var(--neoGreen-25);--neo-badge-color: var(--theme-color-font)}.neo-badge-neo-blue{--neo-badge-bg-color: var(--neoBlue-100);--neo-badge-color: var(--neoBlue-800)}.neo-badge-neo-green{--neo-badge-bg-color: var(--theme-color-main);--neo-badge-color: var(--theme-color-secondary)}.neo-badge-neo-yellow{--neo-badge-bg-color: var(--theme-color-secondary);--neo-badge-color: var(--theme-color-font)}\n"]
    }]
  }], null, null);
})();
class NeoLogoComponent {
  static {
    this.ɵfac = function NeoLogoComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoLogoComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NeoLogoComponent,
      selectors: [["neo-logo"]],
      decls: 3,
      vars: 0,
      consts: [["width", "42", "height", "42", "viewBox", "0 0 42 42", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M0 4.2C0 1.88 1.88 0 4.2 0h33.6c2.32 0 4.2 1.88 4.2 4.2v33.6c0 2.32 -1.88 4.2 -4.2 4.2H4.2c-2.32 0 -4.2 -1.88 -4.2 -4.2z", "fill", "#E0F89D"], ["d", "M21.013 21.026c1.313 1.772 2.809 1.732 2.809 1.732 0.748 -3.504 2.061 -7.954 3.229 -11.012 0.367 -0.945 1.313 -1.641 2.244 -1.641h5.001c1.194 0 1.877 1.116 1.418 2.336 -0.945 2.494 -1.798 5.434 -2.468 8.584s-1.063 6.09 -1.181 8.584c-0.066 1.221 -1.221 2.336 -2.415 2.336h-1.522c-5.224 0 -8.518 -4.384 -7.363 -9.804zc-1.313 -1.772 -2.809 -1.732 -2.809 -1.732 -0.748 3.504 -2.061 7.954 -3.229 11.012 -0.367 0.945 -1.313 1.641 -2.244 1.641h-5.001c-1.194 0 -1.877 -1.116 -1.418 -2.336 0.945 -2.494 1.798 -5.434 2.468 -8.584s1.063 -6.09 1.181 -8.584c0.066 -1.221 1.221 -2.336 2.415 -2.336h1.509c5.224 0 8.518 4.384 7.363 9.804", "fill", "#143232"]],
      template: function NeoLogoComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵnamespaceSVG();
          i0.ɵɵelementStart(0, "svg", 0);
          i0.ɵɵelement(1, "path", 1)(2, "path", 2);
          i0.ɵɵelementEnd();
        }
      },
      styles: ["svg[_ngcontent-%COMP%]{display:block;width:100%;height:100%;border-radius:8px}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoLogoComponent, [{
    type: Component,
    args: [{
      selector: 'neo-logo',
      imports: [],
      template: "<svg width=\"42\" height=\"42\" viewBox=\"0 0 42 42\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path\n        d=\"M0 4.2C0 1.88 1.88 0 4.2 0h33.6c2.32 0 4.2 1.88 4.2 4.2v33.6c0 2.32 -1.88 4.2 -4.2 4.2H4.2c-2.32 0 -4.2 -1.88 -4.2 -4.2z\"\n        fill=\"#E0F89D\"\n    />\n    <path\n        d=\"M21.013 21.026c1.313 1.772 2.809 1.732 2.809 1.732 0.748 -3.504 2.061 -7.954 3.229 -11.012 0.367 -0.945 1.313 -1.641 2.244 -1.641h5.001c1.194 0 1.877 1.116 1.418 2.336 -0.945 2.494 -1.798 5.434 -2.468 8.584s-1.063 6.09 -1.181 8.584c-0.066 1.221 -1.221 2.336 -2.415 2.336h-1.522c-5.224 0 -8.518 -4.384 -7.363 -9.804zc-1.313 -1.772 -2.809 -1.732 -2.809 -1.732 -0.748 3.504 -2.061 7.954 -3.229 11.012 -0.367 0.945 -1.313 1.641 -2.244 1.641h-5.001c-1.194 0 -1.877 -1.116 -1.418 -2.336 0.945 -2.494 1.798 -5.434 2.468 -8.584s1.063 -6.09 1.181 -8.584c0.066 -1.221 1.221 -2.336 2.415 -2.336h1.509c5.224 0 8.518 4.384 7.363 9.804\"\n        fill=\"#143232\"\n    />\n</svg>\n",
      styles: ["svg{display:block;width:100%;height:100%;border-radius:8px}\n"]
    }]
  }], null, null);
})();
class FormFieldHintDirective {
  constructor() {
    this.id = `app-form-field-hint-${FormFieldHintDirective.formFieldHintId++}`;
  }
  static {
    this.formFieldHintId = 0;
  }
  static {
    this.ɵfac = function FormFieldHintDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormFieldHintDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FormFieldHintDirective,
      selectors: [["", "neoFormFieldHint", ""]],
      hostVars: 1,
      hostBindings: function FormFieldHintDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("id", ctx.id);
        }
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormFieldHintDirective, [{
    type: Directive,
    args: [{
      selector: '[neoFormFieldHint]'
    }]
  }], null, {
    id: [{
      type: HostBinding,
      args: ['attr.id']
    }]
  });
})();
class FormFieldValidationMessageDirective {
  constructor() {
    this.id = `app-form-field-validation-message-${FormFieldValidationMessageDirective.formFieldValidationMessageId++}`;
  }
  static {
    this.formFieldValidationMessageId = 0;
  }
  static {
    this.ɵfac = function FormFieldValidationMessageDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormFieldValidationMessageDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FormFieldValidationMessageDirective,
      selectors: [["", "neoValidationMessage", ""]],
      hostVars: 1,
      hostBindings: function FormFieldValidationMessageDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("id", ctx.id);
        }
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormFieldValidationMessageDirective, [{
    type: Directive,
    args: [{
      selector: '[neoValidationMessage]'
    }]
  }], null, {
    id: [{
      type: HostBinding,
      args: ['attr.id']
    }]
  });
})();

/**
 * This should be implemented and provided by controls or form field - control connectors to track changes
 * to the control's focusedness.
 *
 * The form field implementation wants to show validation errors when the user leaves the input control.
 * This is super simple in case of an input field as we can just listen to focus events.
 * With complex controls like dropdowns or datepickers tracking the state is much more complicated.
 * For example we don't want to show errors when the datepicker opens although the input loses focus then.
 */
class FormFieldFocusableControlDirective {
  static {
    this.ɵfac = function FormFieldFocusableControlDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormFieldFocusableControlDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FormFieldFocusableControlDirective
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormFieldFocusableControlDirective, [{
    type: Directive
  }], null, null);
})();
class FormFieldFocusableControlDefaultDirective extends FormFieldFocusableControlDirective {
  constructor() {
    super(...arguments);
    this._focusWithin$ = new BehaviorSubject(false);
    this.focusWithin$ = this._focusWithin$.asObservable();
  }
  handleFocusEvent(focusWithin) {
    this._focusWithin$.next(focusWithin);
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵFormFieldFocusableControlDefaultDirective_BaseFactory;
      return function FormFieldFocusableControlDefaultDirective_Factory(__ngFactoryType__) {
        return (ɵFormFieldFocusableControlDefaultDirective_BaseFactory || (ɵFormFieldFocusableControlDefaultDirective_BaseFactory = i0.ɵɵgetInheritedFactory(FormFieldFocusableControlDefaultDirective)))(__ngFactoryType__ || FormFieldFocusableControlDefaultDirective);
      };
    })();
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FormFieldFocusableControlDefaultDirective,
      selectors: [["", "neoFocusableControlDefault", ""]],
      hostBindings: function FormFieldFocusableControlDefaultDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("focusin", function FormFieldFocusableControlDefaultDirective_focusin_HostBindingHandler() {
            return ctx.handleFocusEvent(true);
          })("focusout", function FormFieldFocusableControlDefaultDirective_focusout_HostBindingHandler() {
            return ctx.handleFocusEvent(false);
          });
        }
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: FormFieldFocusableControlDirective,
        useExisting: FormFieldFocusableControlDefaultDirective
      }]), i0.ɵɵInheritDefinitionFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormFieldFocusableControlDefaultDirective, [{
    type: Directive,
    args: [{
      selector: '[neoFocusableControlDefault]',
      host: {
        '(focusin)': 'handleFocusEvent(true)',
        '(focusout)': 'handleFocusEvent(false)'
      },
      providers: [{
        provide: FormFieldFocusableControlDirective,
        useExisting: FormFieldFocusableControlDefaultDirective
      }]
    }]
  }], null, null);
})();

/**
 * The neo-form-field gives a structure to create form fields, an uniform way to show validation messages,
 * possibility to connect the validation errors, hints with controls in an accessible way.
 *
 * For full potential we usually have to implement "connectors" to connect the controls with the form field.
 * For example see FormFieldNeoInputDirective where we add aria tags and manage focus with FormFieldFocusableControlDefaultDirective.
 */
class FormFieldComponent {
  constructor() {
    this.hint = contentChild(FormFieldHintDirective);
    this.validationMessage = contentChild(FormFieldValidationMessageDirective);
    this.ngControls = contentChildren(NgControl, {
      descendants: true
    });
    this.control = input();
    /**
     * Default mode is 'control'.
     * - 'control': the form field is using the validity of the control to decide whether to show the field as invalid
     * @example
     * In this mode you should have a single neoValidationMessage with possible ifs inside to show different messages
     * ```
     * <neo-form-field>
     *     <input #otherInput="ngModel" neoInput [(ngModel)]="test" minlength="3" required type="text" />
     *     <span neoValidationMessage>
     *         \@if (otherInput.hasError('required')) {
     *             Field is required.
     *         } \@else {
     *             Minlength message
     *         }
     *     </span>
     * </neo-form-field>
     * ```
     * - 'message': the form field is showing the field as invalid if there are any messages present
     * @example
     * In this mode you should conditionally show any neoValidationMessages. Each message has to have its own neoValidationMessage.
     * ```
     *  <neo-form-field validationStateSource="message">
     *      <label for="">Input within Form field with minLength 3 validator</label>
     *      <input neoInput formControlName="testControl" type="text" />
     *      \@if (form.controls.testControl.hasError('minlength')) {
     *          <span neoValidationMessage>Input validation</span>
     *      } \@else if (test === 'test') {
     *          <span neoValidationMessage>Test validation</span>
     *      }
     *  </neo-form-field>
     * ```
     */
    this.validationStateSource = input('control');
    this._childControl = computed(() => this.ngControls()[0]?.control || null);
    this._currentControl = computed(() => {
      return this.control() || this._childControl();
    });
    this._currentControl$ = toObservable(this._currentControl);
    this.selfFocusableControl = inject(FormFieldFocusableControlDirective, {
      self: true
    });
    this.childFocusableControl = contentChildren(FormFieldFocusableControlDirective, {
      descendants: true
    });
    this._focusWithin$ = toObservable(this.childFocusableControl).pipe(map(controls => controls[0] || this.selfFocusableControl), switchMap(focusableControl => focusableControl.focusWithin$), debounceTime(0));
    this._forceShowError$ = new Subject();
    this._controlTouched$ = this._currentControl$.pipe(switchMap(control => {
      if (!control) {
        return of(false);
      }
      return control.events.pipe(filter(e => e instanceof TouchedChangeEvent), map(e => e.touched), startWith(control.touched));
    }));
    this._showErrorOnControlInteraction$ = this.createShowErrorOnControlInteraction$(this._focusWithin$, this._controlTouched$);
    this._controlIsUnfocusedAndTouched$ = this.createControlIsUnfocusedAndTouched$(this._focusWithin$, this._controlTouched$);
    this._validationMessage$ = toObservable(this.validationMessage);
    this._showErrorBasedOnControl$ = this.createShowErrorBasedOnControl$(this._showErrorOnControlInteraction$, this._currentControl$, this._controlIsUnfocusedAndTouched$);
    this._showErrorBasedOnMessage$ = this.createShowErrorBasedOnMessage$(this._controlIsUnfocusedAndTouched$, this._validationMessage$, this._showErrorOnControlInteraction$);
    this._isControlInvalidVisible$ = this.createIsControlInvalidVisible$(this._showErrorBasedOnControl$, this._showErrorBasedOnMessage$, this._forceShowError$, toObservable(this.validationStateSource), this._validationMessage$);
    this.isControlInvalidVisible = toSignal(this._isControlInvalidVisible$);
    this.describedByIds = computed(() => {
      const describedByIds = [];
      const errorMessageId = this.validationMessage()?.id;
      if (this.isControlInvalidVisible() && errorMessageId) {
        describedByIds.push(errorMessageId);
      }
      const hintId = this.hint()?.id;
      if (hintId) {
        describedByIds.push(hintId);
      }
      return describedByIds.join(' ');
    });
  }
  forceShowError(showError = true) {
    this._forceShowError$.next(showError);
  }
  createShowErrorOnControlInteraction$(focusWithin$, controlTouched$) {
    // When the focus leaves we should show the error
    const focusWithinMovedOut$ = focusWithin$.pipe(pairwise(), map(([prevFocusWithin, newFocusWithin]) => prevFocusWithin && !newFocusWithin), filter(focusMovedOut => focusMovedOut));
    // When the control becomes touched we should show the error
    const controlBecameTouched$ = controlTouched$.pipe(pairwise(), map(([prevControlTouched, newControlTouched]) => !prevControlTouched && newControlTouched), filter(controlBecameTouched => controlBecameTouched));
    return merge(focusWithinMovedOut$, controlBecameTouched$);
  }
  createControlIsUnfocusedAndTouched$(focusWithin$, controlTouched$) {
    return combineLatest([controlTouched$, focusWithin$]).pipe(map(([touched, focusWithin]) => {
      return touched && !focusWithin;
    }));
  }
  createShowErrorBasedOnMessage$(controlIsUnfocusedAndTouched$, validationMessage$, showErrorOnControlInteraction$) {
    // Show error when the control is unfocused and touched and receives a new message
    const showErrorOnMessageAdded$ = controlIsUnfocusedAndTouched$.pipe(switchMap(controlIsUnfocusedAndTouched => controlIsUnfocusedAndTouched ? validationMessage$ : EMPTY), map(validationMessage => !!validationMessage));
    // Show error when the control is touched or the focus leaves
    return merge(showErrorOnControlInteraction$, showErrorOnMessageAdded$);
  }
  createShowErrorBasedOnControl$(showErrorOnControlInteraction$, currentControl$, controlIsUnfocusedAndTouched$) {
    // Show error when the control is invalid and it's touched or the focus leaves
    const showErrorOnControlInvalid$ = combineLatest([showErrorOnControlInteraction$, currentControl$]).pipe(map(([showError, currentControl]) => showError && !!currentControl?.invalid));
    const controlStatusChange$ = currentControl$.pipe(switchMap(currentControl => currentControl?.events.pipe(filter(e => e instanceof StatusChangeEvent), startWith(new StatusChangeEvent(currentControl.status, currentControl))) ?? EMPTY));
    // Hide error when the control becomes valid
    const hideErrorOnControlValid$ = controlStatusChange$.pipe(filter(e => e.status === 'VALID'), map(() => false));
    // Show error when the control becomes invalid without user interaction
    const showErrorOnInactiveControlInvalid$ = controlIsUnfocusedAndTouched$.pipe(switchMap(controlIsUnfocusedAndTouched => controlIsUnfocusedAndTouched ? controlStatusChange$ : EMPTY), filter(event => event.status === 'INVALID'), map(() => true));
    return merge(showErrorOnControlInvalid$, hideErrorOnControlValid$, showErrorOnInactiveControlInvalid$);
  }
  createIsControlInvalidVisible$(showErrorBasedOnControl$, showErrorBasedOnMessage$, forceShowError$, validationStateSource$, validationMessage$) {
    const showErrorBasedOnSource$ = validationStateSource$.pipe(switchMap(validationStateSource => validationStateSource === 'control' ? showErrorBasedOnControl$ : showErrorBasedOnMessage$));
    const showError$ = merge(showErrorBasedOnSource$, forceShowError$);
    return validationMessage$.pipe(switchMap(validationMessage => {
      if (!validationMessage) {
        return of(false);
      }
      return showError$;
    }));
  }
  static {
    this.ɵfac = function FormFieldComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormFieldComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FormFieldComponent,
      selectors: [["neo-form-field"]],
      contentQueries: function FormFieldComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.hint, FormFieldHintDirective, 5);
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.validationMessage, FormFieldValidationMessageDirective, 5);
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.ngControls, NgControl, 5);
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.childFocusableControl, FormFieldFocusableControlDirective, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance(4);
        }
      },
      hostVars: 4,
      hostBindings: function FormFieldComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("form-field", true)("form-field--disabled", ctx.currentControl == null ? null : ctx.currentControl.disabled);
        }
      },
      inputs: {
        control: [1, "control"],
        validationStateSource: [1, "validationStateSource"]
      },
      features: [i0.ɵɵHostDirectivesFeature([FormFieldFocusableControlDefaultDirective])],
      ngContentSelectors: _c13,
      decls: 5,
      vars: 3,
      consts: [[1, "form-field__label"], [1, "form-field__control"], [1, "form-field__note"], [1, "form-field__hint", 3, "hidden"], [1, "form-field__error", 3, "hidden"], [1, "form-field__error"], ["viewBox", "0 0 24 24", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "form-field__validation-icon"], ["d", "M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z", "stroke-width", "2", "stroke-linecap", "round", "stroke-linejoin", "round"], [1, "form-field__validation-message"]],
      template: function FormFieldComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c12);
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵprojection(1);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(2, "div", 1);
          i0.ɵɵprojection(3, 1);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(4, FormFieldComponent_Conditional_4_Template, 3, 2, "div", 2);
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵclassProp("form-field__control--invalid-visible", ctx.isControlInvalidVisible());
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.hint() || ctx.validationMessage() ? 4 : -1);
        }
      },
      dependencies: [CommonModule],
      styles: [":root{--form-field-distance: 48px}.form-field{align-items:stretch;display:flex;flex-direction:column;gap:6px;position:relative}.form-field__control--invalid-visible{--neo-input-border-color: var(--neo-input-invalid-border-color);--neo-input-bg-color: var(--neo-input-invalid-bg-color);--neo-input-outline-color: var(--neo-input-invalid-outline-color);--neo-input-icon-color: var(--neo-input-invalid-icon-color)}.form-field__label{color:var(--gray-700);font-size:14px;font-style:normal;font-weight:500;line-height:20px}.form-field__note{position:absolute;top:calc(100% + 6px)}.form-field__hint{color:var(--gray-500);font-size:14px;font-weight:400;line-height:20px}.form-field__error{align-items:center;color:var(--alert-colors-error-800);display:flex;gap:6px}.form-field__error.hidden{display:none}.form-field__validation-icon{stroke:currentColor;height:16px;width:16px;position:relative;top:-1px}.form-field__validation-message{font-size:14px;font-weight:400;line-height:20px}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormFieldComponent, [{
    type: Component,
    args: [{
      selector: 'neo-form-field',
      imports: [CommonModule],
      encapsulation: ViewEncapsulation.None,
      host: {
        '[class.form-field]': 'true',
        '[class.form-field--disabled]': 'currentControl?.disabled'
      },
      hostDirectives: [FormFieldFocusableControlDefaultDirective],
      template: "<div class=\"form-field__label\">\n    <ng-content select=\"label\"></ng-content>\n</div>\n<div class=\"form-field__control\" [class.form-field__control--invalid-visible]=\"isControlInvalidVisible()\">\n    <ng-content></ng-content>\n</div>\n@if (hint() || validationMessage()) {\n    <div class=\"form-field__note\">\n        @if (hint()) {\n            <div class=\"form-field__hint\" [hidden]=\"isControlInvalidVisible()\">\n                <ng-content select=\"[neoFormFieldHint]\"></ng-content>\n            </div>\n        }\n        @if (validationMessage()) {\n            <div class=\"form-field__error\" [class.hidden]=\"!isControlInvalidVisible()\">\n                <svg\n                    class=\"form-field__validation-icon\"\n                    viewBox=\"0 0 24 24\"\n                    fill=\"none\"\n                    xmlns=\"http://www.w3.org/2000/svg\"\n                >\n                    <path\n                        d=\"M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z\"\n                        stroke-width=\"2\"\n                        stroke-linecap=\"round\"\n                        stroke-linejoin=\"round\"\n                    />\n                </svg>\n                <div class=\"form-field__validation-message\">\n                    <ng-content select=\"[neoValidationMessage]\"></ng-content>\n                </div>\n            </div>\n        }\n    </div>\n}\n",
      styles: [":root{--form-field-distance: 48px}.form-field{align-items:stretch;display:flex;flex-direction:column;gap:6px;position:relative}.form-field__control--invalid-visible{--neo-input-border-color: var(--neo-input-invalid-border-color);--neo-input-bg-color: var(--neo-input-invalid-bg-color);--neo-input-outline-color: var(--neo-input-invalid-outline-color);--neo-input-icon-color: var(--neo-input-invalid-icon-color)}.form-field__label{color:var(--gray-700);font-size:14px;font-style:normal;font-weight:500;line-height:20px}.form-field__note{position:absolute;top:calc(100% + 6px)}.form-field__hint{color:var(--gray-500);font-size:14px;font-weight:400;line-height:20px}.form-field__error{align-items:center;color:var(--alert-colors-error-800);display:flex;gap:6px}.form-field__error.hidden{display:none}.form-field__validation-icon{stroke:currentColor;height:16px;width:16px;position:relative;top:-1px}.form-field__validation-message{font-size:14px;font-weight:400;line-height:20px}\n"]
    }]
  }], null, null);
})();
class FormFieldNeoInputDirective {
  constructor(_el, _renderer, _formField) {
    this._el = _el;
    this._renderer = _renderer;
    this._formField = _formField;
    this._inputEl = signal(null);
    this._setAriaInvalidEffect = effect(() => {
      const inputEl = this._inputEl();
      if (!inputEl) {
        return;
      }
      this._renderer.setAttribute(inputEl, 'aria-invalid', (!!this._formField?.isControlInvalidVisible()).toString());
    });
    this._setAriaDescribedByEffect = effect(() => {
      const inputEl = this._inputEl();
      if (!inputEl) {
        return;
      }
      const describedByIds = this._formField?.describedByIds();
      if (describedByIds) {
        this._renderer.setAttribute(inputEl, 'aria-describedBy', describedByIds);
      } else {
        this._renderer.removeAttribute(inputEl, 'aria-describedBy');
      }
    });
  }
  ngAfterViewInit() {
    const nativeElement = this._el.nativeElement;
    const inputEl = nativeElement instanceof HTMLInputElement || nativeElement instanceof HTMLTextAreaElement ? nativeElement : nativeElement.querySelector('input, textarea');
    this._inputEl.set(inputEl);
  }
  static {
    this.ɵfac = function FormFieldNeoInputDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormFieldNeoInputDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(FormFieldComponent, 8));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FormFieldNeoInputDirective,
      selectors: [["neo-input"], ["", "neoInput", ""]],
      features: [i0.ɵɵHostDirectivesFeature([FormFieldFocusableControlDefaultDirective])]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormFieldNeoInputDirective, [{
    type: Directive,
    args: [{
      selector: 'neo-input, [neoInput]',
      hostDirectives: [FormFieldFocusableControlDefaultDirective]
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i0.Renderer2
  }, {
    type: FormFieldComponent,
    decorators: [{
      type: Optional
    }]
  }], null);
})();
class FormFieldTouchablesService {
  constructor() {
    this.touchables = new Set();
  }
  static {
    this.ɵfac = function FormFieldTouchablesService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormFieldTouchablesService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FormFieldTouchablesService,
      factory: FormFieldTouchablesService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormFieldTouchablesService, [{
    type: Injectable
  }], null, null);
})();
const registerTouchableEffect = touchable => {
  const touchablesService = inject(FormFieldTouchablesService);
  return effect(onCleanup => {
    touchablesService.touchables.add(touchable);
    onCleanup(() => touchablesService.touchables.delete(touchable));
  });
};

// eslint-disable-next-line @angular-eslint/directive-selector
class AppFormDirective {
  constructor(_el, _formFieldTouchablesService, _ngForm, _formGroupDirective) {
    this._el = _el;
    this._formFieldTouchablesService = _formFieldTouchablesService;
    this._ngForm = _ngForm;
    this._formGroupDirective = _formGroupDirective;
    this.appSubmit = new EventEmitter();
    const formDirective = this._formGroupDirective ?? this._ngForm;
    if (!formDirective) {
      if (isDevMode()) {
        console.error('No Angular form directive is present on this form. Import FormsModule or ReactiveFormsModule first.');
      }
      return;
    }
    formDirective.ngSubmit.pipe(takeUntilDestroyed()).subscribe(v => {
      if (formDirective.form.invalid) {
        this._formFieldTouchablesService.touchables.forEach(touchable => {
          touchable.touch();
        });
        formDirective.form.markAllAsTouched();
        setTimeout(() => this._el.nativeElement.querySelector('[aria-invalid=true]')?.focus(), 0);
        return;
      }
      this.appSubmit.emit(v);
    });
  }
  static {
    this.ɵfac = function AppFormDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AppFormDirective)(i0.ɵɵdirectiveInject(i0.ElementRef, 2), i0.ɵɵdirectiveInject(FormFieldTouchablesService, 2), i0.ɵɵdirectiveInject(i2.NgForm, 10), i0.ɵɵdirectiveInject(i2.FormGroupDirective, 10));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: AppFormDirective,
      selectors: [["form"]],
      outputs: {
        appSubmit: "appSubmit"
      },
      features: [i0.ɵɵProvidersFeature([FormFieldTouchablesService])]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AppFormDirective, [{
    type: Directive,
    args: [{
      selector: 'form',
      providers: [FormFieldTouchablesService]
    }]
  }], () => [{
    type: i0.ElementRef,
    decorators: [{
      type: Self
    }]
  }, {
    type: FormFieldTouchablesService,
    decorators: [{
      type: Self
    }]
  }, {
    type: i2.NgForm,
    decorators: [{
      type: Self
    }, {
      type: Optional
    }]
  }, {
    type: i2.FormGroupDirective,
    decorators: [{
      type: Self
    }, {
      type: Optional
    }]
  }], {
    appSubmit: [{
      type: Output
    }]
  });
})();
class NeoFormFieldModule {
  static {
    this.ɵfac = function NeoFormFieldModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoFormFieldModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NeoFormFieldModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [FormFieldComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoFormFieldModule, [{
    type: NgModule,
    args: [{
      imports: [FormFieldHintDirective, FormFieldValidationMessageDirective, FormFieldComponent, AppFormDirective, FormFieldNeoInputDirective, FormFieldFocusableControlDefaultDirective],
      exports: [FormFieldHintDirective, FormFieldValidationMessageDirective, FormFieldComponent, AppFormDirective, FormFieldNeoInputDirective, FormFieldFocusableControlDefaultDirective]
    }]
  }], null, null);
})();
class NeoUiModule {
  static {
    this.ɵfac = function NeoUiModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoUiModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NeoUiModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, FormsModule, ReactiveFormsModule, ClipboardModule, NeoButtonComponent, NeoCheckboxComponent, NeoIconComponent, NeoIconButtonComponent, NeoInputComponent, NeoLinkComponent, NeoMenuModule, NeoTextAreaComponent, NeoToggleComponent, NeoInputCodeComponent, NeoSelectButtonComponent, NeoSelectListboxComponent, NeoSelectComponent, NeoFormFieldModule, NeoMenuModule, NeoFormFieldModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoUiModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, FormsModule, ReactiveFormsModule, ClipboardModule, NeoButtonComponent, NeoButton, NeoCheckboxComponent, NeoIconComponent, NeoIconButtonComponent, NeoInputComponent, NeoLinkComponent, NeoMenuModule, NeoModalComponent, NeoTextAreaComponent, NeoToggleComponent, NeoInputCodeComponent, NeoOtpDirective, NeoRecoveryCodeDirective, NeoAutofillDirective, NeoRadioButtonComponent, NeoRadioGroupComponent, NeoLoaderComponent, NeoBadgeComponent, NEO_SELECT_DIRECTIVES, NeoLogoComponent, NeoFormFieldModule],
      exports: [NeoButtonComponent, NeoButton, NeoCheckboxComponent, NeoIconComponent, NeoIconButtonComponent, NeoInputComponent, NeoLinkComponent, NeoMenuModule, NeoModalComponent, NeoTextAreaComponent, NeoToggleComponent, NeoInputCodeComponent, NeoOtpDirective, NeoRecoveryCodeDirective, NeoAutofillDirective, NeoRadioButtonComponent, NeoRadioGroupComponent, NeoLoaderComponent, NeoBadgeComponent, NEO_SELECT_DIRECTIVES, NeoLogoComponent, NeoFormFieldModule]
    }]
  }], null, null);
})();

// eslint-disable-next-line @angular-eslint/component-class-suffix
class NeoInputDirective {
  constructor(el) {
    this.el = el;
  }
  static {
    this.ɵfac = function NeoInputDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NeoInputDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NeoInputDirective,
      selectors: [["", "neoInput", ""]],
      attrs: _c14,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function NeoInputDirective_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{border:1px solid var(--neo-input-border-color);border-radius:12px;display:flex;align-items:center;background-color:unset;width:100%;padding:11px 12px;font-size:16px;font-family:Roobert,sans-serif;font-style:normal;font-weight:400;line-height:24px;box-shadow:0 0 0 50px var(--neo-input-bg-color) inset}[_nghost-%COMP%]::placeholder{color:var(--neo-input-placeholder-color)}[_nghost-%COMP%]:focus-visible{outline:3px solid var(--neo-input-outline-color);outline-offset:1px;border-color:var(--neo-input-border-focused)}[_nghost-%COMP%]:-webkit-autofill, [_nghost-%COMP%]:-webkit-autofill:focus{transition:background-color 600000s 0s,color 600000s 0s}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NeoInputDirective, [{
    type: Component,
    args: [{
      selector: '[neoInput]',
      template: `<ng-content></ng-content>`,
      styles: [":host{border:1px solid var(--neo-input-border-color);border-radius:12px;display:flex;align-items:center;background-color:unset;width:100%;padding:11px 12px;font-size:16px;font-family:Roobert,sans-serif;font-style:normal;font-weight:400;line-height:24px;box-shadow:0 0 0 50px var(--neo-input-bg-color) inset}:host::placeholder{color:var(--neo-input-placeholder-color)}:host:focus-visible{outline:3px solid var(--neo-input-outline-color);outline-offset:1px;border-color:var(--neo-input-border-focused)}:host:-webkit-autofill,:host:-webkit-autofill:focus{transition:background-color 600000s 0s,color 600000s 0s}\n"]
    }]
  }], () => [{
    type: i0.ElementRef
  }], null);
})();

/*
 * Public API Surface of neo-ui
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AppFormDirective, FormFieldComponent, FormFieldFocusableControlDefaultDirective, FormFieldFocusableControlDirective, FormFieldHintDirective, FormFieldNeoInputDirective, FormFieldValidationMessageDirective, NEO_SELECT_DIRECTIVES, NeoAutofillDirective, NeoBadgeComponent, NeoBasicValueAccessorDirective, NeoButton, NeoButtonComponent, NeoCheckboxComponent, NeoFormFieldModule, NeoIconButtonComponent, NeoIconComponent, NeoInputCodeComponent, NeoInputComponent, NeoInputDirective, NeoLinkComponent, NeoLoaderComponent, NeoLogoComponent, NeoMenuButtonComponent, NeoMenuComponent, NeoMenuModule, NeoMenuSeparatorComponent, NeoModalComponent, NeoOtpDirective, NeoRadioButtonComponent, NeoRadioGroupComponent, NeoRecoveryCodeDirective, NeoSelectButtonComponent, NeoSelectButtonDirective, NeoSelectComponent, NeoSelectItemDirective, NeoSelectListboxAnimationDirective, NeoSelectListboxComponent, NeoSelectListboxDirective, NeoSelectListboxItemDirective, NeoSelectModule, NeoTextAreaComponent, NeoToggleComponent, NeoUiComponent, NeoUiModule, NeoUiService, NeoWithMenuDirective };
